//
// THIS FILE IS GENERATED DO NOT EDIT!
// DO NOT MODIFY BY HAND!
// @eapcj THANKS YOU!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  citext: any;
  date: any;
  float8: any;
  numeric: any;
  timestamp: any;
  timestamptz: string;
  timetz: any;
  uuid: string;
}


export interface StudentBbbJoinLink {
  id: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface StudentBooleanComparisonExp {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface StudentIntComparisonExp {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
}

export interface StudentMessageResponse {
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface StudentSession {
  directus_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_expires_in?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface StudentStringComparisonExp {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
}

export interface StudentUserData {
  assignments?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  birthday_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  chat?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  first_name: EntireFieldWrapper<Scalars['String']>;
  grading?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  is_verified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  live_class?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  mobile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street_address?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** columns and relationships of "assignment_attendee_type" */
export interface StudentAssignmentAttendeeType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentAssignmentsAggregate>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  value: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface StudentAssignmentAttendeeTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface StudentAssignmentAttendeeTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_attendee_type". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentAttendeeTypeBoolExp {
  _and?: Maybe<Array<StudentAssignmentAttendeeTypeBoolExp>>;
  _not?: Maybe<StudentAssignmentAttendeeTypeBoolExp>;
  _or?: Maybe<Array<StudentAssignmentAttendeeTypeBoolExp>>;
  assignments?: Maybe<StudentAssignmentsBoolExp>;
  comment?: Maybe<StudentStringComparisonExp>;
  value?: Maybe<StudentStringComparisonExp>;
}

export const enum StudentAssignmentAttendeeTypeEnum {
  CLASS = 'CLASS',
  USER = 'USER'
};

/** Boolean expression to compare columns of type "assignment_attendee_type_enum". All fields are combined with logical 'AND'. */
export interface StudentAssignmentAttendeeTypeEnumComparisonExp {
  _eq?: Maybe<StudentAssignmentAttendeeTypeEnum>;
  _in?: Maybe<Array<StudentAssignmentAttendeeTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentAssignmentAttendeeTypeEnum>;
  _nin?: Maybe<Array<StudentAssignmentAttendeeTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_attendee_type". */
export interface StudentAssignmentAttendeeTypeOrderBy {
  assignments_aggregate?: Maybe<StudentAssignmentsAggregateOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_attendee_type" */
export const enum StudentAssignmentAttendeeTypeSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "assignment_book_chapter" */
export interface StudentAssignmentBookChapter {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<StudentBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_book_chapter" */
export interface StudentAssignmentBookChapterAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentBookChapterMaxOrderBy>;
  min?: Maybe<StudentAssignmentBookChapterMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_book_chapter". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentBookChapterBoolExp {
  _and?: Maybe<Array<StudentAssignmentBookChapterBoolExp>>;
  _not?: Maybe<StudentAssignmentBookChapterBoolExp>;
  _or?: Maybe<Array<StudentAssignmentBookChapterBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  book_chapter?: Maybe<StudentBookChaptersBoolExp>;
  book_chapter_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_book_chapter" */
export interface StudentAssignmentBookChapterMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  book_chapter_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_book_chapter" */
export interface StudentAssignmentBookChapterMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  book_chapter_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "assignment_book_chapter". */
export interface StudentAssignmentBookChapterOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  book_chapter?: Maybe<StudentBookChaptersOrderBy>;
  book_chapter_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_book_chapter" */
export const enum StudentAssignmentBookChapterSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_discussion" */
export interface StudentAssignmentDiscussion {
  /** An array relationship */
  assignment_discussion_contents: EntireFieldWrapper<Array<StudentAssignmentDiscussionContent>>;
  /** An array relationship */
  assignment_discussion_subscriptions: EntireFieldWrapper<Array<StudentAssignmentDiscussionSubscription>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion" */
export interface StudentAssignmentDiscussionAssignmentDiscussionContentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
}


/** columns and relationships of "assignment_discussion" */
export interface StudentAssignmentDiscussionAssignmentDiscussionSubscriptionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionSubscriptionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion" */
export interface StudentAssignmentDiscussionAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentDiscussionMaxOrderBy>;
  min?: Maybe<StudentAssignmentDiscussionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion" */
export interface StudentAssignmentDiscussionArrRelInsertInput {
  data: Array<StudentAssignmentDiscussionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAssignmentDiscussionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentDiscussionBoolExp {
  _and?: Maybe<Array<StudentAssignmentDiscussionBoolExp>>;
  _not?: Maybe<StudentAssignmentDiscussionBoolExp>;
  _or?: Maybe<Array<StudentAssignmentDiscussionBoolExp>>;
  assignment_discussion_contents?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
  assignment_discussion_subscriptions?: Maybe<StudentAssignmentDiscussionSubscriptionBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion" */
export const enum StudentAssignmentDiscussionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_PKEY = 'assignment_discussion_pkey'
};

/** columns and relationships of "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContent {
  /** An object relationship */
  assignment_discussion: EntireFieldWrapper<StudentAssignmentDiscussion>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  replay_to?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContent>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentStudents>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<StudentTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentDiscussionContentMaxOrderBy>;
  min?: Maybe<StudentAssignmentDiscussionContentMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentArrRelInsertInput {
  data: Array<StudentAssignmentDiscussionContentInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAssignmentDiscussionContentOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_content". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentDiscussionContentBoolExp {
  _and?: Maybe<Array<StudentAssignmentDiscussionContentBoolExp>>;
  _not?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
  _or?: Maybe<Array<StudentAssignmentDiscussionContentBoolExp>>;
  assignment_discussion?: Maybe<StudentAssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<StudentUuidComparisonExp>;
  content?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  parent_id?: Maybe<StudentUuidComparisonExp>;
  replay_to?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  teacher?: Maybe<StudentTeachersBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_content" */
export const enum StudentAssignmentDiscussionContentConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_CONTENT_PKEY = 'assignment_discussion_content_pkey'
};

/** input type for inserting data into table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentInsertInput {
  assignment_discussion?: Maybe<StudentAssignmentDiscussionObjRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  replay_to?: Maybe<StudentAssignmentDiscussionContentObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentMaxOrderBy {
  assignment_discussion_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  parent_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentMinOrderBy {
  assignment_discussion_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  parent_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentDiscussionContent>>;
}

/** input type for inserting object relation for remote table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentObjRelInsertInput {
  data: StudentAssignmentDiscussionContentInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAssignmentDiscussionContentOnConflict>;
}

/** on conflict condition type for table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentOnConflict {
  constraint: StudentAssignmentDiscussionContentConstraint;
  update_columns?: Array<StudentAssignmentDiscussionContentUpdateColumn>;
  where?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_content". */
export interface StudentAssignmentDiscussionContentOrderBy {
  assignment_discussion?: Maybe<StudentAssignmentDiscussionOrderBy>;
  assignment_discussion_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  parent_id?: Maybe<StudentOrderBy>;
  replay_to?: Maybe<StudentAssignmentDiscussionContentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  teacher?: Maybe<StudentTeachersOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: assignment_discussion_content */
export interface StudentAssignmentDiscussionContentPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_content" */
export const enum StudentAssignmentDiscussionContentSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_content" */
export interface StudentAssignmentDiscussionContentSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_content" */
export const enum StudentAssignmentDiscussionContentUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for inserting data into table "assignment_discussion" */
export interface StudentAssignmentDiscussionInsertInput {
  assignment_discussion_contents?: Maybe<StudentAssignmentDiscussionContentArrRelInsertInput>;
  assignment_discussion_subscriptions?: Maybe<StudentAssignmentDiscussionSubscriptionArrRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion" */
export interface StudentAssignmentDiscussionMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_discussion" */
export interface StudentAssignmentDiscussionMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_discussion" */
export interface StudentAssignmentDiscussionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentDiscussion>>;
}

/** input type for inserting object relation for remote table "assignment_discussion" */
export interface StudentAssignmentDiscussionObjRelInsertInput {
  data: StudentAssignmentDiscussionInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAssignmentDiscussionOnConflict>;
}

/** on conflict condition type for table "assignment_discussion" */
export interface StudentAssignmentDiscussionOnConflict {
  constraint: StudentAssignmentDiscussionConstraint;
  update_columns?: Array<StudentAssignmentDiscussionUpdateColumn>;
  where?: Maybe<StudentAssignmentDiscussionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion". */
export interface StudentAssignmentDiscussionOrderBy {
  assignment_discussion_contents_aggregate?: Maybe<StudentAssignmentDiscussionContentAggregateOrderBy>;
  assignment_discussion_subscriptions_aggregate?: Maybe<StudentAssignmentDiscussionSubscriptionAggregateOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: assignment_discussion */
export interface StudentAssignmentDiscussionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion" */
export const enum StudentAssignmentDiscussionSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion" */
export interface StudentAssignmentDiscussionSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscription {
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<StudentAssignmentDiscussion>>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_notification_enabled: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentDiscussionSubscriptionMaxOrderBy>;
  min?: Maybe<StudentAssignmentDiscussionSubscriptionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionArrRelInsertInput {
  data: Array<StudentAssignmentDiscussionSubscriptionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAssignmentDiscussionSubscriptionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_subscription". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentDiscussionSubscriptionBoolExp {
  _and?: Maybe<Array<StudentAssignmentDiscussionSubscriptionBoolExp>>;
  _not?: Maybe<StudentAssignmentDiscussionSubscriptionBoolExp>;
  _or?: Maybe<Array<StudentAssignmentDiscussionSubscriptionBoolExp>>;
  assignment_discussion?: Maybe<StudentAssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_notification_enabled?: Maybe<StudentBooleanComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_subscription" */
export const enum StudentAssignmentDiscussionSubscriptionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_SUBSCRIPTION_PKEY = 'assignment_discussion_subscription_pkey'
};

/** input type for inserting data into table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionInsertInput {
  assignment_discussion?: Maybe<StudentAssignmentDiscussionArrRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionMaxOrderBy {
  assignment_discussion_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionMinOrderBy {
  assignment_discussion_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentDiscussionSubscription>>;
}

/** on conflict condition type for table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionOnConflict {
  constraint: StudentAssignmentDiscussionSubscriptionConstraint;
  update_columns?: Array<StudentAssignmentDiscussionSubscriptionUpdateColumn>;
  where?: Maybe<StudentAssignmentDiscussionSubscriptionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_subscription". */
export interface StudentAssignmentDiscussionSubscriptionOrderBy {
  assignment_discussion_aggregate?: Maybe<StudentAssignmentDiscussionAggregateOrderBy>;
  assignment_discussion_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_notification_enabled?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: assignment_discussion_subscription */
export interface StudentAssignmentDiscussionSubscriptionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_subscription" */
export const enum StudentAssignmentDiscussionSubscriptionSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_subscription" */
export interface StudentAssignmentDiscussionSubscriptionSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_subscription" */
export const enum StudentAssignmentDiscussionSubscriptionUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** update columns of table "assignment_discussion" */
export const enum StudentAssignmentDiscussionUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_files" */
export interface StudentAssignmentFiles {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_files" */
export interface StudentAssignmentFilesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentFilesMaxOrderBy>;
  min?: Maybe<StudentAssignmentFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_files". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentFilesBoolExp {
  _and?: Maybe<Array<StudentAssignmentFilesBoolExp>>;
  _not?: Maybe<StudentAssignmentFilesBoolExp>;
  _or?: Maybe<Array<StudentAssignmentFilesBoolExp>>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  hash?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  path?: Maybe<StudentStringComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** input type for inserting data into table "assignment_files" */
export interface StudentAssignmentFilesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_files" */
export interface StudentAssignmentFilesMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  hash?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_files" */
export interface StudentAssignmentFilesMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  hash?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_files" */
export interface StudentAssignmentFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentFiles>>;
}

/** Ordering options when selecting data from "assignment_files". */
export interface StudentAssignmentFilesOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  hash?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_files" */
export const enum StudentAssignmentFilesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Possible values for assisgment grade weights.
 *
 *
 * columns and relationships of "assignment_grade_weights"
 */
export interface StudentAssignmentGradeWeights {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  value: EntireFieldWrapper<Scalars['numeric']>;
}

/** aggregated selection of "assignment_grade_weights" */
export interface StudentAssignmentGradeWeightsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAssignmentGradeWeights>>;
}

/** aggregate fields of "assignment_grade_weights" */
export interface StudentAssignmentGradeWeightsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeightsVarianceFields>>;
}


/** aggregate fields of "assignment_grade_weights" */
export interface StudentAssignmentGradeWeightsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAssignmentGradeWeightsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface StudentAssignmentGradeWeightsAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "assignment_grade_weights". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentGradeWeightsBoolExp {
  _and?: Maybe<Array<StudentAssignmentGradeWeightsBoolExp>>;
  _not?: Maybe<StudentAssignmentGradeWeightsBoolExp>;
  _or?: Maybe<Array<StudentAssignmentGradeWeightsBoolExp>>;
  comment?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  value?: Maybe<StudentNumericComparisonExp>;
}

/** aggregate max on columns */
export interface StudentAssignmentGradeWeightsMaxFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate min on columns */
export interface StudentAssignmentGradeWeightsMinFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** Ordering options when selecting data from "assignment_grade_weights". */
export interface StudentAssignmentGradeWeightsOrderBy {
  comment?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_grade_weights" */
export const enum StudentAssignmentGradeWeightsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  ID = 'id',
  /** column name */
  VALUE = 'value'
};

/** aggregate stddev on columns */
export interface StudentAssignmentGradeWeightsStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface StudentAssignmentGradeWeightsStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface StudentAssignmentGradeWeightsStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface StudentAssignmentGradeWeightsSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate var_pop on columns */
export interface StudentAssignmentGradeWeightsVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface StudentAssignmentGradeWeightsVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface StudentAssignmentGradeWeightsVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** columns and relationships of "assignment_notes" */
export interface StudentAssignmentNotes {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentAssignments>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentStudents>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<StudentTeachers>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "assignment_notes". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentNotesBoolExp {
  _and?: Maybe<Array<StudentAssignmentNotesBoolExp>>;
  _not?: Maybe<StudentAssignmentNotesBoolExp>;
  _or?: Maybe<Array<StudentAssignmentNotesBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  content?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  teacher?: Maybe<StudentTeachersBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_notes" */
export const enum StudentAssignmentNotesConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_NOTES_PKEY = 'assignment_notes_pkey'
};

/** input type for inserting data into table "assignment_notes" */
export interface StudentAssignmentNotesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "assignment_notes" */
export interface StudentAssignmentNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentNotes>>;
}

/** on conflict condition type for table "assignment_notes" */
export interface StudentAssignmentNotesOnConflict {
  constraint: StudentAssignmentNotesConstraint;
  update_columns?: Array<StudentAssignmentNotesUpdateColumn>;
  where?: Maybe<StudentAssignmentNotesBoolExp>;
}

/** Ordering options when selecting data from "assignment_notes". */
export interface StudentAssignmentNotesOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  teacher?: Maybe<StudentTeachersOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: assignment_notes */
export interface StudentAssignmentNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_notes" */
export const enum StudentAssignmentNotesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_notes" */
export interface StudentAssignmentNotesSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_notes" */
export const enum StudentAssignmentNotesUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswers {
  assignment_question_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersAggregateOrderBy {
  avg?: Maybe<StudentAssignmentQuestionAnswersAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentQuestionAnswersMaxOrderBy>;
  min?: Maybe<StudentAssignmentQuestionAnswersMinOrderBy>;
  stddev?: Maybe<StudentAssignmentQuestionAnswersStddevOrderBy>;
  stddev_pop?: Maybe<StudentAssignmentQuestionAnswersStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentAssignmentQuestionAnswersStddevSampOrderBy>;
  sum?: Maybe<StudentAssignmentQuestionAnswersSumOrderBy>;
  var_pop?: Maybe<StudentAssignmentQuestionAnswersVarPopOrderBy>;
  var_samp?: Maybe<StudentAssignmentQuestionAnswersVarSampOrderBy>;
  variance?: Maybe<StudentAssignmentQuestionAnswersVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersAvgOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_answers". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentQuestionAnswersBoolExp {
  _and?: Maybe<Array<StudentAssignmentQuestionAnswersBoolExp>>;
  _not?: Maybe<StudentAssignmentQuestionAnswersBoolExp>;
  _or?: Maybe<Array<StudentAssignmentQuestionAnswersBoolExp>>;
  assignment_question_id?: Maybe<StudentUuidComparisonExp>;
  assignment_question_option_id?: Maybe<StudentUuidComparisonExp>;
  content?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_correct?: Maybe<StudentBooleanComparisonExp>;
  order?: Maybe<StudentIntComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** input type for inserting data into table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersInsertInput {
  assignment_question_id?: Maybe<Scalars['uuid']>;
  assignment_question_option_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersMaxOrderBy {
  assignment_question_id?: Maybe<StudentOrderBy>;
  assignment_question_option_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersMinOrderBy {
  assignment_question_id?: Maybe<StudentOrderBy>;
  assignment_question_option_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentQuestionAnswers>>;
}

/** Ordering options when selecting data from "assignment_question_answers". */
export interface StudentAssignmentQuestionAnswersOrderBy {
  assignment_question_id?: Maybe<StudentOrderBy>;
  assignment_question_option_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_correct?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_question_answers" */
export const enum StudentAssignmentQuestionAnswersSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_ID = 'assignment_question_option_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  USER_ID = 'user_id'
};

/** order by stddev() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersStddevOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersStddevPopOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersStddevSampOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersSumOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersVarPopOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersVarSampOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "assignment_question_answers" */
export interface StudentAssignmentQuestionAnswersVarianceOrderBy {
  order?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "assignment_question_option_relations" */
export interface StudentAssignmentQuestionOptionRelations {
  /** An object relationship */
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionOptions>>;
  /** An object relationship */
  assignment_question_option?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionOptions>>;
  assignment_question_option_matched_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_matching_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_question_option_relations" */
export interface StudentAssignmentQuestionOptionRelationsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentQuestionOptionRelationsMaxOrderBy>;
  min?: Maybe<StudentAssignmentQuestionOptionRelationsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_option_relations". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentQuestionOptionRelationsBoolExp {
  _and?: Maybe<Array<StudentAssignmentQuestionOptionRelationsBoolExp>>;
  _not?: Maybe<StudentAssignmentQuestionOptionRelationsBoolExp>;
  _or?: Maybe<Array<StudentAssignmentQuestionOptionRelationsBoolExp>>;
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
  assignment_question_option?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
  assignment_question_option_matched_id?: Maybe<StudentUuidComparisonExp>;
  assignment_question_option_matching_id?: Maybe<StudentUuidComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_question_option_relations" */
export interface StudentAssignmentQuestionOptionRelationsMaxOrderBy {
  assignment_question_option_matched_id?: Maybe<StudentOrderBy>;
  assignment_question_option_matching_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_question_option_relations" */
export interface StudentAssignmentQuestionOptionRelationsMinOrderBy {
  assignment_question_option_matched_id?: Maybe<StudentOrderBy>;
  assignment_question_option_matching_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "assignment_question_option_relations". */
export interface StudentAssignmentQuestionOptionRelationsOrderBy {
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<StudentAssignmentQuestionOptionsOrderBy>;
  assignment_question_option?: Maybe<StudentAssignmentQuestionOptionsOrderBy>;
  assignment_question_option_matched_id?: Maybe<StudentOrderBy>;
  assignment_question_option_matching_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_question_option_relations" */
export const enum StudentAssignmentQuestionOptionRelationsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHED_ID = 'assignment_question_option_matched_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHING_ID = 'assignment_question_option_matching_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "assignment_question_options" */
export interface StudentAssignmentQuestionOptions {
  /** An object relationship */
  assignment_question: EntireFieldWrapper<StudentAssignmentQuestions>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<StudentAssignmentQuestionAnswers>>;
  assignment_question_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<StudentAssignmentQuestionOptionRelations>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  group?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  score?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}


/** columns and relationships of "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionAnswersBoolExp>;
}


/** columns and relationships of "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionOptionRelationsBoolExp>;
}

/** order by aggregate values of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsAggregateOrderBy {
  avg?: Maybe<StudentAssignmentQuestionOptionsAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentQuestionOptionsMaxOrderBy>;
  min?: Maybe<StudentAssignmentQuestionOptionsMinOrderBy>;
  stddev?: Maybe<StudentAssignmentQuestionOptionsStddevOrderBy>;
  stddev_pop?: Maybe<StudentAssignmentQuestionOptionsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentAssignmentQuestionOptionsStddevSampOrderBy>;
  sum?: Maybe<StudentAssignmentQuestionOptionsSumOrderBy>;
  var_pop?: Maybe<StudentAssignmentQuestionOptionsVarPopOrderBy>;
  var_samp?: Maybe<StudentAssignmentQuestionOptionsVarSampOrderBy>;
  variance?: Maybe<StudentAssignmentQuestionOptionsVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsAvgOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_options". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentQuestionOptionsBoolExp {
  _and?: Maybe<Array<StudentAssignmentQuestionOptionsBoolExp>>;
  _not?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
  _or?: Maybe<Array<StudentAssignmentQuestionOptionsBoolExp>>;
  assignment_question?: Maybe<StudentAssignmentQuestionsBoolExp>;
  assignment_question_answers?: Maybe<StudentAssignmentQuestionAnswersBoolExp>;
  assignment_question_id?: Maybe<StudentUuidComparisonExp>;
  assignment_question_option_relations?: Maybe<StudentAssignmentQuestionOptionRelationsBoolExp>;
  comment?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  group?: Maybe<StudentIntComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_correct?: Maybe<StudentBooleanComparisonExp>;
  order?: Maybe<StudentIntComparisonExp>;
  score?: Maybe<StudentIntComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsMaxOrderBy {
  assignment_question_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  group?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsMinOrderBy {
  assignment_question_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  group?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "assignment_question_options". */
export interface StudentAssignmentQuestionOptionsOrderBy {
  assignment_question?: Maybe<StudentAssignmentQuestionsOrderBy>;
  assignment_question_answers_aggregate?: Maybe<StudentAssignmentQuestionAnswersAggregateOrderBy>;
  assignment_question_id?: Maybe<StudentOrderBy>;
  assignment_question_option_relations_aggregate?: Maybe<StudentAssignmentQuestionOptionRelationsAggregateOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  group?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_correct?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_question_options" */
export const enum StudentAssignmentQuestionOptionsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  SCORE = 'score',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsStddevOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsStddevPopOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsStddevSampOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsSumOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsVarPopOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsVarSampOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "assignment_question_options" */
export interface StudentAssignmentQuestionOptionsVarianceOrderBy {
  group?: Maybe<StudentOrderBy>;
  order?: Maybe<StudentOrderBy>;
  score?: Maybe<StudentOrderBy>;
}

export const enum StudentAssignmentQuestionTypesEnum {
  /** quiz.fill_in_black */
  FILL_IN_BLANK = 'FILL_IN_BLANK',
  /** quiz.matching */
  MATCHING = 'MATCHING',
  /** quiz.open_question */
  OPEN_QUESTION = 'OPEN_QUESTION',
  /** quiz.pick_options */
  PICK_OPTIONS = 'PICK_OPTIONS'
};

/** Boolean expression to compare columns of type "assignment_question_types_enum". All fields are combined with logical 'AND'. */
export interface StudentAssignmentQuestionTypesEnumComparisonExp {
  _eq?: Maybe<StudentAssignmentQuestionTypesEnum>;
  _in?: Maybe<Array<StudentAssignmentQuestionTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentAssignmentQuestionTypesEnum>;
  _nin?: Maybe<Array<StudentAssignmentQuestionTypesEnum>>;
}

/** columns and relationships of "assignment_questions" */
export interface StudentAssignmentQuestions {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<StudentAssignmentQuestionOptions>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentAssignmentQuestionTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "assignment_questions" */
export interface StudentAssignmentQuestionsAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
}

/** order by aggregate values of table "assignment_questions" */
export interface StudentAssignmentQuestionsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentQuestionsMaxOrderBy>;
  min?: Maybe<StudentAssignmentQuestionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_questions". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentQuestionsBoolExp {
  _and?: Maybe<Array<StudentAssignmentQuestionsBoolExp>>;
  _not?: Maybe<StudentAssignmentQuestionsBoolExp>;
  _or?: Maybe<Array<StudentAssignmentQuestionsBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  assignment_question_options?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
  content?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  type?: Maybe<StudentAssignmentQuestionTypesEnumComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_questions" */
export interface StudentAssignmentQuestionsMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_questions" */
export interface StudentAssignmentQuestionsMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "assignment_questions". */
export interface StudentAssignmentQuestionsOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  assignment_question_options_aggregate?: Maybe<StudentAssignmentQuestionOptionsAggregateOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_questions" */
export const enum StudentAssignmentQuestionsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_quiz" */
export interface StudentAssignmentQuiz {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  attempts?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  pass_percentage: EntireFieldWrapper<Scalars['Int']>;
  time_control: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_quiz" */
export interface StudentAssignmentQuizAggregateOrderBy {
  avg?: Maybe<StudentAssignmentQuizAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentQuizMaxOrderBy>;
  min?: Maybe<StudentAssignmentQuizMinOrderBy>;
  stddev?: Maybe<StudentAssignmentQuizStddevOrderBy>;
  stddev_pop?: Maybe<StudentAssignmentQuizStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentAssignmentQuizStddevSampOrderBy>;
  sum?: Maybe<StudentAssignmentQuizSumOrderBy>;
  var_pop?: Maybe<StudentAssignmentQuizVarPopOrderBy>;
  var_samp?: Maybe<StudentAssignmentQuizVarSampOrderBy>;
  variance?: Maybe<StudentAssignmentQuizVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizAvgOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_quiz". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentQuizBoolExp {
  _and?: Maybe<Array<StudentAssignmentQuizBoolExp>>;
  _not?: Maybe<StudentAssignmentQuizBoolExp>;
  _or?: Maybe<Array<StudentAssignmentQuizBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  attempts?: Maybe<StudentIntComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  pass_percentage?: Maybe<StudentIntComparisonExp>;
  time_control?: Maybe<StudentBooleanComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  attempts?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  attempts?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "assignment_quiz". */
export interface StudentAssignmentQuizOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  attempts?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
  time_control?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_quiz" */
export const enum StudentAssignmentQuizSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  ATTEMPTS = 'attempts',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PASS_PERCENTAGE = 'pass_percentage',
  /** column name */
  TIME_CONTROL = 'time_control',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizStddevOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizStddevPopOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizStddevSampOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizSumOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** order by var_pop() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizVarPopOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizVarSampOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "assignment_quiz" */
export interface StudentAssignmentQuizVarianceOrderBy {
  attempts?: Maybe<StudentOrderBy>;
  pass_percentage?: Maybe<StudentOrderBy>;
}

/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface StudentAssignmentSubmits {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  completed_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamp']>;
  file?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_submited: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface StudentAssignmentSubmitsFilesArgs {
  distinct_on?: Maybe<Array<StudentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentFilesOrderBy>>;
  where?: Maybe<StudentFilesBoolExp>;
}

/** order by aggregate values of table "assignment_submits" */
export interface StudentAssignmentSubmitsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentSubmitsMaxOrderBy>;
  min?: Maybe<StudentAssignmentSubmitsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_submits". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentSubmitsBoolExp {
  _and?: Maybe<Array<StudentAssignmentSubmitsBoolExp>>;
  _not?: Maybe<StudentAssignmentSubmitsBoolExp>;
  _or?: Maybe<Array<StudentAssignmentSubmitsBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  completed_at?: Maybe<StudentTimestamptzComparisonExp>;
  content?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestampComparisonExp>;
  file?: Maybe<StudentStringComparisonExp>;
  files?: Maybe<StudentFilesBoolExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_submited?: Maybe<StudentBooleanComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_submits" */
export const enum StudentAssignmentSubmitsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_SUBMITS_ASSIGNMENT_ID_USER_ID_KEY = 'assignment_submits_assignment_id_user_id_key',
  /** unique or primary key constraint */
  ASSIGNMENT_USER_PKEY = 'assignment_user_pkey'
};

/** input type for inserting data into table "assignment_submits" */
export interface StudentAssignmentSubmitsInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_submits" */
export interface StudentAssignmentSubmitsMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  completed_at?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  file?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_submits" */
export interface StudentAssignmentSubmitsMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  completed_at?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  file?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_submits" */
export interface StudentAssignmentSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentSubmits>>;
}

/** on conflict condition type for table "assignment_submits" */
export interface StudentAssignmentSubmitsOnConflict {
  constraint: StudentAssignmentSubmitsConstraint;
  update_columns?: Array<StudentAssignmentSubmitsUpdateColumn>;
  where?: Maybe<StudentAssignmentSubmitsBoolExp>;
}

/** Ordering options when selecting data from "assignment_submits". */
export interface StudentAssignmentSubmitsOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  completed_at?: Maybe<StudentOrderBy>;
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  file?: Maybe<StudentOrderBy>;
  files_aggregate?: Maybe<StudentFilesAggregateOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_submited?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: assignment_submits */
export interface StudentAssignmentSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_submits" */
export const enum StudentAssignmentSubmitsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_submits" */
export interface StudentAssignmentSubmitsSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_submits" */
export const enum StudentAssignmentSubmitsUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_type" */
export interface StudentAssignmentType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentAssignmentsAggregate>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_type" */
export interface StudentAssignmentTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_type" */
export interface StudentAssignmentTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentTypeBoolExp {
  _and?: Maybe<Array<StudentAssignmentTypeBoolExp>>;
  _not?: Maybe<StudentAssignmentTypeBoolExp>;
  _or?: Maybe<Array<StudentAssignmentTypeBoolExp>>;
  assignments?: Maybe<StudentAssignmentsBoolExp>;
  icon?: Maybe<StudentStringComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
}

export const enum StudentAssignmentTypeEnum {
  HAUSAUFGABE = 'HAUSAUFGABE',
  KLASSENARBEIT = 'KLASSENARBEIT',
  MATERIAL = 'MATERIAL',
  ONLINE = 'ONLINE',
  PRUFUNG = 'PRUFUNG',
  QUIZ = 'QUIZ',
  STUDY = 'STUDY',
  TASK = 'TASK'
};

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export interface StudentAssignmentTypeEnumComparisonExp {
  _eq?: Maybe<StudentAssignmentTypeEnum>;
  _in?: Maybe<Array<StudentAssignmentTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentAssignmentTypeEnum>;
  _nin?: Maybe<Array<StudentAssignmentTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_type". */
export interface StudentAssignmentTypeOrderBy {
  assignments_aggregate?: Maybe<StudentAssignmentsAggregateOrderBy>;
  icon?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignment_type" */
export const enum StudentAssignmentTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/**
 * All users that assignment is assigned to and the table that teachers insert grades for each of them
 *
 *
 * columns and relationships of "assignment_user"
 */
export interface StudentAssignmentUser {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentMarks>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_user" */
export interface StudentAssignmentUserAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentUserMaxOrderBy>;
  min?: Maybe<StudentAssignmentUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_user". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentUserBoolExp {
  _and?: Maybe<Array<StudentAssignmentUserBoolExp>>;
  _not?: Maybe<StudentAssignmentUserBoolExp>;
  _or?: Maybe<Array<StudentAssignmentUserBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_completed?: Maybe<StudentBooleanComparisonExp>;
  mark?: Maybe<StudentMarksBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_user" */
export interface StudentAssignmentUserMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "assignment_user" */
export interface StudentAssignmentUserMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "assignment_user" */
export interface StudentAssignmentUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAssignmentUser>>;
}

/** Ordering options when selecting data from "assignment_user". */
export interface StudentAssignmentUserOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_completed?: Maybe<StudentOrderBy>;
  mark?: Maybe<StudentMarksOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: assignment_user */
export interface StudentAssignmentUserPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_user" */
export const enum StudentAssignmentUserSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_user" */
export interface StudentAssignmentUserSetInput {
  is_completed?: Maybe<Scalars['Boolean']>;
}

/** columns and relationships of "assignments" */
export interface StudentAssignments {
  /** An object relationship */
  assignmentAttendeeType?: EntireFieldWrapper<Maybe<StudentAssignmentAttendeeType>>;
  assignment_attendee_type?: EntireFieldWrapper<Maybe<StudentAssignmentAttendeeTypeEnum>>;
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<StudentAssignmentBookChapter>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<StudentAssignmentFiles>>;
  /** An object relationship */
  assignment_grade_weight?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeights>>;
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<StudentAssignmentQuestions>>;
  /** An object relationship */
  assignment_quiz?: EntireFieldWrapper<Maybe<StudentAssignmentQuiz>>;
  /** An array relationship */
  assignment_quizzes: EntireFieldWrapper<Array<StudentAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentAssignmentSubmits>>;
  /** An object relationship */
  assignment_type: EntireFieldWrapper<StudentAssignmentType>;
  /** An array relationship */
  assignment_users: EntireFieldWrapper<Array<StudentAssignmentUser>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<StudentChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentViewAssignmentClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** A computed field, executes function "assignment_due_at_filter" */
  due_at_filter?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentFiles>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "assignment_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_gradeable: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  lesson?: EntireFieldWrapper<Maybe<StudentLessons>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<StudentTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentAssignmentTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsAssignmentFilesArgs {
  distinct_on?: Maybe<Array<StudentAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentFilesOrderBy>>;
  where?: Maybe<StudentAssignmentFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsAssignmentQuizzesArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuizOrderBy>>;
  where?: Maybe<StudentAssignmentQuizBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentAssignmentSubmitsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsAssignmentUsersArgs {
  distinct_on?: Maybe<Array<StudentAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentUserOrderBy>>;
  where?: Maybe<StudentAssignmentUserBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsClassesArgs {
  distinct_on?: Maybe<Array<StudentViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentViewAssignmentClassBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsFilesArgs {
  distinct_on?: Maybe<Array<StudentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentFilesOrderBy>>;
  where?: Maybe<StudentFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsGradesArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentAssignmentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}

/** aggregated selection of "assignments" */
export interface StudentAssignmentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAssignmentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAssignments>>;
}

/** aggregate fields of "assignments" */
export interface StudentAssignmentsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentAssignmentsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAssignmentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAssignmentsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentAssignmentsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentAssignmentsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentAssignmentsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentAssignmentsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentAssignmentsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentAssignmentsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentAssignmentsVarianceFields>>;
}


/** aggregate fields of "assignments" */
export interface StudentAssignmentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "assignments" */
export interface StudentAssignmentsAggregateOrderBy {
  avg?: Maybe<StudentAssignmentsAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAssignmentsMaxOrderBy>;
  min?: Maybe<StudentAssignmentsMinOrderBy>;
  stddev?: Maybe<StudentAssignmentsStddevOrderBy>;
  stddev_pop?: Maybe<StudentAssignmentsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentAssignmentsStddevSampOrderBy>;
  sum?: Maybe<StudentAssignmentsSumOrderBy>;
  var_pop?: Maybe<StudentAssignmentsVarPopOrderBy>;
  var_samp?: Maybe<StudentAssignmentsVarSampOrderBy>;
  variance?: Maybe<StudentAssignmentsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentAssignmentsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "assignments" */
export interface StudentAssignmentsAvgOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export interface StudentAssignmentsBoolExp {
  _and?: Maybe<Array<StudentAssignmentsBoolExp>>;
  _not?: Maybe<StudentAssignmentsBoolExp>;
  _or?: Maybe<Array<StudentAssignmentsBoolExp>>;
  assignmentAttendeeType?: Maybe<StudentAssignmentAttendeeTypeBoolExp>;
  assignment_attendee_type?: Maybe<StudentAssignmentAttendeeTypeEnumComparisonExp>;
  assignment_book_chapters?: Maybe<StudentAssignmentBookChapterBoolExp>;
  assignment_files?: Maybe<StudentAssignmentFilesBoolExp>;
  assignment_grade_weight?: Maybe<StudentAssignmentGradeWeightsBoolExp>;
  assignment_grade_weight_id?: Maybe<StudentUuidComparisonExp>;
  assignment_questions?: Maybe<StudentAssignmentQuestionsBoolExp>;
  assignment_quiz?: Maybe<StudentAssignmentQuizBoolExp>;
  assignment_quizzes?: Maybe<StudentAssignmentQuizBoolExp>;
  assignment_submits?: Maybe<StudentAssignmentSubmitsBoolExp>;
  assignment_type?: Maybe<StudentAssignmentTypeBoolExp>;
  assignment_users?: Maybe<StudentAssignmentUserBoolExp>;
  chat?: Maybe<StudentChatsBoolExp>;
  chat_id?: Maybe<StudentUuidComparisonExp>;
  classes?: Maybe<StudentViewAssignmentClassBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  description?: Maybe<StudentStringComparisonExp>;
  due_at?: Maybe<StudentTimestamptzComparisonExp>;
  due_at_filter?: Maybe<StudentStringComparisonExp>;
  duration?: Maybe<StudentIntComparisonExp>;
  files?: Maybe<StudentFilesBoolExp>;
  grades?: Maybe<StudentGradesBoolExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_completed?: Maybe<StudentBooleanComparisonExp>;
  is_everybody?: Maybe<StudentBooleanComparisonExp>;
  is_gradeable?: Maybe<StudentBooleanComparisonExp>;
  lesson?: Maybe<StudentLessonsBoolExp>;
  lesson_id?: Maybe<StudentUuidComparisonExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  teaching_structure?: Maybe<StudentTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentUuidComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  type?: Maybe<StudentAssignmentTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentAssignmentsMaxFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "assignments" */
export interface StudentAssignmentsMaxOrderBy {
  assignment_grade_weight_id?: Maybe<StudentOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  due_at?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentAssignmentsMinFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "assignments" */
export interface StudentAssignmentsMinOrderBy {
  assignment_grade_weight_id?: Maybe<StudentOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  due_at?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "assignments". */
export interface StudentAssignmentsOrderBy {
  assignmentAttendeeType?: Maybe<StudentAssignmentAttendeeTypeOrderBy>;
  assignment_attendee_type?: Maybe<StudentOrderBy>;
  assignment_book_chapters_aggregate?: Maybe<StudentAssignmentBookChapterAggregateOrderBy>;
  assignment_files_aggregate?: Maybe<StudentAssignmentFilesAggregateOrderBy>;
  assignment_grade_weight?: Maybe<StudentAssignmentGradeWeightsOrderBy>;
  assignment_grade_weight_id?: Maybe<StudentOrderBy>;
  assignment_questions_aggregate?: Maybe<StudentAssignmentQuestionsAggregateOrderBy>;
  assignment_quiz?: Maybe<StudentAssignmentQuizOrderBy>;
  assignment_quizzes_aggregate?: Maybe<StudentAssignmentQuizAggregateOrderBy>;
  assignment_submits_aggregate?: Maybe<StudentAssignmentSubmitsAggregateOrderBy>;
  assignment_type?: Maybe<StudentAssignmentTypeOrderBy>;
  assignment_users_aggregate?: Maybe<StudentAssignmentUserAggregateOrderBy>;
  chat?: Maybe<StudentChatsOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  classes_aggregate?: Maybe<StudentViewAssignmentClassAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  due_at?: Maybe<StudentOrderBy>;
  due_at_filter?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  files_aggregate?: Maybe<StudentFilesAggregateOrderBy>;
  grades_aggregate?: Maybe<StudentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_completed?: Maybe<StudentOrderBy>;
  is_everybody?: Maybe<StudentOrderBy>;
  is_gradeable?: Maybe<StudentOrderBy>;
  lesson?: Maybe<StudentLessonsOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teaching_structure?: Maybe<StudentTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "assignments" */
export const enum StudentAssignmentsSelectColumn {
  /** column name */
  ASSIGNMENT_ATTENDEE_TYPE = 'assignment_attendee_type',
  /** column name */
  ASSIGNMENT_GRADE_WEIGHT_ID = 'assignment_grade_weight_id',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_GRADEABLE = 'is_gradeable',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate stddev on columns */
export interface StudentAssignmentsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "assignments" */
export interface StudentAssignmentsStddevOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentAssignmentsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "assignments" */
export interface StudentAssignmentsStddevPopOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentAssignmentsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "assignments" */
export interface StudentAssignmentsStddevSampOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentAssignmentsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "assignments" */
export interface StudentAssignmentsSumOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentAssignmentsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "assignments" */
export interface StudentAssignmentsVarPopOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentAssignmentsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "assignments" */
export interface StudentAssignmentsVarSampOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentAssignmentsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "assignments" */
export interface StudentAssignmentsVarianceOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "attendance_types" */
export interface StudentAttendanceTypes {
  icon: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "attendance_types". All fields are combined with a logical 'AND'. */
export interface StudentAttendanceTypesBoolExp {
  _and?: Maybe<Array<StudentAttendanceTypesBoolExp>>;
  _not?: Maybe<StudentAttendanceTypesBoolExp>;
  _or?: Maybe<Array<StudentAttendanceTypesBoolExp>>;
  icon?: Maybe<StudentStringComparisonExp>;
  text?: Maybe<StudentStringComparisonExp>;
  value?: Maybe<StudentStringComparisonExp>;
}

/** Ordering options when selecting data from "attendance_types". */
export interface StudentAttendanceTypesOrderBy {
  icon?: Maybe<StudentOrderBy>;
  text?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
}

/** select columns of table "attendance_types" */
export const enum StudentAttendanceTypesSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  TEXT = 'text',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "attendances" */
export interface StudentAttendances {
  attendance_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  class: EntireFieldWrapper<StudentTeachingStructures>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  semester: EntireFieldWrapper<StudentTeachingStructures>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  student?: EntireFieldWrapper<Maybe<StudentUsers>>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentTeachingStructures>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  teacher?: EntireFieldWrapper<Maybe<StudentUsers>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  type?: EntireFieldWrapper<Maybe<StudentAttendanceTypes>>;
}

/** Boolean expression to filter rows from the table "attendances". All fields are combined with a logical 'AND'. */
export interface StudentAttendancesBoolExp {
  _and?: Maybe<Array<StudentAttendancesBoolExp>>;
  _not?: Maybe<StudentAttendancesBoolExp>;
  _or?: Maybe<Array<StudentAttendancesBoolExp>>;
  attendance_type?: Maybe<StudentStringComparisonExp>;
  class?: Maybe<StudentTeachingStructuresBoolExp>;
  class_id?: Maybe<StudentUuidComparisonExp>;
  comment?: Maybe<StudentStringComparisonExp>;
  date?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  semester?: Maybe<StudentTeachingStructuresBoolExp>;
  semester_id?: Maybe<StudentUuidComparisonExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  subject?: Maybe<StudentTeachingStructuresBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  teacher_id?: Maybe<StudentUuidComparisonExp>;
  type?: Maybe<StudentAttendanceTypesBoolExp>;
}

/** Ordering options when selecting data from "attendances". */
export interface StudentAttendancesOrderBy {
  attendance_type?: Maybe<StudentOrderBy>;
  class?: Maybe<StudentTeachingStructuresOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  date?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  semester?: Maybe<StudentTeachingStructuresOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentTeachingStructuresOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentAttendanceTypesOrderBy>;
}

/** select columns of table "attendances" */
export const enum StudentAttendancesSelectColumn {
  /** column name */
  ATTENDANCE_TYPE = 'attendance_type',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "auth.account_providers" */
export interface StudentAuthAccountProviders {
  /** An object relationship */
  account: EntireFieldWrapper<StudentAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  auth_provider: EntireFieldWrapper<Scalars['String']>;
  auth_provider_unique_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  provider: EntireFieldWrapper<StudentAuthProviders>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "auth.account_providers" */
export interface StudentAuthAccountProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAuthAccountProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAuthAccountProviders>>;
}

/** aggregate fields of "auth.account_providers" */
export interface StudentAuthAccountProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAuthAccountProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAuthAccountProvidersMinFields>>;
}


/** aggregate fields of "auth.account_providers" */
export interface StudentAuthAccountProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_providers" */
export interface StudentAuthAccountProvidersAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAuthAccountProvidersMaxOrderBy>;
  min?: Maybe<StudentAuthAccountProvidersMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_providers" */
export interface StudentAuthAccountProvidersArrRelInsertInput {
  data: Array<StudentAuthAccountProvidersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthAccountProvidersOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export interface StudentAuthAccountProvidersBoolExp {
  _and?: Maybe<Array<StudentAuthAccountProvidersBoolExp>>;
  _not?: Maybe<StudentAuthAccountProvidersBoolExp>;
  _or?: Maybe<Array<StudentAuthAccountProvidersBoolExp>>;
  account?: Maybe<StudentAuthAccountsBoolExp>;
  account_id?: Maybe<StudentUuidComparisonExp>;
  auth_provider?: Maybe<StudentStringComparisonExp>;
  auth_provider_unique_id?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  provider?: Maybe<StudentAuthProvidersBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "auth.account_providers" */
export const enum StudentAuthAccountProvidersConstraint {
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_ACCOUNT_ID_AUTH_PROVIDER_KEY = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_AUTH_PROVIDER_AUTH_PROVIDER_UNIQUE_ID_KEY = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_PKEY = 'account_providers_pkey'
};

/** input type for inserting data into table "auth.account_providers" */
export interface StudentAuthAccountProvidersInsertInput {
  account?: Maybe<StudentAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<StudentAuthProvidersObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentAuthAccountProvidersMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "auth.account_providers" */
export interface StudentAuthAccountProvidersMaxOrderBy {
  account_id?: Maybe<StudentOrderBy>;
  auth_provider?: Maybe<StudentOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentAuthAccountProvidersMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "auth.account_providers" */
export interface StudentAuthAccountProvidersMinOrderBy {
  account_id?: Maybe<StudentOrderBy>;
  auth_provider?: Maybe<StudentOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "auth.account_providers" */
export interface StudentAuthAccountProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAuthAccountProviders>>;
}

/** on conflict condition type for table "auth.account_providers" */
export interface StudentAuthAccountProvidersOnConflict {
  constraint: StudentAuthAccountProvidersConstraint;
  update_columns?: Array<StudentAuthAccountProvidersUpdateColumn>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.account_providers". */
export interface StudentAuthAccountProvidersOrderBy {
  account?: Maybe<StudentAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrderBy>;
  auth_provider?: Maybe<StudentOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  provider?: Maybe<StudentAuthProvidersOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: auth_account_providers */
export interface StudentAuthAccountProvidersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_providers" */
export const enum StudentAuthAccountProvidersSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "auth.account_providers" */
export interface StudentAuthAccountProvidersSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "auth.account_providers" */
export const enum StudentAuthAccountProvidersUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "auth.account_roles" */
export interface StudentAuthAccountRoles {
  /** An object relationship */
  account: EntireFieldWrapper<StudentAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<StudentAuthRoles>;
}

/** aggregated selection of "auth.account_roles" */
export interface StudentAuthAccountRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAuthAccountRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAuthAccountRoles>>;
}

/** aggregate fields of "auth.account_roles" */
export interface StudentAuthAccountRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAuthAccountRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAuthAccountRolesMinFields>>;
}


/** aggregate fields of "auth.account_roles" */
export interface StudentAuthAccountRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_roles" */
export interface StudentAuthAccountRolesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAuthAccountRolesMaxOrderBy>;
  min?: Maybe<StudentAuthAccountRolesMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_roles" */
export interface StudentAuthAccountRolesArrRelInsertInput {
  data: Array<StudentAuthAccountRolesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthAccountRolesOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export interface StudentAuthAccountRolesBoolExp {
  _and?: Maybe<Array<StudentAuthAccountRolesBoolExp>>;
  _not?: Maybe<StudentAuthAccountRolesBoolExp>;
  _or?: Maybe<Array<StudentAuthAccountRolesBoolExp>>;
  account?: Maybe<StudentAuthAccountsBoolExp>;
  account_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  role?: Maybe<StudentStringComparisonExp>;
  roleByRole?: Maybe<StudentAuthRolesBoolExp>;
}

/** unique or primary key constraints on table "auth.account_roles" */
export const enum StudentAuthAccountRolesConstraint {
  /** unique or primary key constraint */
  ACCOUNT_ROLES_PKEY = 'account_roles_pkey',
  /** unique or primary key constraint */
  USER_ROLES_ACCOUNT_ID_ROLE_KEY = 'user_roles_account_id_role_key'
};

/** input type for inserting data into table "auth.account_roles" */
export interface StudentAuthAccountRolesInsertInput {
  account?: Maybe<StudentAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<StudentAuthRolesObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentAuthAccountRolesMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by max() on columns of table "auth.account_roles" */
export interface StudentAuthAccountRolesMaxOrderBy {
  account_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  role?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentAuthAccountRolesMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by min() on columns of table "auth.account_roles" */
export interface StudentAuthAccountRolesMinOrderBy {
  account_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  role?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "auth.account_roles" */
export interface StudentAuthAccountRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAuthAccountRoles>>;
}

/** on conflict condition type for table "auth.account_roles" */
export interface StudentAuthAccountRolesOnConflict {
  constraint: StudentAuthAccountRolesConstraint;
  update_columns?: Array<StudentAuthAccountRolesUpdateColumn>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.account_roles". */
export interface StudentAuthAccountRolesOrderBy {
  account?: Maybe<StudentAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  role?: Maybe<StudentOrderBy>;
  roleByRole?: Maybe<StudentAuthRolesOrderBy>;
}

/** primary key columns input for table: auth_account_roles */
export interface StudentAuthAccountRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_roles" */
export const enum StudentAuthAccountRolesSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.account_roles" */
export interface StudentAuthAccountRolesSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.account_roles" */
export const enum StudentAuthAccountRolesUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccounts {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<StudentAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<StudentAuthAccountProvidersAggregate>;
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<StudentAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<StudentAuthAccountRolesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  default_role: EntireFieldWrapper<Scalars['String']>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbers>>;
  is_active: EntireFieldWrapper<Scalars['Boolean']>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  refresh_tokens: EntireFieldWrapper<Array<StudentAuthRefreshTokens>>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: EntireFieldWrapper<StudentAuthRefreshTokensAggregate>;
  /** An object relationship */
  role: EntireFieldWrapper<StudentAuthRoles>;
  ticket: EntireFieldWrapper<Scalars['uuid']>;
  ticket_expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccountsAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccountsAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccountsAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccountsAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccountsRefreshTokensArgs {
  distinct_on?: Maybe<Array<StudentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentAuthRefreshTokensBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentAuthAccountsRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentAuthRefreshTokensBoolExp>;
}

/** aggregated selection of "auth.accounts" */
export interface StudentAuthAccountsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAuthAccountsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAuthAccounts>>;
}

/** aggregate fields of "auth.accounts" */
export interface StudentAuthAccountsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAuthAccountsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAuthAccountsMinFields>>;
}


/** aggregate fields of "auth.accounts" */
export interface StudentAuthAccountsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAuthAccountsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.accounts" */
export interface StudentAuthAccountsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAuthAccountsMaxOrderBy>;
  min?: Maybe<StudentAuthAccountsMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.accounts" */
export interface StudentAuthAccountsArrRelInsertInput {
  data: Array<StudentAuthAccountsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthAccountsOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export interface StudentAuthAccountsBoolExp {
  _and?: Maybe<Array<StudentAuthAccountsBoolExp>>;
  _not?: Maybe<StudentAuthAccountsBoolExp>;
  _or?: Maybe<Array<StudentAuthAccountsBoolExp>>;
  account_providers?: Maybe<StudentAuthAccountProvidersBoolExp>;
  account_roles?: Maybe<StudentAuthAccountRolesBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  default_role?: Maybe<StudentStringComparisonExp>;
  email?: Maybe<StudentCitextComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  insurance_number?: Maybe<StudentPrivateInsuranceNumbersBoolExp>;
  is_active?: Maybe<StudentBooleanComparisonExp>;
  new_email?: Maybe<StudentCitextComparisonExp>;
  password_hash?: Maybe<StudentStringComparisonExp>;
  refresh_tokens?: Maybe<StudentAuthRefreshTokensBoolExp>;
  role?: Maybe<StudentAuthRolesBoolExp>;
  ticket?: Maybe<StudentUuidComparisonExp>;
  ticket_expires_at?: Maybe<StudentTimestamptzComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user?: Maybe<StudentUsersBoolExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.accounts" */
export const enum StudentAuthAccountsConstraint {
  /** unique or primary key constraint */
  ACCOUNTS_EMAIL_KEY = 'accounts_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_NEW_EMAIL_KEY = 'accounts_new_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_PKEY = 'accounts_pkey',
  /** unique or primary key constraint */
  ACCOUNTS_USER_ID_KEY = 'accounts_user_id_key'
};

/** input type for inserting data into table "auth.accounts" */
export interface StudentAuthAccountsInsertInput {
  account_providers?: Maybe<StudentAuthAccountProvidersArrRelInsertInput>;
  account_roles?: Maybe<StudentAuthAccountRolesArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<StudentPrivateInsuranceNumbersObjRelInsertInput>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<StudentAuthRefreshTokensArrRelInsertInput>;
  role?: Maybe<StudentAuthRolesObjRelInsertInput>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentAuthAccountsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.accounts" */
export interface StudentAuthAccountsMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  default_role?: Maybe<StudentOrderBy>;
  email?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  new_email?: Maybe<StudentOrderBy>;
  password_hash?: Maybe<StudentOrderBy>;
  ticket?: Maybe<StudentOrderBy>;
  ticket_expires_at?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentAuthAccountsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.accounts" */
export interface StudentAuthAccountsMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  default_role?: Maybe<StudentOrderBy>;
  email?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  new_email?: Maybe<StudentOrderBy>;
  password_hash?: Maybe<StudentOrderBy>;
  ticket?: Maybe<StudentOrderBy>;
  ticket_expires_at?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "auth.accounts" */
export interface StudentAuthAccountsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAuthAccounts>>;
}

/** input type for inserting object relation for remote table "auth.accounts" */
export interface StudentAuthAccountsObjRelInsertInput {
  data: StudentAuthAccountsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthAccountsOnConflict>;
}

/** on conflict condition type for table "auth.accounts" */
export interface StudentAuthAccountsOnConflict {
  constraint: StudentAuthAccountsConstraint;
  update_columns?: Array<StudentAuthAccountsUpdateColumn>;
  where?: Maybe<StudentAuthAccountsBoolExp>;
}

/** Ordering options when selecting data from "auth.accounts". */
export interface StudentAuthAccountsOrderBy {
  account_providers_aggregate?: Maybe<StudentAuthAccountProvidersAggregateOrderBy>;
  account_roles_aggregate?: Maybe<StudentAuthAccountRolesAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  default_role?: Maybe<StudentOrderBy>;
  email?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  insurance_number?: Maybe<StudentPrivateInsuranceNumbersOrderBy>;
  is_active?: Maybe<StudentOrderBy>;
  new_email?: Maybe<StudentOrderBy>;
  password_hash?: Maybe<StudentOrderBy>;
  refresh_tokens_aggregate?: Maybe<StudentAuthRefreshTokensAggregateOrderBy>;
  role?: Maybe<StudentAuthRolesOrderBy>;
  ticket?: Maybe<StudentOrderBy>;
  ticket_expires_at?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user?: Maybe<StudentUsersOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: auth_accounts */
export interface StudentAuthAccountsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.accounts" */
export const enum StudentAuthAccountsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "auth.accounts" */
export interface StudentAuthAccountsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.accounts" */
export const enum StudentAuthAccountsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "auth.providers" */
export interface StudentAuthProviders {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<StudentAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<StudentAuthAccountProvidersAggregate>;
  provider: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.providers" */
export interface StudentAuthProvidersAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.providers" */
export interface StudentAuthProvidersAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}

/** aggregated selection of "auth.providers" */
export interface StudentAuthProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAuthProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAuthProviders>>;
}

/** aggregate fields of "auth.providers" */
export interface StudentAuthProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAuthProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAuthProvidersMinFields>>;
}


/** aggregate fields of "auth.providers" */
export interface StudentAuthProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAuthProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export interface StudentAuthProvidersBoolExp {
  _and?: Maybe<Array<StudentAuthProvidersBoolExp>>;
  _not?: Maybe<StudentAuthProvidersBoolExp>;
  _or?: Maybe<Array<StudentAuthProvidersBoolExp>>;
  account_providers?: Maybe<StudentAuthAccountProvidersBoolExp>;
  provider?: Maybe<StudentStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.providers" */
export const enum StudentAuthProvidersConstraint {
  /** unique or primary key constraint */
  PROVIDERS_PKEY = 'providers_pkey'
};

/** input type for inserting data into table "auth.providers" */
export interface StudentAuthProvidersInsertInput {
  account_providers?: Maybe<StudentAuthAccountProvidersArrRelInsertInput>;
  provider?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentAuthProvidersMaxFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentAuthProvidersMinFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.providers" */
export interface StudentAuthProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAuthProviders>>;
}

/** input type for inserting object relation for remote table "auth.providers" */
export interface StudentAuthProvidersObjRelInsertInput {
  data: StudentAuthProvidersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthProvidersOnConflict>;
}

/** on conflict condition type for table "auth.providers" */
export interface StudentAuthProvidersOnConflict {
  constraint: StudentAuthProvidersConstraint;
  update_columns?: Array<StudentAuthProvidersUpdateColumn>;
  where?: Maybe<StudentAuthProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.providers". */
export interface StudentAuthProvidersOrderBy {
  account_providers_aggregate?: Maybe<StudentAuthAccountProvidersAggregateOrderBy>;
  provider?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: auth_providers */
export interface StudentAuthProvidersPkColumnsInput {
  provider: Scalars['String'];
}

/** select columns of table "auth.providers" */
export const enum StudentAuthProvidersSelectColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** input type for updating data in table "auth.providers" */
export interface StudentAuthProvidersSetInput {
  provider?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.providers" */
export const enum StudentAuthProvidersUpdateColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** columns and relationships of "auth.refresh_tokens" */
export interface StudentAuthRefreshTokens {
  /** An object relationship */
  account: EntireFieldWrapper<StudentAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  refresh_token: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokensAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAuthRefreshTokens>>;
}

/** aggregate fields of "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokensMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokensMinFields>>;
}


/** aggregate fields of "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAuthRefreshTokensSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentAuthRefreshTokensMaxOrderBy>;
  min?: Maybe<StudentAuthRefreshTokensMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensArrRelInsertInput {
  data: Array<StudentAuthRefreshTokensInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthRefreshTokensOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export interface StudentAuthRefreshTokensBoolExp {
  _and?: Maybe<Array<StudentAuthRefreshTokensBoolExp>>;
  _not?: Maybe<StudentAuthRefreshTokensBoolExp>;
  _or?: Maybe<Array<StudentAuthRefreshTokensBoolExp>>;
  account?: Maybe<StudentAuthAccountsBoolExp>;
  account_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  expires_at?: Maybe<StudentTimestamptzComparisonExp>;
  refresh_token?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export const enum StudentAuthRefreshTokensConstraint {
  /** unique or primary key constraint */
  REFRESH_TOKENS_PKEY = 'refresh_tokens_pkey'
};

/** input type for inserting data into table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensInsertInput {
  account?: Maybe<StudentAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentAuthRefreshTokensMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensMaxOrderBy {
  account_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  expires_at?: Maybe<StudentOrderBy>;
  refresh_token?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentAuthRefreshTokensMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensMinOrderBy {
  account_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  expires_at?: Maybe<StudentOrderBy>;
  refresh_token?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAuthRefreshTokens>>;
}

/** on conflict condition type for table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensOnConflict {
  constraint: StudentAuthRefreshTokensConstraint;
  update_columns?: Array<StudentAuthRefreshTokensUpdateColumn>;
  where?: Maybe<StudentAuthRefreshTokensBoolExp>;
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export interface StudentAuthRefreshTokensOrderBy {
  account?: Maybe<StudentAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  expires_at?: Maybe<StudentOrderBy>;
  refresh_token?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: auth_refresh_tokens */
export interface StudentAuthRefreshTokensPkColumnsInput {
  refresh_token: Scalars['uuid'];
}

/** select columns of table "auth.refresh_tokens" */
export const enum StudentAuthRefreshTokensSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** input type for updating data in table "auth.refresh_tokens" */
export interface StudentAuthRefreshTokensSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.refresh_tokens" */
export const enum StudentAuthRefreshTokensUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** columns and relationships of "auth.roles" */
export interface StudentAuthRoles {
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<StudentAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<StudentAuthAccountRolesAggregate>;
  /** An array relationship */
  accounts: EntireFieldWrapper<Array<StudentAuthAccounts>>;
  /** An aggregate relationship */
  accounts_aggregate: EntireFieldWrapper<StudentAuthAccountsAggregate>;
  role: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.roles" */
export interface StudentAuthRolesAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentAuthRolesAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentAuthRolesAccountsArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountsOrderBy>>;
  where?: Maybe<StudentAuthAccountsBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentAuthRolesAccountsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountsOrderBy>>;
  where?: Maybe<StudentAuthAccountsBoolExp>;
}

/** aggregated selection of "auth.roles" */
export interface StudentAuthRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentAuthRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentAuthRoles>>;
}

/** aggregate fields of "auth.roles" */
export interface StudentAuthRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentAuthRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentAuthRolesMinFields>>;
}


/** aggregate fields of "auth.roles" */
export interface StudentAuthRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentAuthRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export interface StudentAuthRolesBoolExp {
  _and?: Maybe<Array<StudentAuthRolesBoolExp>>;
  _not?: Maybe<StudentAuthRolesBoolExp>;
  _or?: Maybe<Array<StudentAuthRolesBoolExp>>;
  account_roles?: Maybe<StudentAuthAccountRolesBoolExp>;
  accounts?: Maybe<StudentAuthAccountsBoolExp>;
  role?: Maybe<StudentStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.roles" */
export const enum StudentAuthRolesConstraint {
  /** unique or primary key constraint */
  ROLES_PKEY = 'roles_pkey'
};

/** input type for inserting data into table "auth.roles" */
export interface StudentAuthRolesInsertInput {
  account_roles?: Maybe<StudentAuthAccountRolesArrRelInsertInput>;
  accounts?: Maybe<StudentAuthAccountsArrRelInsertInput>;
  role?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentAuthRolesMaxFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentAuthRolesMinFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.roles" */
export interface StudentAuthRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentAuthRoles>>;
}

/** input type for inserting object relation for remote table "auth.roles" */
export interface StudentAuthRolesObjRelInsertInput {
  data: StudentAuthRolesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentAuthRolesOnConflict>;
}

/** on conflict condition type for table "auth.roles" */
export interface StudentAuthRolesOnConflict {
  constraint: StudentAuthRolesConstraint;
  update_columns?: Array<StudentAuthRolesUpdateColumn>;
  where?: Maybe<StudentAuthRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.roles". */
export interface StudentAuthRolesOrderBy {
  account_roles_aggregate?: Maybe<StudentAuthAccountRolesAggregateOrderBy>;
  accounts_aggregate?: Maybe<StudentAuthAccountsAggregateOrderBy>;
  role?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: auth_roles */
export interface StudentAuthRolesPkColumnsInput {
  role: Scalars['String'];
}

/** select columns of table "auth.roles" */
export const enum StudentAuthRolesSelectColumn {
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.roles" */
export interface StudentAuthRolesSetInput {
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.roles" */
export const enum StudentAuthRolesUpdateColumn {
  /** column name */
  ROLE = 'role'
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export interface StudentBigintComparisonExp {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
}

/** columns and relationships of "book_chapter_type" */
export interface StudentBookChapterType {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentBookChapters>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "book_chapter_type" */
export interface StudentBookChapterTypeBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookChaptersOrderBy>>;
  where?: Maybe<StudentBookChaptersBoolExp>;
}

/** Boolean expression to filter rows from the table "book_chapter_type". All fields are combined with a logical 'AND'. */
export interface StudentBookChapterTypeBoolExp {
  _and?: Maybe<Array<StudentBookChapterTypeBoolExp>>;
  _not?: Maybe<StudentBookChapterTypeBoolExp>;
  _or?: Maybe<Array<StudentBookChapterTypeBoolExp>>;
  book_chapters?: Maybe<StudentBookChaptersBoolExp>;
  description?: Maybe<StudentStringComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
}

export const enum StudentBookChapterTypeEnum {
  HTML = 'HTML',
  QUIZZ = 'QUIZZ'
};

/** Boolean expression to compare columns of type "book_chapter_type_enum". All fields are combined with logical 'AND'. */
export interface StudentBookChapterTypeEnumComparisonExp {
  _eq?: Maybe<StudentBookChapterTypeEnum>;
  _in?: Maybe<Array<StudentBookChapterTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentBookChapterTypeEnum>;
  _nin?: Maybe<Array<StudentBookChapterTypeEnum>>;
}

/** Ordering options when selecting data from "book_chapter_type". */
export interface StudentBookChapterTypeOrderBy {
  book_chapters_aggregate?: Maybe<StudentBookChaptersAggregateOrderBy>;
  description?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
}

/** select columns of table "book_chapter_type" */
export const enum StudentBookChapterTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "book_chapters" */
export interface StudentBookChapters {
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<StudentAssignmentBookChapter>>;
  /** An object relationship */
  book: EntireFieldWrapper<StudentBooks>;
  /** An object relationship */
  book_chapter_type: EntireFieldWrapper<StudentBookChapterType>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentChapterSections>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  due_at: EntireFieldWrapper<Scalars['date']>;
  /** A computed field, executes function "book_chapter_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentBookChapterTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "book_chapters" */
export interface StudentBookChaptersAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "book_chapters" */
export interface StudentBookChaptersChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionsOrderBy>>;
  where?: Maybe<StudentChapterSectionsBoolExp>;
}

/** order by aggregate values of table "book_chapters" */
export interface StudentBookChaptersAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentBookChaptersMaxOrderBy>;
  min?: Maybe<StudentBookChaptersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_chapters". All fields are combined with a logical 'AND'. */
export interface StudentBookChaptersBoolExp {
  _and?: Maybe<Array<StudentBookChaptersBoolExp>>;
  _not?: Maybe<StudentBookChaptersBoolExp>;
  _or?: Maybe<Array<StudentBookChaptersBoolExp>>;
  assignment_book_chapters?: Maybe<StudentAssignmentBookChapterBoolExp>;
  book?: Maybe<StudentBooksBoolExp>;
  book_chapter_type?: Maybe<StudentBookChapterTypeBoolExp>;
  book_id?: Maybe<StudentUuidComparisonExp>;
  chapter_sections?: Maybe<StudentChapterSectionsBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  due_at?: Maybe<StudentDateComparisonExp>;
  duration_left?: Maybe<StudentBigintComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  status?: Maybe<StudentStringComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  type?: Maybe<StudentBookChapterTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "book_chapters" */
export interface StudentBookChaptersMaxOrderBy {
  book_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  due_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "book_chapters" */
export interface StudentBookChaptersMinOrderBy {
  book_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  due_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "book_chapters". */
export interface StudentBookChaptersOrderBy {
  assignment_book_chapters_aggregate?: Maybe<StudentAssignmentBookChapterAggregateOrderBy>;
  book?: Maybe<StudentBooksOrderBy>;
  book_chapter_type?: Maybe<StudentBookChapterTypeOrderBy>;
  book_id?: Maybe<StudentOrderBy>;
  chapter_sections_aggregate?: Maybe<StudentChapterSectionsAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  due_at?: Maybe<StudentOrderBy>;
  duration_left?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "book_chapters" */
export const enum StudentBookChaptersSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "book_course" */
export interface StudentBookCourse {
  /** An object relationship */
  book: EntireFieldWrapper<StudentBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_course" */
export interface StudentBookCourseAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentBookCourseMaxOrderBy>;
  min?: Maybe<StudentBookCourseMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_course". All fields are combined with a logical 'AND'. */
export interface StudentBookCourseBoolExp {
  _and?: Maybe<Array<StudentBookCourseBoolExp>>;
  _not?: Maybe<StudentBookCourseBoolExp>;
  _or?: Maybe<Array<StudentBookCourseBoolExp>>;
  book?: Maybe<StudentBooksBoolExp>;
  book_id?: Maybe<StudentUuidComparisonExp>;
  course?: Maybe<StudentCoursesBoolExp>;
  course_id?: Maybe<StudentUuidComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "book_course" */
export interface StudentBookCourseMaxOrderBy {
  book_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "book_course" */
export interface StudentBookCourseMinOrderBy {
  book_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "book_course". */
export interface StudentBookCourseOrderBy {
  book?: Maybe<StudentBooksOrderBy>;
  book_id?: Maybe<StudentOrderBy>;
  course?: Maybe<StudentCoursesOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** select columns of table "book_course" */
export const enum StudentBookCourseSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "book_user" */
export interface StudentBookUser {
  /** An object relationship */
  book: EntireFieldWrapper<StudentBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_user" */
export interface StudentBookUserAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentBookUserMaxOrderBy>;
  min?: Maybe<StudentBookUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_user". All fields are combined with a logical 'AND'. */
export interface StudentBookUserBoolExp {
  _and?: Maybe<Array<StudentBookUserBoolExp>>;
  _not?: Maybe<StudentBookUserBoolExp>;
  _or?: Maybe<Array<StudentBookUserBoolExp>>;
  book?: Maybe<StudentBooksBoolExp>;
  book_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "book_user" */
export interface StudentBookUserMaxOrderBy {
  book_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "book_user" */
export interface StudentBookUserMinOrderBy {
  book_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "book_user". */
export interface StudentBookUserOrderBy {
  book?: Maybe<StudentBooksOrderBy>;
  book_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "book_user" */
export const enum StudentBookUserSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "books" */
export interface StudentBooks {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentBookChapters>>;
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<StudentBookCourse>>;
  /** An array relationship */
  book_users: EntireFieldWrapper<Array<StudentBookUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "books" */
export interface StudentBooksBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookChaptersOrderBy>>;
  where?: Maybe<StudentBookChaptersBoolExp>;
}


/** columns and relationships of "books" */
export interface StudentBooksBookCoursesArgs {
  distinct_on?: Maybe<Array<StudentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookCourseOrderBy>>;
  where?: Maybe<StudentBookCourseBoolExp>;
}


/** columns and relationships of "books" */
export interface StudentBooksBookUsersArgs {
  distinct_on?: Maybe<Array<StudentBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookUserOrderBy>>;
  where?: Maybe<StudentBookUserBoolExp>;
}

/** order by aggregate values of table "books" */
export interface StudentBooksAggregateOrderBy {
  avg?: Maybe<StudentBooksAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentBooksMaxOrderBy>;
  min?: Maybe<StudentBooksMinOrderBy>;
  stddev?: Maybe<StudentBooksStddevOrderBy>;
  stddev_pop?: Maybe<StudentBooksStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentBooksStddevSampOrderBy>;
  sum?: Maybe<StudentBooksSumOrderBy>;
  var_pop?: Maybe<StudentBooksVarPopOrderBy>;
  var_samp?: Maybe<StudentBooksVarSampOrderBy>;
  variance?: Maybe<StudentBooksVarianceOrderBy>;
}

/** order by avg() on columns of table "books" */
export interface StudentBooksAvgOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "books". All fields are combined with a logical 'AND'. */
export interface StudentBooksBoolExp {
  _and?: Maybe<Array<StudentBooksBoolExp>>;
  _not?: Maybe<StudentBooksBoolExp>;
  _or?: Maybe<Array<StudentBooksBoolExp>>;
  book_chapters?: Maybe<StudentBookChaptersBoolExp>;
  book_courses?: Maybe<StudentBookCourseBoolExp>;
  book_users?: Maybe<StudentBookUserBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  sort?: Maybe<StudentIntComparisonExp>;
  status?: Maybe<StudentStringComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "books" */
export interface StudentBooksMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "books" */
export interface StudentBooksMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "books". */
export interface StudentBooksOrderBy {
  book_chapters_aggregate?: Maybe<StudentBookChaptersAggregateOrderBy>;
  book_courses_aggregate?: Maybe<StudentBookCourseAggregateOrderBy>;
  book_users_aggregate?: Maybe<StudentBookUserAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "books" */
export const enum StudentBooksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "books" */
export interface StudentBooksStddevOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "books" */
export interface StudentBooksStddevPopOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "books" */
export interface StudentBooksStddevSampOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "books" */
export interface StudentBooksSumOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** order by var_pop() on columns of table "books" */
export interface StudentBooksVarPopOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "books" */
export interface StudentBooksVarSampOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "books" */
export interface StudentBooksVarianceOrderBy {
  sort?: Maybe<StudentOrderBy>;
}

/**
 * DEPRECATED - change to assignments_notes
 *
 *
 * columns and relationships of "chapter_section_notes"
 */
export interface StudentChapterSectionNotes {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chapter_section: EntireFieldWrapper<StudentChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
}

/** order by aggregate values of table "chapter_section_notes" */
export interface StudentChapterSectionNotesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChapterSectionNotesMaxOrderBy>;
  min?: Maybe<StudentChapterSectionNotesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_notes". All fields are combined with a logical 'AND'. */
export interface StudentChapterSectionNotesBoolExp {
  _and?: Maybe<Array<StudentChapterSectionNotesBoolExp>>;
  _not?: Maybe<StudentChapterSectionNotesBoolExp>;
  _or?: Maybe<Array<StudentChapterSectionNotesBoolExp>>;
  body?: Maybe<StudentStringComparisonExp>;
  chapter_section?: Maybe<StudentChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "chapter_section_notes" */
export const enum StudentChapterSectionNotesConstraint {
  /** unique or primary key constraint */
  CHAPTER_SECTION_NOTES_PKEY = 'chapter_section_notes_pkey'
};

/** input type for inserting data into table "chapter_section_notes" */
export interface StudentChapterSectionNotesInsertInput {
  body?: Maybe<Scalars['String']>;
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chapter_section_notes" */
export interface StudentChapterSectionNotesMaxOrderBy {
  body?: Maybe<StudentOrderBy>;
  chapter_section_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "chapter_section_notes" */
export interface StudentChapterSectionNotesMinOrderBy {
  body?: Maybe<StudentOrderBy>;
  chapter_section_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chapter_section_notes" */
export interface StudentChapterSectionNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChapterSectionNotes>>;
}

/** on conflict condition type for table "chapter_section_notes" */
export interface StudentChapterSectionNotesOnConflict {
  constraint: StudentChapterSectionNotesConstraint;
  update_columns?: Array<StudentChapterSectionNotesUpdateColumn>;
  where?: Maybe<StudentChapterSectionNotesBoolExp>;
}

/** Ordering options when selecting data from "chapter_section_notes". */
export interface StudentChapterSectionNotesOrderBy {
  body?: Maybe<StudentOrderBy>;
  chapter_section?: Maybe<StudentChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: chapter_section_notes */
export interface StudentChapterSectionNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chapter_section_notes" */
export const enum StudentChapterSectionNotesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "chapter_section_notes" */
export interface StudentChapterSectionNotesSetInput {
  body?: Maybe<Scalars['String']>;
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "chapter_section_notes" */
export const enum StudentChapterSectionNotesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "chapter_section_submits" */
export interface StudentChapterSectionSubmits {
  /** An object relationship */
  chapter_section: EntireFieldWrapper<StudentChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration_spent: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsAggregateOrderBy {
  avg?: Maybe<StudentChapterSectionSubmitsAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChapterSectionSubmitsMaxOrderBy>;
  min?: Maybe<StudentChapterSectionSubmitsMinOrderBy>;
  stddev?: Maybe<StudentChapterSectionSubmitsStddevOrderBy>;
  stddev_pop?: Maybe<StudentChapterSectionSubmitsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentChapterSectionSubmitsStddevSampOrderBy>;
  sum?: Maybe<StudentChapterSectionSubmitsSumOrderBy>;
  var_pop?: Maybe<StudentChapterSectionSubmitsVarPopOrderBy>;
  var_samp?: Maybe<StudentChapterSectionSubmitsVarSampOrderBy>;
  variance?: Maybe<StudentChapterSectionSubmitsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsAvgOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_submits". All fields are combined with a logical 'AND'. */
export interface StudentChapterSectionSubmitsBoolExp {
  _and?: Maybe<Array<StudentChapterSectionSubmitsBoolExp>>;
  _not?: Maybe<StudentChapterSectionSubmitsBoolExp>;
  _or?: Maybe<Array<StudentChapterSectionSubmitsBoolExp>>;
  chapter_section?: Maybe<StudentChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  duration_spent?: Maybe<StudentIntComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_completed?: Maybe<StudentBooleanComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "chapter_section_submits" */
export const enum StudentChapterSectionSubmitsConstraint {
  /** unique or primary key constraint */
  CHAPTER_SECTION_STUDENT_PKEY = 'chapter_section_student_pkey',
  /** unique or primary key constraint */
  CHAPTER_SECTION_SUBMITS_CHAPTER_SECTION_ID_STUDENT_ID_KEY = 'chapter_section_submits_chapter_section_id_student_id_key'
};

/** input type for incrementing numeric columns in table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsIncInput {
  duration_spent?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsInsertInput {
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration_spent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsMaxOrderBy {
  chapter_section_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  duration_spent?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsMinOrderBy {
  chapter_section_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  duration_spent?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChapterSectionSubmits>>;
}

/** on conflict condition type for table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsOnConflict {
  constraint: StudentChapterSectionSubmitsConstraint;
  update_columns?: Array<StudentChapterSectionSubmitsUpdateColumn>;
  where?: Maybe<StudentChapterSectionSubmitsBoolExp>;
}

/** Ordering options when selecting data from "chapter_section_submits". */
export interface StudentChapterSectionSubmitsOrderBy {
  chapter_section?: Maybe<StudentChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  duration_spent?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_completed?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: chapter_section_submits */
export interface StudentChapterSectionSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chapter_section_submits" */
export const enum StudentChapterSectionSubmitsSelectColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsSetInput {
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration_spent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by stddev() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsStddevOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsStddevPopOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsStddevSampOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsSumOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** update columns of table "chapter_section_submits" */
export const enum StudentChapterSectionSubmitsUpdateColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by var_pop() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsVarPopOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsVarSampOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "chapter_section_submits" */
export interface StudentChapterSectionSubmitsVarianceOrderBy {
  duration_spent?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "chapter_section_type" */
export interface StudentChapterSectionType {
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentChapterSections>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chapter_section_type" */
export interface StudentChapterSectionTypeChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionsOrderBy>>;
  where?: Maybe<StudentChapterSectionsBoolExp>;
}

/** Boolean expression to filter rows from the table "chapter_section_type". All fields are combined with a logical 'AND'. */
export interface StudentChapterSectionTypeBoolExp {
  _and?: Maybe<Array<StudentChapterSectionTypeBoolExp>>;
  _not?: Maybe<StudentChapterSectionTypeBoolExp>;
  _or?: Maybe<Array<StudentChapterSectionTypeBoolExp>>;
  chapter_sections?: Maybe<StudentChapterSectionsBoolExp>;
  icon?: Maybe<StudentStringComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
}

export const enum StudentChapterSectionTypeEnum {
  HTML = 'HTML',
  INFORMATION = 'Information',
  QUIZZ = 'Quizz'
};

/** Boolean expression to compare columns of type "chapter_section_type_enum". All fields are combined with logical 'AND'. */
export interface StudentChapterSectionTypeEnumComparisonExp {
  _eq?: Maybe<StudentChapterSectionTypeEnum>;
  _in?: Maybe<Array<StudentChapterSectionTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentChapterSectionTypeEnum>;
  _nin?: Maybe<Array<StudentChapterSectionTypeEnum>>;
}

/** Ordering options when selecting data from "chapter_section_type". */
export interface StudentChapterSectionTypeOrderBy {
  chapter_sections_aggregate?: Maybe<StudentChapterSectionsAggregateOrderBy>;
  icon?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
}

/** select columns of table "chapter_section_type" */
export const enum StudentChapterSectionTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chapter_sections" */
export interface StudentChapterSections {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<StudentBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<StudentChapterSectionSubmits>>;
  /** An object relationship */
  chapter_section_type: EntireFieldWrapper<StudentChapterSectionType>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** A computed field, executes function "section_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "section_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentChapterSectionTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "chapter_sections" */
export interface StudentChapterSectionsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentChapterSectionNotesBoolExp>;
}


/** columns and relationships of "chapter_sections" */
export interface StudentChapterSectionsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentChapterSectionSubmitsBoolExp>;
}

/** order by aggregate values of table "chapter_sections" */
export interface StudentChapterSectionsAggregateOrderBy {
  avg?: Maybe<StudentChapterSectionsAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChapterSectionsMaxOrderBy>;
  min?: Maybe<StudentChapterSectionsMinOrderBy>;
  stddev?: Maybe<StudentChapterSectionsStddevOrderBy>;
  stddev_pop?: Maybe<StudentChapterSectionsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentChapterSectionsStddevSampOrderBy>;
  sum?: Maybe<StudentChapterSectionsSumOrderBy>;
  var_pop?: Maybe<StudentChapterSectionsVarPopOrderBy>;
  var_samp?: Maybe<StudentChapterSectionsVarSampOrderBy>;
  variance?: Maybe<StudentChapterSectionsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_sections" */
export interface StudentChapterSectionsAvgOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_sections". All fields are combined with a logical 'AND'. */
export interface StudentChapterSectionsBoolExp {
  _and?: Maybe<Array<StudentChapterSectionsBoolExp>>;
  _not?: Maybe<StudentChapterSectionsBoolExp>;
  _or?: Maybe<Array<StudentChapterSectionsBoolExp>>;
  body?: Maybe<StudentStringComparisonExp>;
  book_chapter?: Maybe<StudentBookChaptersBoolExp>;
  book_chapter_id?: Maybe<StudentUuidComparisonExp>;
  chapter_section_notes?: Maybe<StudentChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<StudentChapterSectionSubmitsBoolExp>;
  chapter_section_type?: Maybe<StudentChapterSectionTypeBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  duration?: Maybe<StudentIntComparisonExp>;
  duration_left?: Maybe<StudentIntComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_completed?: Maybe<StudentBooleanComparisonExp>;
  sort?: Maybe<StudentIntComparisonExp>;
  status?: Maybe<StudentStringComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  type?: Maybe<StudentChapterSectionTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_sections" */
export interface StudentChapterSectionsMaxOrderBy {
  body?: Maybe<StudentOrderBy>;
  book_chapter_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "chapter_sections" */
export interface StudentChapterSectionsMinOrderBy {
  body?: Maybe<StudentOrderBy>;
  book_chapter_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "chapter_sections". */
export interface StudentChapterSectionsOrderBy {
  body?: Maybe<StudentOrderBy>;
  book_chapter?: Maybe<StudentBookChaptersOrderBy>;
  book_chapter_id?: Maybe<StudentOrderBy>;
  chapter_section_notes_aggregate?: Maybe<StudentChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<StudentChapterSectionSubmitsAggregateOrderBy>;
  chapter_section_type?: Maybe<StudentChapterSectionTypeOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  duration_left?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_completed?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "chapter_sections" */
export const enum StudentChapterSectionsSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_sections" */
export interface StudentChapterSectionsStddevOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_sections" */
export interface StudentChapterSectionsStddevPopOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_sections" */
export interface StudentChapterSectionsStddevSampOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "chapter_sections" */
export interface StudentChapterSectionsSumOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** order by var_pop() on columns of table "chapter_sections" */
export interface StudentChapterSectionsVarPopOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "chapter_sections" */
export interface StudentChapterSectionsVarSampOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "chapter_sections" */
export interface StudentChapterSectionsVarianceOrderBy {
  duration?: Maybe<StudentOrderBy>;
  sort?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "chat_message_likes" */
export interface StudentChatMessageLikes {
  chat_like_user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "chat_message_likes" */
export interface StudentChatMessageLikesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentChatMessageLikesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentChatMessageLikes>>;
}

/** aggregate fields of "chat_message_likes" */
export interface StudentChatMessageLikesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentChatMessageLikesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentChatMessageLikesMinFields>>;
}


/** aggregate fields of "chat_message_likes" */
export interface StudentChatMessageLikesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_message_likes" */
export interface StudentChatMessageLikesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChatMessageLikesMaxOrderBy>;
  min?: Maybe<StudentChatMessageLikesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_likes" */
export interface StudentChatMessageLikesArrRelInsertInput {
  data: Array<StudentChatMessageLikesInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_message_likes". All fields are combined with a logical 'AND'. */
export interface StudentChatMessageLikesBoolExp {
  _and?: Maybe<Array<StudentChatMessageLikesBoolExp>>;
  _not?: Maybe<StudentChatMessageLikesBoolExp>;
  _or?: Maybe<Array<StudentChatMessageLikesBoolExp>>;
  chat_message?: Maybe<StudentChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** input type for inserting data into table "chat_message_likes" */
export interface StudentChatMessageLikesInsertInput {
  chat_message?: Maybe<StudentChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentChatMessageLikesMaxFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_message_likes" */
export interface StudentChatMessageLikesMaxOrderBy {
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentChatMessageLikesMinFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_message_likes" */
export interface StudentChatMessageLikesMinOrderBy {
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chat_message_likes" */
export interface StudentChatMessageLikesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChatMessageLikes>>;
}

/** Ordering options when selecting data from "chat_message_likes". */
export interface StudentChatMessageLikesOrderBy {
  chat_message?: Maybe<StudentChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "chat_message_likes" */
export const enum StudentChatMessageLikesSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chat_message_reads" */
export interface StudentChatMessageReads {
  /** An object relationship */
  chat_message: EntireFieldWrapper<StudentChatMessages>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_message_reads" */
export interface StudentChatMessageReadsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChatMessageReadsMaxOrderBy>;
  min?: Maybe<StudentChatMessageReadsMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_reads" */
export interface StudentChatMessageReadsArrRelInsertInput {
  data: Array<StudentChatMessageReadsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentChatMessageReadsOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_message_reads". All fields are combined with a logical 'AND'. */
export interface StudentChatMessageReadsBoolExp {
  _and?: Maybe<Array<StudentChatMessageReadsBoolExp>>;
  _not?: Maybe<StudentChatMessageReadsBoolExp>;
  _or?: Maybe<Array<StudentChatMessageReadsBoolExp>>;
  chat_message?: Maybe<StudentChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_read?: Maybe<StudentBooleanComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_message_reads" */
export const enum StudentChatMessageReadsConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGE_USER_PKEY = 'chat_message_user_pkey'
};

/** input type for inserting data into table "chat_message_reads" */
export interface StudentChatMessageReadsInsertInput {
  chat_message?: Maybe<StudentChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
}

/** order by max() on columns of table "chat_message_reads" */
export interface StudentChatMessageReadsMaxOrderBy {
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "chat_message_reads" */
export interface StudentChatMessageReadsMinOrderBy {
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chat_message_reads" */
export interface StudentChatMessageReadsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChatMessageReads>>;
}

/** on conflict condition type for table "chat_message_reads" */
export interface StudentChatMessageReadsOnConflict {
  constraint: StudentChatMessageReadsConstraint;
  update_columns?: Array<StudentChatMessageReadsUpdateColumn>;
  where?: Maybe<StudentChatMessageReadsBoolExp>;
}

/** Ordering options when selecting data from "chat_message_reads". */
export interface StudentChatMessageReadsOrderBy {
  chat_message?: Maybe<StudentChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_read?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: chat_message_reads */
export interface StudentChatMessageReadsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_message_reads" */
export const enum StudentChatMessageReadsSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_message_reads" */
export interface StudentChatMessageReadsSetInput {
  is_read?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_message_reads" */
export const enum StudentChatMessageReadsUpdateColumn {
  /** column name */
  IS_READ = 'is_read'
};

/** columns and relationships of "chat_messages" */
export interface StudentChatMessages {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chat: EntireFieldWrapper<StudentChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentChatMessageLikesAggregate>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentChatMessagesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_pinned: EntireFieldWrapper<Scalars['Boolean']>;
  /** A computed field, executes function "chat_message_replys" */
  replys?: EntireFieldWrapper<Maybe<Array<StudentChatMessages>>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageReadsOrderBy>>;
  where?: Maybe<StudentChatMessageReadsBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesFilesArgs {
  distinct_on?: Maybe<Array<StudentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentFilesOrderBy>>;
  where?: Maybe<StudentFilesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentChatMessagesReplysArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}

/** aggregated selection of "chat_messages" */
export interface StudentChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentChatMessages>>;
}

/** aggregate fields of "chat_messages" */
export interface StudentChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentChatMessagesMinFields>>;
}


/** aggregate fields of "chat_messages" */
export interface StudentChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_messages" */
export interface StudentChatMessagesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChatMessagesMaxOrderBy>;
  min?: Maybe<StudentChatMessagesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_messages" */
export interface StudentChatMessagesArrRelInsertInput {
  data: Array<StudentChatMessagesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentChatMessagesOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export interface StudentChatMessagesBoolExp {
  _and?: Maybe<Array<StudentChatMessagesBoolExp>>;
  _not?: Maybe<StudentChatMessagesBoolExp>;
  _or?: Maybe<Array<StudentChatMessagesBoolExp>>;
  body?: Maybe<StudentStringComparisonExp>;
  chat?: Maybe<StudentChatsBoolExp>;
  chat_id?: Maybe<StudentUuidComparisonExp>;
  chat_message?: Maybe<StudentChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentUuidComparisonExp>;
  chat_message_likes?: Maybe<StudentChatMessageLikesBoolExp>;
  chat_message_reads?: Maybe<StudentChatMessageReadsBoolExp>;
  chat_messages?: Maybe<StudentChatMessagesBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  files?: Maybe<StudentFilesBoolExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_pinned?: Maybe<StudentBooleanComparisonExp>;
  replys?: Maybe<StudentChatMessagesBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_messages" */
export const enum StudentChatMessagesConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGES_PKEY = 'chat_messages_pkey'
};

/** input type for inserting data into table "chat_messages" */
export interface StudentChatMessagesInsertInput {
  body?: Maybe<Scalars['String']>;
  chat?: Maybe<StudentChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message?: Maybe<StudentChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  chat_message_likes?: Maybe<StudentChatMessageLikesArrRelInsertInput>;
  chat_message_reads?: Maybe<StudentChatMessageReadsArrRelInsertInput>;
  chat_messages?: Maybe<StudentChatMessagesArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_messages" */
export interface StudentChatMessagesMaxOrderBy {
  body?: Maybe<StudentOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_messages" */
export interface StudentChatMessagesMinOrderBy {
  body?: Maybe<StudentOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  chat_message_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chat_messages" */
export interface StudentChatMessagesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChatMessages>>;
}

/** input type for inserting object relation for remote table "chat_messages" */
export interface StudentChatMessagesObjRelInsertInput {
  data: StudentChatMessagesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentChatMessagesOnConflict>;
}

/** on conflict condition type for table "chat_messages" */
export interface StudentChatMessagesOnConflict {
  constraint: StudentChatMessagesConstraint;
  update_columns?: Array<StudentChatMessagesUpdateColumn>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}

/** Ordering options when selecting data from "chat_messages". */
export interface StudentChatMessagesOrderBy {
  body?: Maybe<StudentOrderBy>;
  chat?: Maybe<StudentChatsOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  chat_message?: Maybe<StudentChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrderBy>;
  chat_message_likes_aggregate?: Maybe<StudentChatMessageLikesAggregateOrderBy>;
  chat_message_reads_aggregate?: Maybe<StudentChatMessageReadsAggregateOrderBy>;
  chat_messages_aggregate?: Maybe<StudentChatMessagesAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  files_aggregate?: Maybe<StudentFilesAggregateOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_pinned?: Maybe<StudentOrderBy>;
  replys_aggregate?: Maybe<StudentChatMessagesAggregateOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: chat_messages */
export interface StudentChatMessagesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_messages" */
export const enum StudentChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_messages" */
export interface StudentChatMessagesSetInput {
  body?: Maybe<Scalars['String']>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_messages" */
export const enum StudentChatMessagesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned'
};

/** columns and relationships of "chat_type" */
export interface StudentChatType {
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentChats>>;
  description: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chat_type" */
export interface StudentChatTypeChatsArgs {
  distinct_on?: Maybe<Array<StudentChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatsOrderBy>>;
  where?: Maybe<StudentChatsBoolExp>;
}

/** Boolean expression to filter rows from the table "chat_type". All fields are combined with a logical 'AND'. */
export interface StudentChatTypeBoolExp {
  _and?: Maybe<Array<StudentChatTypeBoolExp>>;
  _not?: Maybe<StudentChatTypeBoolExp>;
  _or?: Maybe<Array<StudentChatTypeBoolExp>>;
  chats?: Maybe<StudentChatsBoolExp>;
  description?: Maybe<StudentStringComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
}

export const enum StudentChatTypeEnum {
  /** Group conversation */
  GROUP = 'GROUP',
  /** Private conversation */
  PRIVATE = 'PRIVATE'
};

/** Boolean expression to compare columns of type "chat_type_enum". All fields are combined with logical 'AND'. */
export interface StudentChatTypeEnumComparisonExp {
  _eq?: Maybe<StudentChatTypeEnum>;
  _in?: Maybe<Array<StudentChatTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentChatTypeEnum>;
  _nin?: Maybe<Array<StudentChatTypeEnum>>;
}

/** Ordering options when selecting data from "chat_type". */
export interface StudentChatTypeOrderBy {
  chats_aggregate?: Maybe<StudentChatsAggregateOrderBy>;
  description?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
}

/** select columns of table "chat_type" */
export const enum StudentChatTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chat_user" */
export interface StudentChatUser {
  /** An object relationship */
  chat: EntireFieldWrapper<StudentChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_user" */
export interface StudentChatUserAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChatUserMaxOrderBy>;
  min?: Maybe<StudentChatUserMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_user" */
export interface StudentChatUserArrRelInsertInput {
  data: Array<StudentChatUserInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_user". All fields are combined with a logical 'AND'. */
export interface StudentChatUserBoolExp {
  _and?: Maybe<Array<StudentChatUserBoolExp>>;
  _not?: Maybe<StudentChatUserBoolExp>;
  _or?: Maybe<Array<StudentChatUserBoolExp>>;
  chat?: Maybe<StudentChatsBoolExp>;
  chat_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** input type for inserting data into table "chat_user" */
export interface StudentChatUserInsertInput {
  chat?: Maybe<StudentChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "chat_user" */
export interface StudentChatUserMaxOrderBy {
  chat_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "chat_user" */
export interface StudentChatUserMinOrderBy {
  chat_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chat_user" */
export interface StudentChatUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChatUser>>;
}

/** Ordering options when selecting data from "chat_user". */
export interface StudentChatUserOrderBy {
  chat?: Maybe<StudentChatsOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "chat_user" */
export const enum StudentChatUserSelectColumn {
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chats" */
export interface StudentChats {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentChatMessagesAggregate>;
  /** An object relationship */
  chat_type: EntireFieldWrapper<StudentChatType>;
  /** An array relationship */
  chat_users: EntireFieldWrapper<Array<StudentChatUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<StudentChatTypeEnum>;
  /** A computed field, executes function "unread_messages" */
  unread_messages?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chats" */
export interface StudentChatsChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface StudentChatsChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface StudentChatsChatUsersArgs {
  distinct_on?: Maybe<Array<StudentChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatUserOrderBy>>;
  where?: Maybe<StudentChatUserBoolExp>;
}

/** order by aggregate values of table "chats" */
export interface StudentChatsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentChatsMaxOrderBy>;
  min?: Maybe<StudentChatsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export interface StudentChatsBoolExp {
  _and?: Maybe<Array<StudentChatsBoolExp>>;
  _not?: Maybe<StudentChatsBoolExp>;
  _or?: Maybe<Array<StudentChatsBoolExp>>;
  avatar_url?: Maybe<StudentStringComparisonExp>;
  chat_messages?: Maybe<StudentChatMessagesBoolExp>;
  chat_type?: Maybe<StudentChatTypeBoolExp>;
  chat_users?: Maybe<StudentChatUserBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  type?: Maybe<StudentChatTypeEnumComparisonExp>;
  unread_messages?: Maybe<StudentBigintComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "chats" */
export const enum StudentChatsConstraint {
  /** unique or primary key constraint */
  CHATS_PKEY = 'chats_pkey'
};

/** input type for inserting data into table "chats" */
export interface StudentChatsInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  chat_messages?: Maybe<StudentChatMessagesArrRelInsertInput>;
  chat_users?: Maybe<StudentChatUserArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<StudentChatTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chats" */
export interface StudentChatsMaxOrderBy {
  avatar_url?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "chats" */
export interface StudentChatsMinOrderBy {
  avatar_url?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "chats" */
export interface StudentChatsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentChats>>;
}

/** input type for inserting object relation for remote table "chats" */
export interface StudentChatsObjRelInsertInput {
  data: StudentChatsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentChatsOnConflict>;
}

/** on conflict condition type for table "chats" */
export interface StudentChatsOnConflict {
  constraint: StudentChatsConstraint;
  update_columns?: Array<StudentChatsUpdateColumn>;
  where?: Maybe<StudentChatsBoolExp>;
}

/** Ordering options when selecting data from "chats". */
export interface StudentChatsOrderBy {
  avatar_url?: Maybe<StudentOrderBy>;
  chat_messages_aggregate?: Maybe<StudentChatMessagesAggregateOrderBy>;
  chat_type?: Maybe<StudentChatTypeOrderBy>;
  chat_users_aggregate?: Maybe<StudentChatUserAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  unread_messages?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: chats */
export interface StudentChatsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chats" */
export const enum StudentChatsSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chats" */
export interface StudentChatsSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** update columns of table "chats" */
export const enum StudentChatsUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  TITLE = 'title'
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export interface StudentCitextComparisonExp {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
}

/** columns and relationships of "class_levels" */
export interface StudentClassLevels {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentClasses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  number: EntireFieldWrapper<Scalars['Int']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "class_levels" */
export interface StudentClassLevelsClassesArgs {
  distinct_on?: Maybe<Array<StudentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassesOrderBy>>;
  where?: Maybe<StudentClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_levels". All fields are combined with a logical 'AND'. */
export interface StudentClassLevelsBoolExp {
  _and?: Maybe<Array<StudentClassLevelsBoolExp>>;
  _not?: Maybe<StudentClassLevelsBoolExp>;
  _or?: Maybe<Array<StudentClassLevelsBoolExp>>;
  classes?: Maybe<StudentClassesBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  number?: Maybe<StudentIntComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "class_levels". */
export interface StudentClassLevelsOrderBy {
  classes_aggregate?: Maybe<StudentClassesAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  number?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "class_levels" */
export const enum StudentClassLevelsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "class_type" */
export interface StudentClassType {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentClasses>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "class_type" */
export interface StudentClassTypeClassesArgs {
  distinct_on?: Maybe<Array<StudentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassesOrderBy>>;
  where?: Maybe<StudentClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_type". All fields are combined with a logical 'AND'. */
export interface StudentClassTypeBoolExp {
  _and?: Maybe<Array<StudentClassTypeBoolExp>>;
  _not?: Maybe<StudentClassTypeBoolExp>;
  _or?: Maybe<Array<StudentClassTypeBoolExp>>;
  classes?: Maybe<StudentClassesBoolExp>;
  description?: Maybe<StudentStringComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
}

export const enum StudentClassTypeEnum {
  C = 'C',
  GEISTESWISSENSCHAFTEN = 'Geisteswissenschaften',
  TECHNOLOGIE = 'Technologie'
};

/** Boolean expression to compare columns of type "class_type_enum". All fields are combined with logical 'AND'. */
export interface StudentClassTypeEnumComparisonExp {
  _eq?: Maybe<StudentClassTypeEnum>;
  _in?: Maybe<Array<StudentClassTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentClassTypeEnum>;
  _nin?: Maybe<Array<StudentClassTypeEnum>>;
}

/** Ordering options when selecting data from "class_type". */
export interface StudentClassTypeOrderBy {
  classes_aggregate?: Maybe<StudentClassesAggregateOrderBy>;
  description?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
}

/** select columns of table "class_type" */
export const enum StudentClassTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "classes" */
export interface StudentClasses {
  /** An object relationship */
  class_type: EntireFieldWrapper<StudentClassType>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<StudentCourseClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  identifier?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  level: EntireFieldWrapper<StudentClassLevels>;
  level_id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "class_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentStudents>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentStudentsAggregate>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<StudentClassTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classes" */
export interface StudentClassesCourseClassesArgs {
  distinct_on?: Maybe<Array<StudentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassOrderBy>>;
  where?: Maybe<StudentCourseClassBoolExp>;
}


/** columns and relationships of "classes" */
export interface StudentClassesStudentsArgs {
  distinct_on?: Maybe<Array<StudentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentsOrderBy>>;
  where?: Maybe<StudentStudentsBoolExp>;
}


/** columns and relationships of "classes" */
export interface StudentClassesStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentsOrderBy>>;
  where?: Maybe<StudentStudentsBoolExp>;
}

/** order by aggregate values of table "classes" */
export interface StudentClassesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentClassesMaxOrderBy>;
  min?: Maybe<StudentClassesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export interface StudentClassesBoolExp {
  _and?: Maybe<Array<StudentClassesBoolExp>>;
  _not?: Maybe<StudentClassesBoolExp>;
  _or?: Maybe<Array<StudentClassesBoolExp>>;
  class_type?: Maybe<StudentClassTypeBoolExp>;
  course_classes?: Maybe<StudentCourseClassBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  identifier?: Maybe<StudentStringComparisonExp>;
  level?: Maybe<StudentClassLevelsBoolExp>;
  level_id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  students?: Maybe<StudentStudentsBoolExp>;
  teacher?: Maybe<StudentTeachersBoolExp>;
  teacher_id?: Maybe<StudentUuidComparisonExp>;
  type?: Maybe<StudentClassTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classes" */
export interface StudentClassesMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  identifier?: Maybe<StudentOrderBy>;
  level_id?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "classes" */
export interface StudentClassesMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  identifier?: Maybe<StudentOrderBy>;
  level_id?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "classes". */
export interface StudentClassesOrderBy {
  class_type?: Maybe<StudentClassTypeOrderBy>;
  course_classes_aggregate?: Maybe<StudentCourseClassAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  identifier?: Maybe<StudentOrderBy>;
  level?: Maybe<StudentClassLevelsOrderBy>;
  level_id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  students_aggregate?: Maybe<StudentStudentsAggregateOrderBy>;
  teacher?: Maybe<StudentTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "classes" */
export const enum StudentClassesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IDENTIFIER = 'identifier',
  /** column name */
  LEVEL_ID = 'level_id',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "classrooms" */
export interface StudentClassrooms {
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<StudentCourseClassroom>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  floor: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentLessonsAggregate>;
  name: EntireFieldWrapper<Scalars['String']>;
  room: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classrooms" */
export interface StudentClassroomsCourseClassroomsArgs {
  distinct_on?: Maybe<Array<StudentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassroomOrderBy>>;
  where?: Maybe<StudentCourseClassroomBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentClassroomsLessonsArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentClassroomsLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentClassroomsTeachersArgs {
  distinct_on?: Maybe<Array<StudentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachersOrderBy>>;
  where?: Maybe<StudentTeachersBoolExp>;
}

/** order by aggregate values of table "classrooms" */
export interface StudentClassroomsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentClassroomsMaxOrderBy>;
  min?: Maybe<StudentClassroomsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classrooms". All fields are combined with a logical 'AND'. */
export interface StudentClassroomsBoolExp {
  _and?: Maybe<Array<StudentClassroomsBoolExp>>;
  _not?: Maybe<StudentClassroomsBoolExp>;
  _or?: Maybe<Array<StudentClassroomsBoolExp>>;
  course_classrooms?: Maybe<StudentCourseClassroomBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  floor?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  lessons?: Maybe<StudentLessonsBoolExp>;
  name?: Maybe<StudentStringComparisonExp>;
  room?: Maybe<StudentStringComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  teachers?: Maybe<StudentTeachersBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classrooms" */
export interface StudentClassroomsMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  floor?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  room?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "classrooms" */
export interface StudentClassroomsMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  floor?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  room?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "classrooms". */
export interface StudentClassroomsOrderBy {
  course_classrooms_aggregate?: Maybe<StudentCourseClassroomAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  floor?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lessons_aggregate?: Maybe<StudentLessonsAggregateOrderBy>;
  name?: Maybe<StudentOrderBy>;
  room?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teachers_aggregate?: Maybe<StudentTeachersAggregateOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "classrooms" */
export const enum StudentClassroomsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FLOOR = 'floor',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ROOM = 'room',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_class" */
export interface StudentCourseClass {
  /** An object relationship */
  class: EntireFieldWrapper<StudentClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_class" */
export interface StudentCourseClassAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentCourseClassMaxOrderBy>;
  min?: Maybe<StudentCourseClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_class". All fields are combined with a logical 'AND'. */
export interface StudentCourseClassBoolExp {
  _and?: Maybe<Array<StudentCourseClassBoolExp>>;
  _not?: Maybe<StudentCourseClassBoolExp>;
  _or?: Maybe<Array<StudentCourseClassBoolExp>>;
  class?: Maybe<StudentClassesBoolExp>;
  class_id?: Maybe<StudentUuidComparisonExp>;
  course?: Maybe<StudentCoursesBoolExp>;
  course_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_class" */
export interface StudentCourseClassMaxOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "course_class" */
export interface StudentCourseClassMinOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "course_class". */
export interface StudentCourseClassOrderBy {
  class?: Maybe<StudentClassesOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
  course?: Maybe<StudentCoursesOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "course_class" */
export const enum StudentCourseClassSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_classroom" */
export interface StudentCourseClassroom {
  /** An object relationship */
  classroom: EntireFieldWrapper<StudentClassrooms>;
  classroom_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_classroom" */
export interface StudentCourseClassroomAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentCourseClassroomMaxOrderBy>;
  min?: Maybe<StudentCourseClassroomMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_classroom". All fields are combined with a logical 'AND'. */
export interface StudentCourseClassroomBoolExp {
  _and?: Maybe<Array<StudentCourseClassroomBoolExp>>;
  _not?: Maybe<StudentCourseClassroomBoolExp>;
  _or?: Maybe<Array<StudentCourseClassroomBoolExp>>;
  classroom?: Maybe<StudentClassroomsBoolExp>;
  classroom_id?: Maybe<StudentUuidComparisonExp>;
  course?: Maybe<StudentCoursesBoolExp>;
  course_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_classroom" */
export interface StudentCourseClassroomMaxOrderBy {
  classroom_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "course_classroom" */
export interface StudentCourseClassroomMinOrderBy {
  classroom_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "course_classroom". */
export interface StudentCourseClassroomOrderBy {
  classroom?: Maybe<StudentClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrderBy>;
  course?: Maybe<StudentCoursesOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "course_classroom" */
export const enum StudentCourseClassroomSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_student" */
export interface StudentCourseStudent {
  /** An object relationship */
  course: EntireFieldWrapper<StudentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_student" */
export interface StudentCourseStudentAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentCourseStudentMaxOrderBy>;
  min?: Maybe<StudentCourseStudentMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_student". All fields are combined with a logical 'AND'. */
export interface StudentCourseStudentBoolExp {
  _and?: Maybe<Array<StudentCourseStudentBoolExp>>;
  _not?: Maybe<StudentCourseStudentBoolExp>;
  _or?: Maybe<Array<StudentCourseStudentBoolExp>>;
  course?: Maybe<StudentCoursesBoolExp>;
  course_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_student" */
export interface StudentCourseStudentMaxOrderBy {
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "course_student" */
export interface StudentCourseStudentMinOrderBy {
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "course_student". */
export interface StudentCourseStudentOrderBy {
  course?: Maybe<StudentCoursesOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "course_student" */
export const enum StudentCourseStudentSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_teacher" */
export interface StudentCourseTeacher {
  /** An object relationship */
  course: EntireFieldWrapper<StudentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_primary: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_teacher" */
export interface StudentCourseTeacherAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentCourseTeacherMaxOrderBy>;
  min?: Maybe<StudentCourseTeacherMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_teacher". All fields are combined with a logical 'AND'. */
export interface StudentCourseTeacherBoolExp {
  _and?: Maybe<Array<StudentCourseTeacherBoolExp>>;
  _not?: Maybe<StudentCourseTeacherBoolExp>;
  _or?: Maybe<Array<StudentCourseTeacherBoolExp>>;
  course?: Maybe<StudentCoursesBoolExp>;
  course_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_primary?: Maybe<StudentBooleanComparisonExp>;
  teacher?: Maybe<StudentTeachersBoolExp>;
  teacher_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_teacher" */
export interface StudentCourseTeacherMaxOrderBy {
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "course_teacher" */
export interface StudentCourseTeacherMinOrderBy {
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "course_teacher". */
export interface StudentCourseTeacherOrderBy {
  course?: Maybe<StudentCoursesOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_primary?: Maybe<StudentOrderBy>;
  teacher?: Maybe<StudentTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "course_teacher" */
export const enum StudentCourseTeacherSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRIMARY = 'is_primary',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "courses" */
export interface StudentCourses {
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<StudentBookCourse>>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<StudentCourseClass>>;
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<StudentCourseClassroom>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<StudentCourseTeacher>>;
  /** An array relationship */
  course_users: EntireFieldWrapper<Array<StudentCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_mandatory: EntireFieldWrapper<Scalars['Boolean']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentLessonsAggregate>;
  /** An object relationship */
  semester: EntireFieldWrapper<StudentSemesters>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesBookCoursesArgs {
  distinct_on?: Maybe<Array<StudentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookCourseOrderBy>>;
  where?: Maybe<StudentBookCourseBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesCourseClassesArgs {
  distinct_on?: Maybe<Array<StudentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassOrderBy>>;
  where?: Maybe<StudentCourseClassBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesCourseClassroomsArgs {
  distinct_on?: Maybe<Array<StudentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassroomOrderBy>>;
  where?: Maybe<StudentCourseClassroomBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesCourseTeachersArgs {
  distinct_on?: Maybe<Array<StudentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseTeacherOrderBy>>;
  where?: Maybe<StudentCourseTeacherBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesCourseUsersArgs {
  distinct_on?: Maybe<Array<StudentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseStudentOrderBy>>;
  where?: Maybe<StudentCourseStudentBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesLessonsArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentCoursesLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}

/** order by aggregate values of table "courses" */
export interface StudentCoursesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentCoursesMaxOrderBy>;
  min?: Maybe<StudentCoursesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export interface StudentCoursesBoolExp {
  _and?: Maybe<Array<StudentCoursesBoolExp>>;
  _not?: Maybe<StudentCoursesBoolExp>;
  _or?: Maybe<Array<StudentCoursesBoolExp>>;
  book_courses?: Maybe<StudentBookCourseBoolExp>;
  course_classes?: Maybe<StudentCourseClassBoolExp>;
  course_classrooms?: Maybe<StudentCourseClassroomBoolExp>;
  course_teachers?: Maybe<StudentCourseTeacherBoolExp>;
  course_users?: Maybe<StudentCourseStudentBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  description?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_everybody?: Maybe<StudentBooleanComparisonExp>;
  is_mandatory?: Maybe<StudentBooleanComparisonExp>;
  lessons?: Maybe<StudentLessonsBoolExp>;
  semester?: Maybe<StudentSemestersBoolExp>;
  semester_id?: Maybe<StudentUuidComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "courses" */
export interface StudentCoursesMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "courses" */
export interface StudentCoursesMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "courses". */
export interface StudentCoursesOrderBy {
  book_courses_aggregate?: Maybe<StudentBookCourseAggregateOrderBy>;
  course_classes_aggregate?: Maybe<StudentCourseClassAggregateOrderBy>;
  course_classrooms_aggregate?: Maybe<StudentCourseClassroomAggregateOrderBy>;
  course_teachers_aggregate?: Maybe<StudentCourseTeacherAggregateOrderBy>;
  course_users_aggregate?: Maybe<StudentCourseStudentAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_everybody?: Maybe<StudentOrderBy>;
  is_mandatory?: Maybe<StudentOrderBy>;
  lessons_aggregate?: Maybe<StudentLessonsAggregateOrderBy>;
  semester?: Maybe<StudentSemestersOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "courses" */
export const enum StudentCoursesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_MANDATORY = 'is_mandatory',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export interface StudentDateComparisonExp {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
}

/** columns and relationships of "event_users" */
export interface StudentEventUsers {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  event: EntireFieldWrapper<StudentEvents>;
  event_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  paid?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "event_users". All fields are combined with a logical 'AND'. */
export interface StudentEventUsersBoolExp {
  _and?: Maybe<Array<StudentEventUsersBoolExp>>;
  _not?: Maybe<StudentEventUsersBoolExp>;
  _or?: Maybe<Array<StudentEventUsersBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  event?: Maybe<StudentEventsBoolExp>;
  event_id?: Maybe<StudentUuidComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  paid?: Maybe<StudentBooleanComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "event_users". */
export interface StudentEventUsersOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  event?: Maybe<StudentEventsOrderBy>;
  event_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  paid?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "event_users" */
export const enum StudentEventUsersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENT_ID = 'event_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAID = 'paid',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "events" */
export interface StudentEvents {
  cost: EntireFieldWrapper<Scalars['float8']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export interface StudentEventsBoolExp {
  _and?: Maybe<Array<StudentEventsBoolExp>>;
  _not?: Maybe<StudentEventsBoolExp>;
  _or?: Maybe<Array<StudentEventsBoolExp>>;
  cost?: Maybe<StudentFloat8ComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  date?: Maybe<StudentTimestamptzComparisonExp>;
  description?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  status?: Maybe<StudentStringComparisonExp>;
  time?: Maybe<StudentIntComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "events". */
export interface StudentEventsOrderBy {
  cost?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  date?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  time?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "events" */
export const enum StudentEventsSelectColumn {
  /** column name */
  COST = 'cost',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DATE = 'date',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TIME = 'time',
  /** column name */
  TITLE = 'title',
  /** column name */
  USER_ID = 'user_id'
};

export const enum StudentFileTableTypesEnum {
  ASSIGNMENT_SUBMITS = 'assignment_submits',
  ASSIGNMENTS = 'assignments',
  CHATS = 'chats',
  PROFILE_PICTURES = 'profile_pictures'
};

/** Boolean expression to compare columns of type "file_table_types_enum". All fields are combined with logical 'AND'. */
export interface StudentFileTableTypesEnumComparisonExp {
  _eq?: Maybe<StudentFileTableTypesEnum>;
  _in?: Maybe<Array<StudentFileTableTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentFileTableTypesEnum>;
  _nin?: Maybe<Array<StudentFileTableTypesEnum>>;
}

/** columns and relationships of "files" */
export interface StudentFiles {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  file_name: EntireFieldWrapper<Scalars['String']>;
  foreign_id: EntireFieldWrapper<Scalars['uuid']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  table: EntireFieldWrapper<StudentFileTableTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "files" */
export interface StudentFilesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentFilesMaxOrderBy>;
  min?: Maybe<StudentFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export interface StudentFilesBoolExp {
  _and?: Maybe<Array<StudentFilesBoolExp>>;
  _not?: Maybe<StudentFilesBoolExp>;
  _or?: Maybe<Array<StudentFilesBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  file_name?: Maybe<StudentStringComparisonExp>;
  foreign_id?: Maybe<StudentUuidComparisonExp>;
  hash?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  path?: Maybe<StudentStringComparisonExp>;
  table?: Maybe<StudentFileTableTypesEnumComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "files" */
export interface StudentFilesMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  file_name?: Maybe<StudentOrderBy>;
  foreign_id?: Maybe<StudentOrderBy>;
  hash?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "files" */
export interface StudentFilesMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  file_name?: Maybe<StudentOrderBy>;
  foreign_id?: Maybe<StudentOrderBy>;
  hash?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "files" */
export interface StudentFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentFiles>>;
}

/** Ordering options when selecting data from "files". */
export interface StudentFilesOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  file_name?: Maybe<StudentOrderBy>;
  foreign_id?: Maybe<StudentOrderBy>;
  hash?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  table?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "files" */
export const enum StudentFilesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE_NAME = 'file_name',
  /** column name */
  FOREIGN_ID = 'foreign_id',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TABLE = 'table',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export interface StudentFloat8ComparisonExp {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
}

/** columns and relationships of "grade_types" */
export interface StudentGradeTypes {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentViewGradesAggregate>;
}


/** columns and relationships of "grade_types" */
export interface StudentGradeTypesGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradeTypesOrderBy>>;
  where?: Maybe<StudentGradeTypesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentGradeTypesGradesArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentGradeTypesGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentGradeTypesViewGradesArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentGradeTypesViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}

/** order by aggregate values of table "grade_types" */
export interface StudentGradeTypesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentGradeTypesMaxOrderBy>;
  min?: Maybe<StudentGradeTypesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "grade_types". All fields are combined with a logical 'AND'. */
export interface StudentGradeTypesBoolExp {
  _and?: Maybe<Array<StudentGradeTypesBoolExp>>;
  _not?: Maybe<StudentGradeTypesBoolExp>;
  _or?: Maybe<Array<StudentGradeTypesBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  grade_type?: Maybe<StudentGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentUuidComparisonExp>;
  grade_types?: Maybe<StudentGradeTypesBoolExp>;
  grades?: Maybe<StudentGradesBoolExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  view_grades?: Maybe<StudentViewGradesBoolExp>;
}

/** order by max() on columns of table "grade_types" */
export interface StudentGradeTypesMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "grade_types" */
export interface StudentGradeTypesMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "grade_types". */
export interface StudentGradeTypesOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  grade_type?: Maybe<StudentGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  grade_types_aggregate?: Maybe<StudentGradeTypesAggregateOrderBy>;
  grades_aggregate?: Maybe<StudentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  view_grades_aggregate?: Maybe<StudentViewGradesAggregateOrderBy>;
}

/** select columns of table "grade_types" */
export const enum StudentGradeTypesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "grades" */
export interface StudentGrades {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  weight: EntireFieldWrapper<Scalars['Int']>;
}

/** aggregated selection of "grades" */
export interface StudentGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentGrades>>;
}

/** aggregate fields of "grades" */
export interface StudentGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentGradesVarianceFields>>;
}


/** aggregate fields of "grades" */
export interface StudentGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "grades" */
export interface StudentGradesAggregateOrderBy {
  avg?: Maybe<StudentGradesAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentGradesMaxOrderBy>;
  min?: Maybe<StudentGradesMinOrderBy>;
  stddev?: Maybe<StudentGradesStddevOrderBy>;
  stddev_pop?: Maybe<StudentGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentGradesStddevSampOrderBy>;
  sum?: Maybe<StudentGradesSumOrderBy>;
  var_pop?: Maybe<StudentGradesVarPopOrderBy>;
  var_samp?: Maybe<StudentGradesVarSampOrderBy>;
  variance?: Maybe<StudentGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentGradesAvgFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "grades" */
export interface StudentGradesAvgOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "grades". All fields are combined with a logical 'AND'. */
export interface StudentGradesBoolExp {
  _and?: Maybe<Array<StudentGradesBoolExp>>;
  _not?: Maybe<StudentGradesBoolExp>;
  _or?: Maybe<Array<StudentGradesBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  comment?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  grade_type?: Maybe<StudentGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentUuidComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  mark?: Maybe<StudentMarksBoolExp>;
  mark_id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  weight?: Maybe<StudentIntComparisonExp>;
}

/** aggregate max on columns */
export interface StudentGradesMaxFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "grades" */
export interface StudentGradesMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  mark_id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentGradesMinFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "grades" */
export interface StudentGradesMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  mark_id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "grades". */
export interface StudentGradesOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  grade_type?: Maybe<StudentGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  mark?: Maybe<StudentMarksOrderBy>;
  mark_id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** select columns of table "grades" */
export const enum StudentGradesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface StudentGradesStddevFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "grades" */
export interface StudentGradesStddevOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentGradesStddevPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "grades" */
export interface StudentGradesStddevPopOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentGradesStddevSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "grades" */
export interface StudentGradesStddevSampOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentGradesSumFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "grades" */
export interface StudentGradesSumOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentGradesVarPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "grades" */
export interface StudentGradesVarPopOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentGradesVarSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "grades" */
export interface StudentGradesVarSampOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentGradesVarianceFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "grades" */
export interface StudentGradesVarianceOrderBy {
  weight?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "latest_activities" */
export interface StudentLatestActivities {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  message: EntireFieldWrapper<Scalars['String']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "latest_activities". All fields are combined with a logical 'AND'. */
export interface StudentLatestActivitiesBoolExp {
  _and?: Maybe<Array<StudentLatestActivitiesBoolExp>>;
  _not?: Maybe<StudentLatestActivitiesBoolExp>;
  _or?: Maybe<Array<StudentLatestActivitiesBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  message?: Maybe<StudentStringComparisonExp>;
  path?: Maybe<StudentStringComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "latest_activities". */
export interface StudentLatestActivitiesOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  message?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "latest_activities" */
export const enum StudentLatestActivitiesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  PATH = 'path',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lesson_attendace_type" */
export interface StudentLessonAttendaceType {
  name: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "lesson_attendace_type". All fields are combined with a logical 'AND'. */
export interface StudentLessonAttendaceTypeBoolExp {
  _and?: Maybe<Array<StudentLessonAttendaceTypeBoolExp>>;
  _not?: Maybe<StudentLessonAttendaceTypeBoolExp>;
  _or?: Maybe<Array<StudentLessonAttendaceTypeBoolExp>>;
  name?: Maybe<StudentStringComparisonExp>;
}

/** Ordering options when selecting data from "lesson_attendace_type". */
export interface StudentLessonAttendaceTypeOrderBy {
  name?: Maybe<StudentOrderBy>;
}

/** select columns of table "lesson_attendace_type" */
export const enum StudentLessonAttendaceTypeSelectColumn {
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "lesson_attendances" */
export interface StudentLessonAttendances {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  lesson: EntireFieldWrapper<StudentLessons>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "lesson_attendances" */
export interface StudentLessonAttendancesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentLessonAttendancesMaxOrderBy>;
  min?: Maybe<StudentLessonAttendancesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "lesson_attendances". All fields are combined with a logical 'AND'. */
export interface StudentLessonAttendancesBoolExp {
  _and?: Maybe<Array<StudentLessonAttendancesBoolExp>>;
  _not?: Maybe<StudentLessonAttendancesBoolExp>;
  _or?: Maybe<Array<StudentLessonAttendancesBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  lesson?: Maybe<StudentLessonsBoolExp>;
  lesson_id?: Maybe<StudentUuidComparisonExp>;
  type?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "lesson_attendances" */
export interface StudentLessonAttendancesMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "lesson_attendances" */
export interface StudentLessonAttendancesMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "lesson_attendances". */
export interface StudentLessonAttendancesOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lesson?: Maybe<StudentLessonsOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "lesson_attendances" */
export const enum StudentLessonAttendancesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lessons" */
export interface StudentLessons {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentAssignmentsAggregate>;
  /** An array relationship */
  attendaces: EntireFieldWrapper<Array<StudentLessonAttendances>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<StudentClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_online: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_classes?: EntireFieldWrapper<Maybe<StudentLiveClasses>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "lessons" */
export interface StudentLessonsAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface StudentLessonsAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface StudentLessonsAttendacesArgs {
  distinct_on?: Maybe<Array<StudentLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonAttendancesOrderBy>>;
  where?: Maybe<StudentLessonAttendancesBoolExp>;
}

/** aggregated selection of "lessons" */
export interface StudentLessonsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentLessonsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentLessons>>;
}

/** aggregate fields of "lessons" */
export interface StudentLessonsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentLessonsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentLessonsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentLessonsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentLessonsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentLessonsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentLessonsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentLessonsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentLessonsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentLessonsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentLessonsVarianceFields>>;
}


/** aggregate fields of "lessons" */
export interface StudentLessonsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentLessonsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "lessons" */
export interface StudentLessonsAggregateOrderBy {
  avg?: Maybe<StudentLessonsAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentLessonsMaxOrderBy>;
  min?: Maybe<StudentLessonsMinOrderBy>;
  stddev?: Maybe<StudentLessonsStddevOrderBy>;
  stddev_pop?: Maybe<StudentLessonsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentLessonsStddevSampOrderBy>;
  sum?: Maybe<StudentLessonsSumOrderBy>;
  var_pop?: Maybe<StudentLessonsVarPopOrderBy>;
  var_samp?: Maybe<StudentLessonsVarSampOrderBy>;
  variance?: Maybe<StudentLessonsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentLessonsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "lessons" */
export interface StudentLessonsAvgOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export interface StudentLessonsBoolExp {
  _and?: Maybe<Array<StudentLessonsBoolExp>>;
  _not?: Maybe<StudentLessonsBoolExp>;
  _or?: Maybe<Array<StudentLessonsBoolExp>>;
  assignments?: Maybe<StudentAssignmentsBoolExp>;
  attendaces?: Maybe<StudentLessonAttendancesBoolExp>;
  classroom?: Maybe<StudentClassroomsBoolExp>;
  classroom_id?: Maybe<StudentUuidComparisonExp>;
  course?: Maybe<StudentCoursesBoolExp>;
  course_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  description?: Maybe<StudentStringComparisonExp>;
  duration?: Maybe<StudentIntComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_online?: Maybe<StudentBooleanComparisonExp>;
  live_classes?: Maybe<StudentLiveClassesBoolExp>;
  start_at?: Maybe<StudentTimetzComparisonExp>;
  start_date?: Maybe<StudentDateComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentLessonsMaxFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "lessons" */
export interface StudentLessonsMaxOrderBy {
  classroom_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  start_at?: Maybe<StudentOrderBy>;
  start_date?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentLessonsMinFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "lessons" */
export interface StudentLessonsMinOrderBy {
  classroom_id?: Maybe<StudentOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  start_at?: Maybe<StudentOrderBy>;
  start_date?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "lessons". */
export interface StudentLessonsOrderBy {
  assignments_aggregate?: Maybe<StudentAssignmentsAggregateOrderBy>;
  attendaces_aggregate?: Maybe<StudentLessonAttendancesAggregateOrderBy>;
  classroom?: Maybe<StudentClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrderBy>;
  course?: Maybe<StudentCoursesOrderBy>;
  course_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_online?: Maybe<StudentOrderBy>;
  live_classes?: Maybe<StudentLiveClassesOrderBy>;
  start_at?: Maybe<StudentOrderBy>;
  start_date?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "lessons" */
export const enum StudentLessonsSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ONLINE = 'is_online',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface StudentLessonsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "lessons" */
export interface StudentLessonsStddevOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentLessonsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "lessons" */
export interface StudentLessonsStddevPopOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentLessonsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "lessons" */
export interface StudentLessonsStddevSampOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentLessonsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "lessons" */
export interface StudentLessonsSumOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentLessonsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "lessons" */
export interface StudentLessonsVarPopOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentLessonsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "lessons" */
export interface StudentLessonsVarSampOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentLessonsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "lessons" */
export interface StudentLessonsVarianceOrderBy {
  duration?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "live_class_attendees" */
export interface StudentLiveClassAttendees {
  group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_present: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_class: EntireFieldWrapper<StudentLiveClasses>;
  live_class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  students?: EntireFieldWrapper<Maybe<StudentStudents>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "live_class_attendees" */
export interface StudentLiveClassAttendeesAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentLiveClassAttendeesMaxOrderBy>;
  min?: Maybe<StudentLiveClassAttendeesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "live_class_attendees". All fields are combined with a logical 'AND'. */
export interface StudentLiveClassAttendeesBoolExp {
  _and?: Maybe<Array<StudentLiveClassAttendeesBoolExp>>;
  _not?: Maybe<StudentLiveClassAttendeesBoolExp>;
  _or?: Maybe<Array<StudentLiveClassAttendeesBoolExp>>;
  group_id?: Maybe<StudentUuidComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_present?: Maybe<StudentBooleanComparisonExp>;
  live_class?: Maybe<StudentLiveClassesBoolExp>;
  live_class_id?: Maybe<StudentUuidComparisonExp>;
  students?: Maybe<StudentStudentsBoolExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "live_class_attendees" */
export interface StudentLiveClassAttendeesMaxOrderBy {
  group_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  live_class_id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "live_class_attendees" */
export interface StudentLiveClassAttendeesMinOrderBy {
  group_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  live_class_id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "live_class_attendees". */
export interface StudentLiveClassAttendeesOrderBy {
  group_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_present?: Maybe<StudentOrderBy>;
  live_class?: Maybe<StudentLiveClassesOrderBy>;
  live_class_id?: Maybe<StudentOrderBy>;
  students?: Maybe<StudentStudentsOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "live_class_attendees" */
export const enum StudentLiveClassAttendeesSelectColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRESENT = 'is_present',
  /** column name */
  LIVE_CLASS_ID = 'live_class_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "live_classes" */
export interface StudentLiveClasses {
  attendeePW: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<StudentLiveClassAttendees>>;
  meetingID: EntireFieldWrapper<Scalars['String']>;
  moderatorPW: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}


/** columns and relationships of "live_classes" */
export interface StudentLiveClassesLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<StudentLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLiveClassAttendeesOrderBy>>;
  where?: Maybe<StudentLiveClassAttendeesBoolExp>;
}

/** Boolean expression to filter rows from the table "live_classes". All fields are combined with a logical 'AND'. */
export interface StudentLiveClassesBoolExp {
  _and?: Maybe<Array<StudentLiveClassesBoolExp>>;
  _not?: Maybe<StudentLiveClassesBoolExp>;
  _or?: Maybe<Array<StudentLiveClassesBoolExp>>;
  attendeePW?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  description?: Maybe<StudentStringComparisonExp>;
  duration?: Maybe<StudentIntComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  lesson_id?: Maybe<StudentUuidComparisonExp>;
  live_class_attendees?: Maybe<StudentLiveClassAttendeesBoolExp>;
  meetingID?: Maybe<StudentStringComparisonExp>;
  moderatorPW?: Maybe<StudentStringComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  recording_private_id?: Maybe<StudentIntComparisonExp>;
  starting_at?: Maybe<StudentTimestamptzComparisonExp>;
  status?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  voice_bridge?: Maybe<StudentStringComparisonExp>;
}

/** Ordering options when selecting data from "live_classes". */
export interface StudentLiveClassesOrderBy {
  attendeePW?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  description?: Maybe<StudentOrderBy>;
  duration?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  live_class_attendees_aggregate?: Maybe<StudentLiveClassAttendeesAggregateOrderBy>;
  meetingID?: Maybe<StudentOrderBy>;
  moderatorPW?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  recording_private_id?: Maybe<StudentOrderBy>;
  starting_at?: Maybe<StudentOrderBy>;
  status?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  voice_bridge?: Maybe<StudentOrderBy>;
}

/** select columns of table "live_classes" */
export const enum StudentLiveClassesSelectColumn {
  /** column name */
  ATTENDEEPW = 'attendeePW',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  MEETINGID = 'meetingID',
  /** column name */
  MODERATORPW = 'moderatorPW',
  /** column name */
  NAME = 'name',
  /** column name */
  RECORDING_PRIVATE_ID = 'recording_private_id',
  /** column name */
  STARTING_AT = 'starting_at',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VOICE_BRIDGE = 'voice_bridge'
};

/** columns and relationships of "marks" */
export interface StudentMarks {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  value: EntireFieldWrapper<Scalars['Int']>;
}


/** columns and relationships of "marks" */
export interface StudentMarksGradesArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


/** columns and relationships of "marks" */
export interface StudentMarksGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}

/** Boolean expression to filter rows from the table "marks". All fields are combined with a logical 'AND'. */
export interface StudentMarksBoolExp {
  _and?: Maybe<Array<StudentMarksBoolExp>>;
  _not?: Maybe<StudentMarksBoolExp>;
  _or?: Maybe<Array<StudentMarksBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  grades?: Maybe<StudentGradesBoolExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  value?: Maybe<StudentIntComparisonExp>;
}

/** Ordering options when selecting data from "marks". */
export interface StudentMarksOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  grades_aggregate?: Maybe<StudentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
}

/** select columns of table "marks" */
export const enum StudentMarksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "meeting_user" */
export interface StudentMeetingUser {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  meeting_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "meeting_user" */
export interface StudentMeetingUserAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentMeetingUserAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentMeetingUser>>;
}

/** aggregate fields of "meeting_user" */
export interface StudentMeetingUserAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentMeetingUserMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentMeetingUserMinFields>>;
}


/** aggregate fields of "meeting_user" */
export interface StudentMeetingUserAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentMeetingUserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "meeting_user". All fields are combined with a logical 'AND'. */
export interface StudentMeetingUserBoolExp {
  _and?: Maybe<Array<StudentMeetingUserBoolExp>>;
  _not?: Maybe<StudentMeetingUserBoolExp>;
  _or?: Maybe<Array<StudentMeetingUserBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  meeting_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentMeetingUserMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentMeetingUserMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "meeting_user". */
export interface StudentMeetingUserOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  meeting_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "meeting_user" */
export const enum StudentMeetingUserSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MEETING_ID = 'meeting_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** mutation root */
export interface StudentMutationRoot {
  change_password?: EntireFieldWrapper<Maybe<StudentMessageResponse>>;
  /** delete data from the table: "assignment_discussion" */
  delete_assignment_discussion?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionMutationResponse>>;
  /** delete single row from the table: "assignment_discussion" */
  delete_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussion>>;
  /** delete data from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContentMutationResponse>>;
  /** delete single row from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContent>>;
  /** delete data from the table: "assignment_files" */
  delete_assignment_files?: EntireFieldWrapper<Maybe<StudentAssignmentFilesMutationResponse>>;
  /** delete single row from the table: "assignment_files" */
  delete_assignment_files_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentFiles>>;
  /** delete data from the table: "assignment_notes" */
  delete_assignment_notes?: EntireFieldWrapper<Maybe<StudentAssignmentNotesMutationResponse>>;
  /** delete single row from the table: "assignment_notes" */
  delete_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentNotes>>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: EntireFieldWrapper<Maybe<StudentAuthAccountProvidersMutationResponse>>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccountProviders>>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: EntireFieldWrapper<Maybe<StudentAuthAccountRolesMutationResponse>>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccountRoles>>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: EntireFieldWrapper<Maybe<StudentAuthAccountsMutationResponse>>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccounts>>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: EntireFieldWrapper<Maybe<StudentAuthProvidersMutationResponse>>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentAuthProviders>>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokensMutationResponse>>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokens>>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: EntireFieldWrapper<Maybe<StudentAuthRolesMutationResponse>>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentAuthRoles>>;
  /** delete data from the table: "chapter_section_notes" */
  delete_chapter_section_notes?: EntireFieldWrapper<Maybe<StudentChapterSectionNotesMutationResponse>>;
  /** delete single row from the table: "chapter_section_notes" */
  delete_chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionNotes>>;
  /** delete data from the table: "chapter_section_submits" */
  delete_chapter_section_submits?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmitsMutationResponse>>;
  /** delete single row from the table: "chapter_section_submits" */
  delete_chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmits>>;
  /** delete data from the table: "chat_message_likes" */
  delete_chat_message_likes?: EntireFieldWrapper<Maybe<StudentChatMessageLikesMutationResponse>>;
  /** delete single row from the table: "chat_message_likes" */
  delete_chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessageLikes>>;
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: EntireFieldWrapper<Maybe<StudentChatMessagesMutationResponse>>;
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  /** delete data from the table: "chats" */
  delete_chats?: EntireFieldWrapper<Maybe<StudentChatsMutationResponse>>;
  /** delete single row from the table: "chats" */
  delete_chats_by_pk?: EntireFieldWrapper<Maybe<StudentChats>>;
  /** delete data from the table: "files" */
  delete_files?: EntireFieldWrapper<Maybe<StudentFilesMutationResponse>>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: EntireFieldWrapper<Maybe<StudentFiles>>;
  /** delete data from the table: "private.adresses" */
  delete_private_adresses?: EntireFieldWrapper<Maybe<StudentPrivateAdressesMutationResponse>>;
  /** delete single row from the table: "private.adresses" */
  delete_private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateAdresses>>;
  /** delete data from the table: "private.birthdays" */
  delete_private_birthdays?: EntireFieldWrapper<Maybe<StudentPrivateBirthdaysMutationResponse>>;
  /** delete single row from the table: "private.birthdays" */
  delete_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateBirthdays>>;
  /** delete data from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbersMutationResponse>>;
  /** delete single row from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbers>>;
  /** delete data from the table: "private.phone_numbers" */
  delete_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbersMutationResponse>>;
  /** delete single row from the table: "private.phone_numbers" */
  delete_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbers>>;
  /** delete data from the table: "relationships" */
  delete_relationships?: EntireFieldWrapper<Maybe<StudentRelationshipsMutationResponse>>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: EntireFieldWrapper<Maybe<StudentRelationships>>;
  /** delete data from the table: "school_settings" */
  delete_school_settings?: EntireFieldWrapper<Maybe<StudentSchoolSettingsMutationResponse>>;
  /** delete single row from the table: "school_settings" */
  delete_school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentSchoolSettings>>;
  /** delete data from the table: "school_settings_modules" */
  delete_school_settings_modules?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModulesMutationResponse>>;
  /** delete single row from the table: "school_settings_modules" */
  delete_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModules>>;
  /** delete data from the table: "schools" */
  delete_schools?: EntireFieldWrapper<Maybe<StudentSchoolsMutationResponse>>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: EntireFieldWrapper<Maybe<StudentSchools>>;
  /** delete data from the table: "tasks" */
  delete_tasks?: EntireFieldWrapper<Maybe<StudentTasksMutationResponse>>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: EntireFieldWrapper<Maybe<StudentTasks>>;
  /** delete data from the table: "users" */
  delete_users?: EntireFieldWrapper<Maybe<StudentUsersMutationResponse>>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: EntireFieldWrapper<Maybe<StudentUsers>>;
  /** insert data into the table: "assignment_discussion" */
  insert_assignment_discussion?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionMutationResponse>>;
  /** insert data into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContentMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content_one?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContent>>;
  /** insert a single row into the table: "assignment_discussion" */
  insert_assignment_discussion_one?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussion>>;
  /** insert data into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionSubscriptionMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription_one?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionSubscription>>;
  /** insert data into the table: "assignment_files" */
  insert_assignment_files?: EntireFieldWrapper<Maybe<StudentAssignmentFilesMutationResponse>>;
  /** insert a single row into the table: "assignment_files" */
  insert_assignment_files_one?: EntireFieldWrapper<Maybe<StudentAssignmentFiles>>;
  /** insert data into the table: "assignment_notes" */
  insert_assignment_notes?: EntireFieldWrapper<Maybe<StudentAssignmentNotesMutationResponse>>;
  /** insert a single row into the table: "assignment_notes" */
  insert_assignment_notes_one?: EntireFieldWrapper<Maybe<StudentAssignmentNotes>>;
  /** insert data into the table: "assignment_question_answers" */
  insert_assignment_question_answers?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionAnswersMutationResponse>>;
  /** insert a single row into the table: "assignment_question_answers" */
  insert_assignment_question_answers_one?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionAnswers>>;
  /** insert data into the table: "assignment_submits" */
  insert_assignment_submits?: EntireFieldWrapper<Maybe<StudentAssignmentSubmitsMutationResponse>>;
  /** insert a single row into the table: "assignment_submits" */
  insert_assignment_submits_one?: EntireFieldWrapper<Maybe<StudentAssignmentSubmits>>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: EntireFieldWrapper<Maybe<StudentAuthAccountProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: EntireFieldWrapper<Maybe<StudentAuthAccountProviders>>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: EntireFieldWrapper<Maybe<StudentAuthAccountRolesMutationResponse>>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: EntireFieldWrapper<Maybe<StudentAuthAccountRoles>>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: EntireFieldWrapper<Maybe<StudentAuthAccountsMutationResponse>>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: EntireFieldWrapper<Maybe<StudentAuthAccounts>>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: EntireFieldWrapper<Maybe<StudentAuthProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: EntireFieldWrapper<Maybe<StudentAuthProviders>>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokensMutationResponse>>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokens>>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: EntireFieldWrapper<Maybe<StudentAuthRolesMutationResponse>>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: EntireFieldWrapper<Maybe<StudentAuthRoles>>;
  /** insert data into the table: "chapter_section_notes" */
  insert_chapter_section_notes?: EntireFieldWrapper<Maybe<StudentChapterSectionNotesMutationResponse>>;
  /** insert a single row into the table: "chapter_section_notes" */
  insert_chapter_section_notes_one?: EntireFieldWrapper<Maybe<StudentChapterSectionNotes>>;
  /** insert data into the table: "chapter_section_submits" */
  insert_chapter_section_submits?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmitsMutationResponse>>;
  /** insert a single row into the table: "chapter_section_submits" */
  insert_chapter_section_submits_one?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmits>>;
  /** insert data into the table: "chat_message_likes" */
  insert_chat_message_likes?: EntireFieldWrapper<Maybe<StudentChatMessageLikesMutationResponse>>;
  /** insert a single row into the table: "chat_message_likes" */
  insert_chat_message_likes_one?: EntireFieldWrapper<Maybe<StudentChatMessageLikes>>;
  /** insert data into the table: "chat_message_reads" */
  insert_chat_message_reads?: EntireFieldWrapper<Maybe<StudentChatMessageReadsMutationResponse>>;
  /** insert a single row into the table: "chat_message_reads" */
  insert_chat_message_reads_one?: EntireFieldWrapper<Maybe<StudentChatMessageReads>>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: EntireFieldWrapper<Maybe<StudentChatMessagesMutationResponse>>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  /** insert data into the table: "chat_user" */
  insert_chat_user?: EntireFieldWrapper<Maybe<StudentChatUserMutationResponse>>;
  /** insert a single row into the table: "chat_user" */
  insert_chat_user_one?: EntireFieldWrapper<Maybe<StudentChatUser>>;
  /** insert data into the table: "chats" */
  insert_chats?: EntireFieldWrapper<Maybe<StudentChatsMutationResponse>>;
  /** insert a single row into the table: "chats" */
  insert_chats_one?: EntireFieldWrapper<Maybe<StudentChats>>;
  /** insert data into the table: "notifications" */
  insert_notifications?: EntireFieldWrapper<Maybe<StudentNotificationsMutationResponse>>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: EntireFieldWrapper<Maybe<StudentNotifications>>;
  /** insert data into the table: "private.adresses" */
  insert_private_adresses?: EntireFieldWrapper<Maybe<StudentPrivateAdressesMutationResponse>>;
  /** insert a single row into the table: "private.adresses" */
  insert_private_adresses_one?: EntireFieldWrapper<Maybe<StudentPrivateAdresses>>;
  /** insert data into the table: "private.birthdays" */
  insert_private_birthdays?: EntireFieldWrapper<Maybe<StudentPrivateBirthdaysMutationResponse>>;
  /** insert a single row into the table: "private.birthdays" */
  insert_private_birthdays_one?: EntireFieldWrapper<Maybe<StudentPrivateBirthdays>>;
  /** insert data into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbersMutationResponse>>;
  /** insert a single row into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers_one?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbers>>;
  /** insert data into the table: "private.phone_numbers" */
  insert_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbersMutationResponse>>;
  /** insert a single row into the table: "private.phone_numbers" */
  insert_private_phone_numbers_one?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbers>>;
  /** insert data into the table: "relationships" */
  insert_relationships?: EntireFieldWrapper<Maybe<StudentRelationshipsMutationResponse>>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: EntireFieldWrapper<Maybe<StudentRelationships>>;
  /** insert data into the table: "school_settings" */
  insert_school_settings?: EntireFieldWrapper<Maybe<StudentSchoolSettingsMutationResponse>>;
  /** insert data into the table: "school_settings_modules" */
  insert_school_settings_modules?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModulesMutationResponse>>;
  /** insert a single row into the table: "school_settings_modules" */
  insert_school_settings_modules_one?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModules>>;
  /** insert a single row into the table: "school_settings" */
  insert_school_settings_one?: EntireFieldWrapper<Maybe<StudentSchoolSettings>>;
  /** insert data into the table: "schools" */
  insert_schools?: EntireFieldWrapper<Maybe<StudentSchoolsMutationResponse>>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: EntireFieldWrapper<Maybe<StudentSchools>>;
  /** insert data into the table: "tasks" */
  insert_tasks?: EntireFieldWrapper<Maybe<StudentTasksMutationResponse>>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: EntireFieldWrapper<Maybe<StudentTasks>>;
  /** insert data into the table: "users" */
  insert_users?: EntireFieldWrapper<Maybe<StudentUsersMutationResponse>>;
  /** insert a single row into the table: "users" */
  insert_users_one?: EntireFieldWrapper<Maybe<StudentUsers>>;
  lost_password?: EntireFieldWrapper<Maybe<StudentMessageResponse>>;
  refresh_token?: EntireFieldWrapper<Maybe<StudentSession>>;
  reset_password?: EntireFieldWrapper<Maybe<StudentMessageResponse>>;
  revoke_token?: EntireFieldWrapper<Maybe<StudentMessageResponse>>;
  studentJoin?: EntireFieldWrapper<Maybe<StudentBbbJoinLink>>;
  /** update data of the table: "assignment_discussion" */
  update_assignment_discussion?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionMutationResponse>>;
  /** update single row of the table: "assignment_discussion" */
  update_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussion>>;
  /** update data of the table: "assignment_discussion_content" */
  update_assignment_discussion_content?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContentMutationResponse>>;
  /** update single row of the table: "assignment_discussion_content" */
  update_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContent>>;
  /** update data of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionSubscriptionMutationResponse>>;
  /** update single row of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionSubscription>>;
  /** update data of the table: "assignment_notes" */
  update_assignment_notes?: EntireFieldWrapper<Maybe<StudentAssignmentNotesMutationResponse>>;
  /** update single row of the table: "assignment_notes" */
  update_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentNotes>>;
  /** update data of the table: "assignment_submits" */
  update_assignment_submits?: EntireFieldWrapper<Maybe<StudentAssignmentSubmitsMutationResponse>>;
  /** update single row of the table: "assignment_submits" */
  update_assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentSubmits>>;
  /** update data of the table: "assignment_user" */
  update_assignment_user?: EntireFieldWrapper<Maybe<StudentAssignmentUserMutationResponse>>;
  /** update single row of the table: "assignment_user" */
  update_assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentUser>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: EntireFieldWrapper<Maybe<StudentAuthAccountProvidersMutationResponse>>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccountProviders>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: EntireFieldWrapper<Maybe<StudentAuthAccountRolesMutationResponse>>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccountRoles>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: EntireFieldWrapper<Maybe<StudentAuthAccountsMutationResponse>>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccounts>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: EntireFieldWrapper<Maybe<StudentAuthProvidersMutationResponse>>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentAuthProviders>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokensMutationResponse>>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokens>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: EntireFieldWrapper<Maybe<StudentAuthRolesMutationResponse>>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentAuthRoles>>;
  /** update data of the table: "chapter_section_notes" */
  update_chapter_section_notes?: EntireFieldWrapper<Maybe<StudentChapterSectionNotesMutationResponse>>;
  /** update single row of the table: "chapter_section_notes" */
  update_chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionNotes>>;
  /** update data of the table: "chapter_section_submits" */
  update_chapter_section_submits?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmitsMutationResponse>>;
  /** update single row of the table: "chapter_section_submits" */
  update_chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmits>>;
  /** update data of the table: "chat_message_reads" */
  update_chat_message_reads?: EntireFieldWrapper<Maybe<StudentChatMessageReadsMutationResponse>>;
  /** update single row of the table: "chat_message_reads" */
  update_chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessageReads>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: EntireFieldWrapper<Maybe<StudentChatMessagesMutationResponse>>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  /** update data of the table: "chats" */
  update_chats?: EntireFieldWrapper<Maybe<StudentChatsMutationResponse>>;
  /** update single row of the table: "chats" */
  update_chats_by_pk?: EntireFieldWrapper<Maybe<StudentChats>>;
  /** update data of the table: "notifications" */
  update_notifications?: EntireFieldWrapper<Maybe<StudentNotificationsMutationResponse>>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: EntireFieldWrapper<Maybe<StudentNotifications>>;
  /** update data of the table: "private.adresses" */
  update_private_adresses?: EntireFieldWrapper<Maybe<StudentPrivateAdressesMutationResponse>>;
  /** update single row of the table: "private.adresses" */
  update_private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateAdresses>>;
  /** update data of the table: "private.birthdays" */
  update_private_birthdays?: EntireFieldWrapper<Maybe<StudentPrivateBirthdaysMutationResponse>>;
  /** update single row of the table: "private.birthdays" */
  update_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateBirthdays>>;
  /** update data of the table: "private.insurance_numbers" */
  update_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbersMutationResponse>>;
  /** update single row of the table: "private.insurance_numbers" */
  update_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbers>>;
  /** update data of the table: "private.phone_numbers" */
  update_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbersMutationResponse>>;
  /** update single row of the table: "private.phone_numbers" */
  update_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbers>>;
  /** update data of the table: "relationships" */
  update_relationships?: EntireFieldWrapper<Maybe<StudentRelationshipsMutationResponse>>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: EntireFieldWrapper<Maybe<StudentRelationships>>;
  /** update data of the table: "school_settings" */
  update_school_settings?: EntireFieldWrapper<Maybe<StudentSchoolSettingsMutationResponse>>;
  /** update single row of the table: "school_settings" */
  update_school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentSchoolSettings>>;
  /** update data of the table: "school_settings_modules" */
  update_school_settings_modules?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModulesMutationResponse>>;
  /** update single row of the table: "school_settings_modules" */
  update_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModules>>;
  /** update data of the table: "schools" */
  update_schools?: EntireFieldWrapper<Maybe<StudentSchoolsMutationResponse>>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: EntireFieldWrapper<Maybe<StudentSchools>>;
  /** update data of the table: "tasks" */
  update_tasks?: EntireFieldWrapper<Maybe<StudentTasksMutationResponse>>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: EntireFieldWrapper<Maybe<StudentTasks>>;
  /** update data of the table: "users" */
  update_users?: EntireFieldWrapper<Maybe<StudentUsersMutationResponse>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: EntireFieldWrapper<Maybe<StudentUsers>>;
}


/** mutation root */
export interface StudentMutationRootChangePasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentDiscussionArgs {
  where: StudentAssignmentDiscussionBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentDiscussionContentArgs {
  where: StudentAssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentFilesArgs {
  where: StudentAssignmentFilesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentNotesArgs {
  where: StudentAssignmentNotesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAuthAccountProvidersArgs {
  where: StudentAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAuthAccountRolesArgs {
  where: StudentAuthAccountRolesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAuthAccountsArgs {
  where: StudentAuthAccountsBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAuthProvidersArgs {
  where: StudentAuthProvidersBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootDeleteAuthRefreshTokensArgs {
  where: StudentAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteAuthRolesArgs {
  where: StudentAuthRolesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteAuthRolesByPkArgs {
  role: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootDeleteChapterSectionNotesArgs {
  where: StudentChapterSectionNotesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteChapterSectionSubmitsArgs {
  where: StudentChapterSectionSubmitsBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteChatMessageLikesArgs {
  where: StudentChatMessageLikesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteChatMessagesArgs {
  where: StudentChatMessagesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteChatsArgs {
  where: StudentChatsBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteChatsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteFilesArgs {
  where: StudentFilesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeletePrivateAdressesArgs {
  where: StudentPrivateAdressesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeletePrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeletePrivateBirthdaysArgs {
  where: StudentPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeletePrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeletePrivateInsuranceNumbersArgs {
  where: StudentPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeletePrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeletePrivatePhoneNumbersArgs {
  where: StudentPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeletePrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteRelationshipsArgs {
  where: StudentRelationshipsBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteSchoolSettingsArgs {
  where: StudentSchoolSettingsBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteSchoolSettingsModulesArgs {
  where: StudentSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteSchoolsArgs {
  where: StudentSchoolsBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteSchoolsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteTasksArgs {
  where: StudentTasksBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteTasksByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootDeleteUsersArgs {
  where: StudentUsersBoolExp;
}


/** mutation root */
export interface StudentMutationRootDeleteUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentDiscussionArgs {
  objects: Array<StudentAssignmentDiscussionInsertInput>;
  on_conflict?: Maybe<StudentAssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentDiscussionContentArgs {
  objects: Array<StudentAssignmentDiscussionContentInsertInput>;
  on_conflict?: Maybe<StudentAssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentDiscussionContentOneArgs {
  object: StudentAssignmentDiscussionContentInsertInput;
  on_conflict?: Maybe<StudentAssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentDiscussionOneArgs {
  object: StudentAssignmentDiscussionInsertInput;
  on_conflict?: Maybe<StudentAssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentDiscussionSubscriptionArgs {
  objects: Array<StudentAssignmentDiscussionSubscriptionInsertInput>;
  on_conflict?: Maybe<StudentAssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentDiscussionSubscriptionOneArgs {
  object: StudentAssignmentDiscussionSubscriptionInsertInput;
  on_conflict?: Maybe<StudentAssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentFilesArgs {
  objects: Array<StudentAssignmentFilesInsertInput>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentFilesOneArgs {
  object: StudentAssignmentFilesInsertInput;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentNotesArgs {
  objects: Array<StudentAssignmentNotesInsertInput>;
  on_conflict?: Maybe<StudentAssignmentNotesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentNotesOneArgs {
  object: StudentAssignmentNotesInsertInput;
  on_conflict?: Maybe<StudentAssignmentNotesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentQuestionAnswersArgs {
  objects: Array<StudentAssignmentQuestionAnswersInsertInput>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentQuestionAnswersOneArgs {
  object: StudentAssignmentQuestionAnswersInsertInput;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentSubmitsArgs {
  objects: Array<StudentAssignmentSubmitsInsertInput>;
  on_conflict?: Maybe<StudentAssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAssignmentSubmitsOneArgs {
  object: StudentAssignmentSubmitsInsertInput;
  on_conflict?: Maybe<StudentAssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthAccountProvidersArgs {
  objects: Array<StudentAuthAccountProvidersInsertInput>;
  on_conflict?: Maybe<StudentAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthAccountProvidersOneArgs {
  object: StudentAuthAccountProvidersInsertInput;
  on_conflict?: Maybe<StudentAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthAccountRolesArgs {
  objects: Array<StudentAuthAccountRolesInsertInput>;
  on_conflict?: Maybe<StudentAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthAccountRolesOneArgs {
  object: StudentAuthAccountRolesInsertInput;
  on_conflict?: Maybe<StudentAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthAccountsArgs {
  objects: Array<StudentAuthAccountsInsertInput>;
  on_conflict?: Maybe<StudentAuthAccountsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthAccountsOneArgs {
  object: StudentAuthAccountsInsertInput;
  on_conflict?: Maybe<StudentAuthAccountsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthProvidersArgs {
  objects: Array<StudentAuthProvidersInsertInput>;
  on_conflict?: Maybe<StudentAuthProvidersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthProvidersOneArgs {
  object: StudentAuthProvidersInsertInput;
  on_conflict?: Maybe<StudentAuthProvidersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthRefreshTokensArgs {
  objects: Array<StudentAuthRefreshTokensInsertInput>;
  on_conflict?: Maybe<StudentAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthRefreshTokensOneArgs {
  object: StudentAuthRefreshTokensInsertInput;
  on_conflict?: Maybe<StudentAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthRolesArgs {
  objects: Array<StudentAuthRolesInsertInput>;
  on_conflict?: Maybe<StudentAuthRolesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertAuthRolesOneArgs {
  object: StudentAuthRolesInsertInput;
  on_conflict?: Maybe<StudentAuthRolesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChapterSectionNotesArgs {
  objects: Array<StudentChapterSectionNotesInsertInput>;
  on_conflict?: Maybe<StudentChapterSectionNotesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChapterSectionNotesOneArgs {
  object: StudentChapterSectionNotesInsertInput;
  on_conflict?: Maybe<StudentChapterSectionNotesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChapterSectionSubmitsArgs {
  objects: Array<StudentChapterSectionSubmitsInsertInput>;
  on_conflict?: Maybe<StudentChapterSectionSubmitsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChapterSectionSubmitsOneArgs {
  object: StudentChapterSectionSubmitsInsertInput;
  on_conflict?: Maybe<StudentChapterSectionSubmitsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChatMessageLikesArgs {
  objects: Array<StudentChatMessageLikesInsertInput>;
}


/** mutation root */
export interface StudentMutationRootInsertChatMessageLikesOneArgs {
  object: StudentChatMessageLikesInsertInput;
}


/** mutation root */
export interface StudentMutationRootInsertChatMessageReadsArgs {
  objects: Array<StudentChatMessageReadsInsertInput>;
  on_conflict?: Maybe<StudentChatMessageReadsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChatMessageReadsOneArgs {
  object: StudentChatMessageReadsInsertInput;
  on_conflict?: Maybe<StudentChatMessageReadsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChatMessagesArgs {
  objects: Array<StudentChatMessagesInsertInput>;
  on_conflict?: Maybe<StudentChatMessagesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChatMessagesOneArgs {
  object: StudentChatMessagesInsertInput;
  on_conflict?: Maybe<StudentChatMessagesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChatUserArgs {
  objects: Array<StudentChatUserInsertInput>;
}


/** mutation root */
export interface StudentMutationRootInsertChatUserOneArgs {
  object: StudentChatUserInsertInput;
}


/** mutation root */
export interface StudentMutationRootInsertChatsArgs {
  objects: Array<StudentChatsInsertInput>;
  on_conflict?: Maybe<StudentChatsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertChatsOneArgs {
  object: StudentChatsInsertInput;
  on_conflict?: Maybe<StudentChatsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertNotificationsArgs {
  objects: Array<StudentNotificationsInsertInput>;
  on_conflict?: Maybe<StudentNotificationsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertNotificationsOneArgs {
  object: StudentNotificationsInsertInput;
  on_conflict?: Maybe<StudentNotificationsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivateAdressesArgs {
  objects: Array<StudentPrivateAdressesInsertInput>;
  on_conflict?: Maybe<StudentPrivateAdressesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivateAdressesOneArgs {
  object: StudentPrivateAdressesInsertInput;
  on_conflict?: Maybe<StudentPrivateAdressesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivateBirthdaysArgs {
  objects: Array<StudentPrivateBirthdaysInsertInput>;
  on_conflict?: Maybe<StudentPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivateBirthdaysOneArgs {
  object: StudentPrivateBirthdaysInsertInput;
  on_conflict?: Maybe<StudentPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivateInsuranceNumbersArgs {
  objects: Array<StudentPrivateInsuranceNumbersInsertInput>;
  on_conflict?: Maybe<StudentPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivateInsuranceNumbersOneArgs {
  object: StudentPrivateInsuranceNumbersInsertInput;
  on_conflict?: Maybe<StudentPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivatePhoneNumbersArgs {
  objects: Array<StudentPrivatePhoneNumbersInsertInput>;
  on_conflict?: Maybe<StudentPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertPrivatePhoneNumbersOneArgs {
  object: StudentPrivatePhoneNumbersInsertInput;
  on_conflict?: Maybe<StudentPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertRelationshipsArgs {
  objects: Array<StudentRelationshipsInsertInput>;
  on_conflict?: Maybe<StudentRelationshipsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertRelationshipsOneArgs {
  object: StudentRelationshipsInsertInput;
  on_conflict?: Maybe<StudentRelationshipsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertSchoolSettingsArgs {
  objects: Array<StudentSchoolSettingsInsertInput>;
  on_conflict?: Maybe<StudentSchoolSettingsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertSchoolSettingsModulesArgs {
  objects: Array<StudentSchoolSettingsModulesInsertInput>;
  on_conflict?: Maybe<StudentSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertSchoolSettingsModulesOneArgs {
  object: StudentSchoolSettingsModulesInsertInput;
  on_conflict?: Maybe<StudentSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertSchoolSettingsOneArgs {
  object: StudentSchoolSettingsInsertInput;
  on_conflict?: Maybe<StudentSchoolSettingsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertSchoolsArgs {
  objects: Array<StudentSchoolsInsertInput>;
  on_conflict?: Maybe<StudentSchoolsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertSchoolsOneArgs {
  object: StudentSchoolsInsertInput;
  on_conflict?: Maybe<StudentSchoolsOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertTasksArgs {
  objects: Array<StudentTasksInsertInput>;
  on_conflict?: Maybe<StudentTasksOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertTasksOneArgs {
  object: StudentTasksInsertInput;
  on_conflict?: Maybe<StudentTasksOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertUsersArgs {
  objects: Array<StudentUsersInsertInput>;
  on_conflict?: Maybe<StudentUsersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootInsertUsersOneArgs {
  object: StudentUsersInsertInput;
  on_conflict?: Maybe<StudentUsersOnConflict>;
}


/** mutation root */
export interface StudentMutationRootLostPasswordArgs {
  email: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootRefreshTokenArgs {
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootResetPasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootRevokeTokenArgs {
  all?: Maybe<Scalars['Boolean']>;
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface StudentMutationRootStudentJoinArgs {
  meeting_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentDiscussionArgs {
  _set?: Maybe<StudentAssignmentDiscussionSetInput>;
  where: StudentAssignmentDiscussionBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentDiscussionByPkArgs {
  _set?: Maybe<StudentAssignmentDiscussionSetInput>;
  pk_columns: StudentAssignmentDiscussionPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentDiscussionContentArgs {
  _set?: Maybe<StudentAssignmentDiscussionContentSetInput>;
  where: StudentAssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentDiscussionContentByPkArgs {
  _set?: Maybe<StudentAssignmentDiscussionContentSetInput>;
  pk_columns: StudentAssignmentDiscussionContentPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentDiscussionSubscriptionArgs {
  _set?: Maybe<StudentAssignmentDiscussionSubscriptionSetInput>;
  where: StudentAssignmentDiscussionSubscriptionBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentDiscussionSubscriptionByPkArgs {
  _set?: Maybe<StudentAssignmentDiscussionSubscriptionSetInput>;
  pk_columns: StudentAssignmentDiscussionSubscriptionPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentNotesArgs {
  _set?: Maybe<StudentAssignmentNotesSetInput>;
  where: StudentAssignmentNotesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentNotesByPkArgs {
  _set?: Maybe<StudentAssignmentNotesSetInput>;
  pk_columns: StudentAssignmentNotesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentSubmitsArgs {
  _set?: Maybe<StudentAssignmentSubmitsSetInput>;
  where: StudentAssignmentSubmitsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentSubmitsByPkArgs {
  _set?: Maybe<StudentAssignmentSubmitsSetInput>;
  pk_columns: StudentAssignmentSubmitsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentUserArgs {
  _set?: Maybe<StudentAssignmentUserSetInput>;
  where: StudentAssignmentUserBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAssignmentUserByPkArgs {
  _set?: Maybe<StudentAssignmentUserSetInput>;
  pk_columns: StudentAssignmentUserPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthAccountProvidersArgs {
  _set?: Maybe<StudentAuthAccountProvidersSetInput>;
  where: StudentAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthAccountProvidersByPkArgs {
  _set?: Maybe<StudentAuthAccountProvidersSetInput>;
  pk_columns: StudentAuthAccountProvidersPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthAccountRolesArgs {
  _set?: Maybe<StudentAuthAccountRolesSetInput>;
  where: StudentAuthAccountRolesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthAccountRolesByPkArgs {
  _set?: Maybe<StudentAuthAccountRolesSetInput>;
  pk_columns: StudentAuthAccountRolesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthAccountsArgs {
  _set?: Maybe<StudentAuthAccountsSetInput>;
  where: StudentAuthAccountsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthAccountsByPkArgs {
  _set?: Maybe<StudentAuthAccountsSetInput>;
  pk_columns: StudentAuthAccountsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthProvidersArgs {
  _set?: Maybe<StudentAuthProvidersSetInput>;
  where: StudentAuthProvidersBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthProvidersByPkArgs {
  _set?: Maybe<StudentAuthProvidersSetInput>;
  pk_columns: StudentAuthProvidersPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthRefreshTokensArgs {
  _set?: Maybe<StudentAuthRefreshTokensSetInput>;
  where: StudentAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthRefreshTokensByPkArgs {
  _set?: Maybe<StudentAuthRefreshTokensSetInput>;
  pk_columns: StudentAuthRefreshTokensPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthRolesArgs {
  _set?: Maybe<StudentAuthRolesSetInput>;
  where: StudentAuthRolesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateAuthRolesByPkArgs {
  _set?: Maybe<StudentAuthRolesSetInput>;
  pk_columns: StudentAuthRolesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateChapterSectionNotesArgs {
  _set?: Maybe<StudentChapterSectionNotesSetInput>;
  where: StudentChapterSectionNotesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateChapterSectionNotesByPkArgs {
  _set?: Maybe<StudentChapterSectionNotesSetInput>;
  pk_columns: StudentChapterSectionNotesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateChapterSectionSubmitsArgs {
  _inc?: Maybe<StudentChapterSectionSubmitsIncInput>;
  _set?: Maybe<StudentChapterSectionSubmitsSetInput>;
  where: StudentChapterSectionSubmitsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateChapterSectionSubmitsByPkArgs {
  _inc?: Maybe<StudentChapterSectionSubmitsIncInput>;
  _set?: Maybe<StudentChapterSectionSubmitsSetInput>;
  pk_columns: StudentChapterSectionSubmitsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateChatMessageReadsArgs {
  _set?: Maybe<StudentChatMessageReadsSetInput>;
  where: StudentChatMessageReadsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateChatMessageReadsByPkArgs {
  _set?: Maybe<StudentChatMessageReadsSetInput>;
  pk_columns: StudentChatMessageReadsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateChatMessagesArgs {
  _set?: Maybe<StudentChatMessagesSetInput>;
  where: StudentChatMessagesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateChatMessagesByPkArgs {
  _set?: Maybe<StudentChatMessagesSetInput>;
  pk_columns: StudentChatMessagesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateChatsArgs {
  _set?: Maybe<StudentChatsSetInput>;
  where: StudentChatsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateChatsByPkArgs {
  _set?: Maybe<StudentChatsSetInput>;
  pk_columns: StudentChatsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateNotificationsArgs {
  _set?: Maybe<StudentNotificationsSetInput>;
  where: StudentNotificationsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateNotificationsByPkArgs {
  _set?: Maybe<StudentNotificationsSetInput>;
  pk_columns: StudentNotificationsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivateAdressesArgs {
  _set?: Maybe<StudentPrivateAdressesSetInput>;
  where: StudentPrivateAdressesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivateAdressesByPkArgs {
  _set?: Maybe<StudentPrivateAdressesSetInput>;
  pk_columns: StudentPrivateAdressesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivateBirthdaysArgs {
  _set?: Maybe<StudentPrivateBirthdaysSetInput>;
  where: StudentPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivateBirthdaysByPkArgs {
  _set?: Maybe<StudentPrivateBirthdaysSetInput>;
  pk_columns: StudentPrivateBirthdaysPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivateInsuranceNumbersArgs {
  _set?: Maybe<StudentPrivateInsuranceNumbersSetInput>;
  where: StudentPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivateInsuranceNumbersByPkArgs {
  _set?: Maybe<StudentPrivateInsuranceNumbersSetInput>;
  pk_columns: StudentPrivateInsuranceNumbersPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivatePhoneNumbersArgs {
  _set?: Maybe<StudentPrivatePhoneNumbersSetInput>;
  where: StudentPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdatePrivatePhoneNumbersByPkArgs {
  _set?: Maybe<StudentPrivatePhoneNumbersSetInput>;
  pk_columns: StudentPrivatePhoneNumbersPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateRelationshipsArgs {
  _set?: Maybe<StudentRelationshipsSetInput>;
  where: StudentRelationshipsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateRelationshipsByPkArgs {
  _set?: Maybe<StudentRelationshipsSetInput>;
  pk_columns: StudentRelationshipsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateSchoolSettingsArgs {
  _set?: Maybe<StudentSchoolSettingsSetInput>;
  where: StudentSchoolSettingsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateSchoolSettingsByPkArgs {
  _set?: Maybe<StudentSchoolSettingsSetInput>;
  pk_columns: StudentSchoolSettingsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateSchoolSettingsModulesArgs {
  _set?: Maybe<StudentSchoolSettingsModulesSetInput>;
  where: StudentSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateSchoolSettingsModulesByPkArgs {
  _set?: Maybe<StudentSchoolSettingsModulesSetInput>;
  pk_columns: StudentSchoolSettingsModulesPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateSchoolsArgs {
  _set?: Maybe<StudentSchoolsSetInput>;
  where: StudentSchoolsBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateSchoolsByPkArgs {
  _set?: Maybe<StudentSchoolsSetInput>;
  pk_columns: StudentSchoolsPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateTasksArgs {
  _set?: Maybe<StudentTasksSetInput>;
  where: StudentTasksBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateTasksByPkArgs {
  _set?: Maybe<StudentTasksSetInput>;
  pk_columns: StudentTasksPkColumnsInput;
}


/** mutation root */
export interface StudentMutationRootUpdateUsersArgs {
  _set?: Maybe<StudentUsersSetInput>;
  where: StudentUsersBoolExp;
}


/** mutation root */
export interface StudentMutationRootUpdateUsersByPkArgs {
  _set?: Maybe<StudentUsersSetInput>;
  pk_columns: StudentUsersPkColumnsInput;
}

/** columns and relationships of "notifications" */
export interface StudentNotifications {
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "notifications" */
export interface StudentNotificationsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentNotificationsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentNotifications>>;
}

/** aggregate fields of "notifications" */
export interface StudentNotificationsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentNotificationsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentNotificationsMinFields>>;
}


/** aggregate fields of "notifications" */
export interface StudentNotificationsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentNotificationsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export interface StudentNotificationsBoolExp {
  _and?: Maybe<Array<StudentNotificationsBoolExp>>;
  _not?: Maybe<StudentNotificationsBoolExp>;
  _or?: Maybe<Array<StudentNotificationsBoolExp>>;
  content?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_read?: Maybe<StudentBooleanComparisonExp>;
  path?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "notifications" */
export const enum StudentNotificationsConstraint {
  /** unique or primary key constraint */
  NOTIFICATIONS_PKEY = 'notifications_pkey'
};

/** input type for inserting data into table "notifications" */
export interface StudentNotificationsInsertInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentNotificationsMaxFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentNotificationsMinFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "notifications" */
export interface StudentNotificationsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentNotifications>>;
}

/** on conflict condition type for table "notifications" */
export interface StudentNotificationsOnConflict {
  constraint: StudentNotificationsConstraint;
  update_columns?: Array<StudentNotificationsUpdateColumn>;
  where?: Maybe<StudentNotificationsBoolExp>;
}

/** Ordering options when selecting data from "notifications". */
export interface StudentNotificationsOrderBy {
  content?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_read?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: notifications */
export interface StudentNotificationsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "notifications" */
export const enum StudentNotificationsSelectColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "notifications" */
export interface StudentNotificationsSetInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "notifications" */
export const enum StudentNotificationsUpdateColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface StudentNumericComparisonExp {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
}

/** column ordering options */
export const enum StudentOrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
};

/** columns and relationships of "parents" */
export interface StudentParents {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "parents". All fields are combined with a logical 'AND'. */
export interface StudentParentsBoolExp {
  _and?: Maybe<Array<StudentParentsBoolExp>>;
  _not?: Maybe<StudentParentsBoolExp>;
  _or?: Maybe<Array<StudentParentsBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "parents". */
export interface StudentParentsOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "parents" */
export const enum StudentParentsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.adresses" */
export interface StudentPrivateAdresses {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentUsers>;
}

/** aggregated selection of "private.adresses" */
export interface StudentPrivateAdressesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentPrivateAdressesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentPrivateAdresses>>;
}

/** aggregate fields of "private.adresses" */
export interface StudentPrivateAdressesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentPrivateAdressesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentPrivateAdressesMinFields>>;
}


/** aggregate fields of "private.adresses" */
export interface StudentPrivateAdressesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentPrivateAdressesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.adresses". All fields are combined with a logical 'AND'. */
export interface StudentPrivateAdressesBoolExp {
  _and?: Maybe<Array<StudentPrivateAdressesBoolExp>>;
  _not?: Maybe<StudentPrivateAdressesBoolExp>;
  _or?: Maybe<Array<StudentPrivateAdressesBoolExp>>;
  area?: Maybe<StudentStringComparisonExp>;
  city?: Maybe<StudentStringComparisonExp>;
  country?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  postal_code?: Maybe<StudentStringComparisonExp>;
  street?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user?: Maybe<StudentUsersBoolExp>;
}

/** unique or primary key constraints on table "private.adresses" */
export const enum StudentPrivateAdressesConstraint {
  /** unique or primary key constraint */
  ADRESSES_PKEY = 'adresses_pkey'
};

/** input type for inserting data into table "private.adresses" */
export interface StudentPrivateAdressesInsertInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentPrivateAdressesMaxFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentPrivateAdressesMinFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.adresses" */
export interface StudentPrivateAdressesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentPrivateAdresses>>;
}

/** input type for inserting object relation for remote table "private.adresses" */
export interface StudentPrivateAdressesObjRelInsertInput {
  data: StudentPrivateAdressesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentPrivateAdressesOnConflict>;
}

/** on conflict condition type for table "private.adresses" */
export interface StudentPrivateAdressesOnConflict {
  constraint: StudentPrivateAdressesConstraint;
  update_columns?: Array<StudentPrivateAdressesUpdateColumn>;
  where?: Maybe<StudentPrivateAdressesBoolExp>;
}

/** Ordering options when selecting data from "private.adresses". */
export interface StudentPrivateAdressesOrderBy {
  area?: Maybe<StudentOrderBy>;
  city?: Maybe<StudentOrderBy>;
  country?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  postal_code?: Maybe<StudentOrderBy>;
  street?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user?: Maybe<StudentUsersOrderBy>;
}

/** primary key columns input for table: private_adresses */
export interface StudentPrivateAdressesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.adresses" */
export const enum StudentPrivateAdressesSelectColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.adresses" */
export interface StudentPrivateAdressesSetInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.adresses" */
export const enum StudentPrivateAdressesUpdateColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.birthdays" */
export interface StudentPrivateBirthdays {
  date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "private.birthdays" */
export interface StudentPrivateBirthdaysAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentPrivateBirthdaysAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentPrivateBirthdays>>;
}

/** aggregate fields of "private.birthdays" */
export interface StudentPrivateBirthdaysAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentPrivateBirthdaysMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentPrivateBirthdaysMinFields>>;
}


/** aggregate fields of "private.birthdays" */
export interface StudentPrivateBirthdaysAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentPrivateBirthdaysSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.birthdays". All fields are combined with a logical 'AND'. */
export interface StudentPrivateBirthdaysBoolExp {
  _and?: Maybe<Array<StudentPrivateBirthdaysBoolExp>>;
  _not?: Maybe<StudentPrivateBirthdaysBoolExp>;
  _or?: Maybe<Array<StudentPrivateBirthdaysBoolExp>>;
  date?: Maybe<StudentDateComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "private.birthdays" */
export const enum StudentPrivateBirthdaysConstraint {
  /** unique or primary key constraint */
  BIRTHDAYS_PKEY = 'birthdays_pkey'
};

/** input type for inserting data into table "private.birthdays" */
export interface StudentPrivateBirthdaysInsertInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentPrivateBirthdaysMaxFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentPrivateBirthdaysMinFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "private.birthdays" */
export interface StudentPrivateBirthdaysMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentPrivateBirthdays>>;
}

/** input type for inserting object relation for remote table "private.birthdays" */
export interface StudentPrivateBirthdaysObjRelInsertInput {
  data: StudentPrivateBirthdaysInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentPrivateBirthdaysOnConflict>;
}

/** on conflict condition type for table "private.birthdays" */
export interface StudentPrivateBirthdaysOnConflict {
  constraint: StudentPrivateBirthdaysConstraint;
  update_columns?: Array<StudentPrivateBirthdaysUpdateColumn>;
  where?: Maybe<StudentPrivateBirthdaysBoolExp>;
}

/** Ordering options when selecting data from "private.birthdays". */
export interface StudentPrivateBirthdaysOrderBy {
  date?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: private_birthdays */
export interface StudentPrivateBirthdaysPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.birthdays" */
export const enum StudentPrivateBirthdaysSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "private.birthdays" */
export interface StudentPrivateBirthdaysSetInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "private.birthdays" */
export const enum StudentPrivateBirthdaysUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentUsers>;
}

/** aggregated selection of "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentPrivateInsuranceNumbers>>;
}

/** aggregate fields of "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbersMinFields>>;
}


/** aggregate fields of "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentPrivateInsuranceNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.insurance_numbers". All fields are combined with a logical 'AND'. */
export interface StudentPrivateInsuranceNumbersBoolExp {
  _and?: Maybe<Array<StudentPrivateInsuranceNumbersBoolExp>>;
  _not?: Maybe<StudentPrivateInsuranceNumbersBoolExp>;
  _or?: Maybe<Array<StudentPrivateInsuranceNumbersBoolExp>>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  user?: Maybe<StudentUsersBoolExp>;
}

/** unique or primary key constraints on table "private.insurance_numbers" */
export const enum StudentPrivateInsuranceNumbersConstraint {
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_NAME_KEY = 'insurance_numbers_name_key',
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_PKEY = 'insurance_numbers_pkey'
};

/** input type for inserting data into table "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<StudentUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentPrivateInsuranceNumbersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentPrivateInsuranceNumbersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentPrivateInsuranceNumbers>>;
}

/** input type for inserting object relation for remote table "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersObjRelInsertInput {
  data: StudentPrivateInsuranceNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentPrivateInsuranceNumbersOnConflict>;
}

/** on conflict condition type for table "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersOnConflict {
  constraint: StudentPrivateInsuranceNumbersConstraint;
  update_columns?: Array<StudentPrivateInsuranceNumbersUpdateColumn>;
  where?: Maybe<StudentPrivateInsuranceNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.insurance_numbers". */
export interface StudentPrivateInsuranceNumbersOrderBy {
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  user?: Maybe<StudentUsersOrderBy>;
}

/** primary key columns input for table: private_insurance_numbers */
export interface StudentPrivateInsuranceNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.insurance_numbers" */
export const enum StudentPrivateInsuranceNumbersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** input type for updating data in table "private.insurance_numbers" */
export interface StudentPrivateInsuranceNumbersSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "private.insurance_numbers" */
export const enum StudentPrivateInsuranceNumbersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "private.phone_numbers" */
export interface StudentPrivatePhoneNumbers {
  country_code: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  number: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentUsers>;
}

/** aggregated selection of "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentPrivatePhoneNumbers>>;
}

/** aggregate fields of "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbersMinFields>>;
}


/** aggregate fields of "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentPrivatePhoneNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.phone_numbers". All fields are combined with a logical 'AND'. */
export interface StudentPrivatePhoneNumbersBoolExp {
  _and?: Maybe<Array<StudentPrivatePhoneNumbersBoolExp>>;
  _not?: Maybe<StudentPrivatePhoneNumbersBoolExp>;
  _or?: Maybe<Array<StudentPrivatePhoneNumbersBoolExp>>;
  country_code?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  number?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user?: Maybe<StudentUsersBoolExp>;
}

/** unique or primary key constraints on table "private.phone_numbers" */
export const enum StudentPrivatePhoneNumbersConstraint {
  /** unique or primary key constraint */
  PHONE_NUMBERS_COUNTRY_CODE_NUMBER_KEY = 'phone_numbers_country_code_number_key',
  /** unique or primary key constraint */
  PHONE_NUMBERS_PKEY = 'phone_numbers_pkey'
};

/** input type for inserting data into table "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersInsertInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentPrivatePhoneNumbersMaxFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentPrivatePhoneNumbersMinFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentPrivatePhoneNumbers>>;
}

/** input type for inserting object relation for remote table "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersObjRelInsertInput {
  data: StudentPrivatePhoneNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentPrivatePhoneNumbersOnConflict>;
}

/** on conflict condition type for table "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersOnConflict {
  constraint: StudentPrivatePhoneNumbersConstraint;
  update_columns?: Array<StudentPrivatePhoneNumbersUpdateColumn>;
  where?: Maybe<StudentPrivatePhoneNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.phone_numbers". */
export interface StudentPrivatePhoneNumbersOrderBy {
  country_code?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  number?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user?: Maybe<StudentUsersOrderBy>;
}

/** primary key columns input for table: private_phone_numbers */
export interface StudentPrivatePhoneNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.phone_numbers" */
export const enum StudentPrivatePhoneNumbersSelectColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.phone_numbers" */
export interface StudentPrivatePhoneNumbersSetInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.phone_numbers" */
export const enum StudentPrivatePhoneNumbersUpdateColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "promotions" */
export interface StudentPromotions {
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_promoted: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  year: EntireFieldWrapper<StudentYears>;
  year_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "promotions" */
export interface StudentPromotionsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentPromotionsMaxOrderBy>;
  min?: Maybe<StudentPromotionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "promotions". All fields are combined with a logical 'AND'. */
export interface StudentPromotionsBoolExp {
  _and?: Maybe<Array<StudentPromotionsBoolExp>>;
  _not?: Maybe<StudentPromotionsBoolExp>;
  _or?: Maybe<Array<StudentPromotionsBoolExp>>;
  class_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_promoted?: Maybe<StudentBooleanComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  year?: Maybe<StudentYearsBoolExp>;
  year_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "promotions" */
export interface StudentPromotionsMaxOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  year_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "promotions" */
export interface StudentPromotionsMinOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  year_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "promotions". */
export interface StudentPromotionsOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_promoted?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  year?: Maybe<StudentYearsOrderBy>;
  year_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "promotions" */
export const enum StudentPromotionsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PROMOTED = 'is_promoted',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  YEAR_ID = 'year_id'
};

export interface StudentQueryRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<StudentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<StudentAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<StudentAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<StudentAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<StudentAssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<StudentAssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<StudentAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<StudentAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<StudentAssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<StudentAssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<StudentAssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<StudentAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionOptions>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<StudentAssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<StudentAssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<StudentAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<StudentAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<StudentAssignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<StudentAttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<StudentAttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<StudentAttendances>>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<StudentAttendances>>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: EntireFieldWrapper<Array<StudentAuthAccountProviders>>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: EntireFieldWrapper<StudentAuthAccountProvidersAggregate>;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccountProviders>>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: EntireFieldWrapper<Array<StudentAuthAccountRoles>>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: EntireFieldWrapper<StudentAuthAccountRolesAggregate>;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccountRoles>>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: EntireFieldWrapper<Array<StudentAuthAccounts>>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: EntireFieldWrapper<StudentAuthAccountsAggregate>;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentAuthAccounts>>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: EntireFieldWrapper<Array<StudentAuthProviders>>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: EntireFieldWrapper<StudentAuthProvidersAggregate>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentAuthProviders>>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: EntireFieldWrapper<Array<StudentAuthRefreshTokens>>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: EntireFieldWrapper<StudentAuthRefreshTokensAggregate>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentAuthRefreshTokens>>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: EntireFieldWrapper<Array<StudentAuthRoles>>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: EntireFieldWrapper<StudentAuthRolesAggregate>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentAuthRoles>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<StudentBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<StudentBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<StudentBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<StudentBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<StudentBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<StudentBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<StudentBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<StudentBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<StudentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<StudentChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<StudentChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<StudentChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<StudentChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<StudentChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<StudentChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<StudentClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<StudentClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<StudentClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<StudentClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<StudentClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<StudentClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<StudentCourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<StudentCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<StudentCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<StudentCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<StudentCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<StudentCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<StudentCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<StudentCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<StudentCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<StudentEventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<StudentEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<StudentEvents>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<StudentEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<StudentFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<StudentGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<StudentGrades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<StudentLatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<StudentLatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<StudentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<StudentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<StudentLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<StudentLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentLessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<StudentLessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<StudentLiveClassAttendees>>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<StudentLiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<StudentLiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<StudentLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<StudentMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<StudentMarks>>;
  me?: EntireFieldWrapper<Maybe<StudentUserData>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<StudentMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<StudentMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<StudentMeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<StudentNotifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<StudentNotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<StudentNotifications>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<StudentParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<StudentParents>>;
  /** fetch data from the table: "private.adresses" */
  private_adresses: EntireFieldWrapper<Array<StudentPrivateAdresses>>;
  /** fetch aggregated fields from the table: "private.adresses" */
  private_adresses_aggregate: EntireFieldWrapper<StudentPrivateAdressesAggregate>;
  /** fetch data from the table: "private.adresses" using primary key columns */
  private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateAdresses>>;
  /** fetch data from the table: "private.birthdays" */
  private_birthdays: EntireFieldWrapper<Array<StudentPrivateBirthdays>>;
  /** fetch aggregated fields from the table: "private.birthdays" */
  private_birthdays_aggregate: EntireFieldWrapper<StudentPrivateBirthdaysAggregate>;
  /** fetch data from the table: "private.birthdays" using primary key columns */
  private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateBirthdays>>;
  /** fetch data from the table: "private.insurance_numbers" */
  private_insurance_numbers: EntireFieldWrapper<Array<StudentPrivateInsuranceNumbers>>;
  /** fetch aggregated fields from the table: "private.insurance_numbers" */
  private_insurance_numbers_aggregate: EntireFieldWrapper<StudentPrivateInsuranceNumbersAggregate>;
  /** fetch data from the table: "private.insurance_numbers" using primary key columns */
  private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbers>>;
  /** fetch data from the table: "private.phone_numbers" */
  private_phone_numbers: EntireFieldWrapper<Array<StudentPrivatePhoneNumbers>>;
  /** fetch aggregated fields from the table: "private.phone_numbers" */
  private_phone_numbers_aggregate: EntireFieldWrapper<StudentPrivatePhoneNumbersAggregate>;
  /** fetch data from the table: "private.phone_numbers" using primary key columns */
  private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbers>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<StudentPromotions>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<StudentRelationships>>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<StudentRelationshipsAggregate>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: EntireFieldWrapper<Maybe<StudentRelationships>>;
  /** fetch data from the table: "school_settings" */
  school_settings: EntireFieldWrapper<Array<StudentSchoolSettings>>;
  /** fetch aggregated fields from the table: "school_settings" */
  school_settings_aggregate: EntireFieldWrapper<StudentSchoolSettingsAggregate>;
  /** fetch data from the table: "school_settings" using primary key columns */
  school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentSchoolSettings>>;
  /** fetch data from the table: "school_settings_modules" */
  school_settings_modules: EntireFieldWrapper<Array<StudentSchoolSettingsModules>>;
  /** fetch aggregated fields from the table: "school_settings_modules" */
  school_settings_modules_aggregate: EntireFieldWrapper<StudentSchoolSettingsModulesAggregate>;
  /** fetch data from the table: "school_settings_modules" using primary key columns */
  school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModules>>;
  /** fetch data from the table: "schools" */
  schools: EntireFieldWrapper<Array<StudentSchools>>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: EntireFieldWrapper<StudentSchoolsAggregate>;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: EntireFieldWrapper<Maybe<StudentSchools>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<StudentSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<StudentSemesters>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<StudentStudentGroupUsers>>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<StudentStudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<StudentStudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<StudentStudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentStudents>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentStudentsAggregate>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<StudentStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<StudentSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<StudentTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<StudentTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<StudentTasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<StudentTeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<StudentTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<StudentTeachingStructureStudents>>;
  /** fetch data from the table: "teaching_structure_students" using primary key columns */
  teaching_structure_students_by_pk?: EntireFieldWrapper<Maybe<StudentTeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<StudentTeachingStructures>>;
  /** fetch data from the table: "users" */
  users: EntireFieldWrapper<Array<StudentUsers>>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: EntireFieldWrapper<StudentUsersAggregate>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: EntireFieldWrapper<Maybe<StudentUsers>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<StudentViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<StudentViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<StudentViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<StudentViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentViewGradesAggregate>;
  /** fetch data from the table: "view.grades_for_students" */
  view_grades_for_students: EntireFieldWrapper<Array<StudentViewGradesForStudents>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<StudentViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<StudentViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<StudentViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<StudentViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<StudentViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<StudentYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<StudentYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<StudentYears>>;
}


export interface StudentQueryRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<StudentAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<StudentAssignmentAttendeeTypeBoolExp>;
}


export interface StudentQueryRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface StudentQueryRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<StudentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentAssignmentBookChapterBoolExp>;
}


export interface StudentQueryRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionBoolExp>;
}


export interface StudentQueryRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
}


export interface StudentQueryRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionSubscriptionBoolExp>;
}


export interface StudentQueryRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<StudentAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentFilesOrderBy>>;
  where?: Maybe<StudentAssignmentFilesBoolExp>;
}


export interface StudentQueryRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentAssignmentGradeWeightsBoolExp>;
}


export interface StudentQueryRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentAssignmentGradeWeightsBoolExp>;
}


export interface StudentQueryRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<StudentAssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentNotesOrderBy>>;
  where?: Maybe<StudentAssignmentNotesBoolExp>;
}


export interface StudentQueryRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionAnswersBoolExp>;
}


export interface StudentQueryRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionOptionRelationsBoolExp>;
}


export interface StudentQueryRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
}


export interface StudentQueryRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionsBoolExp>;
}


export interface StudentQueryRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuizOrderBy>>;
  where?: Maybe<StudentAssignmentQuizBoolExp>;
}


export interface StudentQueryRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentAssignmentSubmitsBoolExp>;
}


export interface StudentQueryRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<StudentAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentTypeOrderBy>>;
  where?: Maybe<StudentAssignmentTypeBoolExp>;
}


export interface StudentQueryRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentQueryRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<StudentAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentUserOrderBy>>;
  where?: Maybe<StudentAssignmentUserBoolExp>;
}


export interface StudentQueryRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


export interface StudentQueryRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


export interface StudentQueryRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<StudentAttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAttendanceTypesOrderBy>>;
  where?: Maybe<StudentAttendanceTypesBoolExp>;
}


export interface StudentQueryRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface StudentQueryRootAttendancesArgs {
  distinct_on?: Maybe<Array<StudentAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAttendancesOrderBy>>;
  where?: Maybe<StudentAttendancesBoolExp>;
}


export interface StudentQueryRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAuthAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}


export interface StudentQueryRootAuthAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentAuthAccountProvidersBoolExp>;
}


export interface StudentQueryRootAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAuthAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}


export interface StudentQueryRootAuthAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentAuthAccountRolesBoolExp>;
}


export interface StudentQueryRootAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAuthAccountsArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountsOrderBy>>;
  where?: Maybe<StudentAuthAccountsBoolExp>;
}


export interface StudentQueryRootAuthAccountsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthAccountsOrderBy>>;
  where?: Maybe<StudentAuthAccountsBoolExp>;
}


export interface StudentQueryRootAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootAuthProvidersArgs {
  distinct_on?: Maybe<Array<StudentAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthProvidersOrderBy>>;
  where?: Maybe<StudentAuthProvidersBoolExp>;
}


export interface StudentQueryRootAuthProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthProvidersOrderBy>>;
  where?: Maybe<StudentAuthProvidersBoolExp>;
}


export interface StudentQueryRootAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


export interface StudentQueryRootAuthRefreshTokensArgs {
  distinct_on?: Maybe<Array<StudentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentAuthRefreshTokensBoolExp>;
}


export interface StudentQueryRootAuthRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentAuthRefreshTokensBoolExp>;
}


export interface StudentQueryRootAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


export interface StudentQueryRootAuthRolesArgs {
  distinct_on?: Maybe<Array<StudentAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthRolesOrderBy>>;
  where?: Maybe<StudentAuthRolesBoolExp>;
}


export interface StudentQueryRootAuthRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAuthRolesOrderBy>>;
  where?: Maybe<StudentAuthRolesBoolExp>;
}


export interface StudentQueryRootAuthRolesByPkArgs {
  role: Scalars['String'];
}


export interface StudentQueryRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<StudentBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookChapterTypeOrderBy>>;
  where?: Maybe<StudentBookChapterTypeBoolExp>;
}


export interface StudentQueryRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentQueryRootBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookChaptersOrderBy>>;
  where?: Maybe<StudentBookChaptersBoolExp>;
}


export interface StudentQueryRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootBookCourseArgs {
  distinct_on?: Maybe<Array<StudentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookCourseOrderBy>>;
  where?: Maybe<StudentBookCourseBoolExp>;
}


export interface StudentQueryRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootBookUserArgs {
  distinct_on?: Maybe<Array<StudentBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookUserOrderBy>>;
  where?: Maybe<StudentBookUserBoolExp>;
}


export interface StudentQueryRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootBooksArgs {
  distinct_on?: Maybe<Array<StudentBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBooksOrderBy>>;
  where?: Maybe<StudentBooksBoolExp>;
}


export interface StudentQueryRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentChapterSectionNotesBoolExp>;
}


export interface StudentQueryRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentChapterSectionSubmitsBoolExp>;
}


export interface StudentQueryRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionTypeOrderBy>>;
  where?: Maybe<StudentChapterSectionTypeBoolExp>;
}


export interface StudentQueryRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentQueryRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionsOrderBy>>;
  where?: Maybe<StudentChapterSectionsBoolExp>;
}


export interface StudentQueryRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentChatMessageLikesBoolExp>;
}


export interface StudentQueryRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentChatMessageLikesBoolExp>;
}


export interface StudentQueryRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageReadsOrderBy>>;
  where?: Maybe<StudentChatMessageReadsBoolExp>;
}


export interface StudentQueryRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


export interface StudentQueryRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


export interface StudentQueryRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChatTypeArgs {
  distinct_on?: Maybe<Array<StudentChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatTypeOrderBy>>;
  where?: Maybe<StudentChatTypeBoolExp>;
}


export interface StudentQueryRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentQueryRootChatUserArgs {
  distinct_on?: Maybe<Array<StudentChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatUserOrderBy>>;
  where?: Maybe<StudentChatUserBoolExp>;
}


export interface StudentQueryRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootChatsArgs {
  distinct_on?: Maybe<Array<StudentChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatsOrderBy>>;
  where?: Maybe<StudentChatsBoolExp>;
}


export interface StudentQueryRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootClassLevelsArgs {
  distinct_on?: Maybe<Array<StudentClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassLevelsOrderBy>>;
  where?: Maybe<StudentClassLevelsBoolExp>;
}


export interface StudentQueryRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootClassTypeArgs {
  distinct_on?: Maybe<Array<StudentClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassTypeOrderBy>>;
  where?: Maybe<StudentClassTypeBoolExp>;
}


export interface StudentQueryRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentQueryRootClassesArgs {
  distinct_on?: Maybe<Array<StudentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassesOrderBy>>;
  where?: Maybe<StudentClassesBoolExp>;
}


export interface StudentQueryRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootClassroomsArgs {
  distinct_on?: Maybe<Array<StudentClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassroomsOrderBy>>;
  where?: Maybe<StudentClassroomsBoolExp>;
}


export interface StudentQueryRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootCourseClassArgs {
  distinct_on?: Maybe<Array<StudentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassOrderBy>>;
  where?: Maybe<StudentCourseClassBoolExp>;
}


export interface StudentQueryRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<StudentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassroomOrderBy>>;
  where?: Maybe<StudentCourseClassroomBoolExp>;
}


export interface StudentQueryRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootCourseStudentArgs {
  distinct_on?: Maybe<Array<StudentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseStudentOrderBy>>;
  where?: Maybe<StudentCourseStudentBoolExp>;
}


export interface StudentQueryRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<StudentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseTeacherOrderBy>>;
  where?: Maybe<StudentCourseTeacherBoolExp>;
}


export interface StudentQueryRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootCoursesArgs {
  distinct_on?: Maybe<Array<StudentCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCoursesOrderBy>>;
  where?: Maybe<StudentCoursesBoolExp>;
}


export interface StudentQueryRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootEventUsersArgs {
  distinct_on?: Maybe<Array<StudentEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentEventUsersOrderBy>>;
  where?: Maybe<StudentEventUsersBoolExp>;
}


export interface StudentQueryRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootEventsArgs {
  distinct_on?: Maybe<Array<StudentEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentEventsOrderBy>>;
  where?: Maybe<StudentEventsBoolExp>;
}


export interface StudentQueryRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootFilesArgs {
  distinct_on?: Maybe<Array<StudentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentFilesOrderBy>>;
  where?: Maybe<StudentFilesBoolExp>;
}


export interface StudentQueryRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradeTypesOrderBy>>;
  where?: Maybe<StudentGradeTypesBoolExp>;
}


export interface StudentQueryRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootGradesArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


export interface StudentQueryRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


export interface StudentQueryRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<StudentLatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLatestActivitiesOrderBy>>;
  where?: Maybe<StudentLatestActivitiesBoolExp>;
}


export interface StudentQueryRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<StudentLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonAttendaceTypeOrderBy>>;
  where?: Maybe<StudentLessonAttendaceTypeBoolExp>;
}


export interface StudentQueryRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentQueryRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<StudentLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonAttendancesOrderBy>>;
  where?: Maybe<StudentLessonAttendancesBoolExp>;
}


export interface StudentQueryRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootLessonsArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


export interface StudentQueryRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


export interface StudentQueryRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<StudentLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLiveClassAttendeesOrderBy>>;
  where?: Maybe<StudentLiveClassAttendeesBoolExp>;
}


export interface StudentQueryRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootLiveClassesArgs {
  distinct_on?: Maybe<Array<StudentLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLiveClassesOrderBy>>;
  where?: Maybe<StudentLiveClassesBoolExp>;
}


export interface StudentQueryRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootMarksArgs {
  distinct_on?: Maybe<Array<StudentMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentMarksOrderBy>>;
  where?: Maybe<StudentMarksBoolExp>;
}


export interface StudentQueryRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootMeetingUserArgs {
  distinct_on?: Maybe<Array<StudentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentMeetingUserOrderBy>>;
  where?: Maybe<StudentMeetingUserBoolExp>;
}


export interface StudentQueryRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<StudentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentMeetingUserOrderBy>>;
  where?: Maybe<StudentMeetingUserBoolExp>;
}


export interface StudentQueryRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootNotificationsArgs {
  distinct_on?: Maybe<Array<StudentNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentNotificationsOrderBy>>;
  where?: Maybe<StudentNotificationsBoolExp>;
}


export interface StudentQueryRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<StudentNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentNotificationsOrderBy>>;
  where?: Maybe<StudentNotificationsBoolExp>;
}


export interface StudentQueryRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootParentsArgs {
  distinct_on?: Maybe<Array<StudentParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentParentsOrderBy>>;
  where?: Maybe<StudentParentsBoolExp>;
}


export interface StudentQueryRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootPrivateAdressesArgs {
  distinct_on?: Maybe<Array<StudentPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivateAdressesOrderBy>>;
  where?: Maybe<StudentPrivateAdressesBoolExp>;
}


export interface StudentQueryRootPrivateAdressesAggregateArgs {
  distinct_on?: Maybe<Array<StudentPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivateAdressesOrderBy>>;
  where?: Maybe<StudentPrivateAdressesBoolExp>;
}


export interface StudentQueryRootPrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootPrivateBirthdaysArgs {
  distinct_on?: Maybe<Array<StudentPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivateBirthdaysOrderBy>>;
  where?: Maybe<StudentPrivateBirthdaysBoolExp>;
}


export interface StudentQueryRootPrivateBirthdaysAggregateArgs {
  distinct_on?: Maybe<Array<StudentPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivateBirthdaysOrderBy>>;
  where?: Maybe<StudentPrivateBirthdaysBoolExp>;
}


export interface StudentQueryRootPrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootPrivateInsuranceNumbersArgs {
  distinct_on?: Maybe<Array<StudentPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<StudentPrivateInsuranceNumbersBoolExp>;
}


export interface StudentQueryRootPrivateInsuranceNumbersAggregateArgs {
  distinct_on?: Maybe<Array<StudentPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<StudentPrivateInsuranceNumbersBoolExp>;
}


export interface StudentQueryRootPrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootPrivatePhoneNumbersArgs {
  distinct_on?: Maybe<Array<StudentPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<StudentPrivatePhoneNumbersBoolExp>;
}


export interface StudentQueryRootPrivatePhoneNumbersAggregateArgs {
  distinct_on?: Maybe<Array<StudentPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<StudentPrivatePhoneNumbersBoolExp>;
}


export interface StudentQueryRootPrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootPromotionsArgs {
  distinct_on?: Maybe<Array<StudentPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPromotionsOrderBy>>;
  where?: Maybe<StudentPromotionsBoolExp>;
}


export interface StudentQueryRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootRelationshipsArgs {
  distinct_on?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentRelationshipsOrderBy>>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}


export interface StudentQueryRootRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentRelationshipsOrderBy>>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}


export interface StudentQueryRootRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootSchoolSettingsArgs {
  distinct_on?: Maybe<Array<StudentSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSchoolSettingsOrderBy>>;
  where?: Maybe<StudentSchoolSettingsBoolExp>;
}


export interface StudentQueryRootSchoolSettingsAggregateArgs {
  distinct_on?: Maybe<Array<StudentSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSchoolSettingsOrderBy>>;
  where?: Maybe<StudentSchoolSettingsBoolExp>;
}


export interface StudentQueryRootSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootSchoolSettingsModulesArgs {
  distinct_on?: Maybe<Array<StudentSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSchoolSettingsModulesOrderBy>>;
  where?: Maybe<StudentSchoolSettingsModulesBoolExp>;
}


export interface StudentQueryRootSchoolSettingsModulesAggregateArgs {
  distinct_on?: Maybe<Array<StudentSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSchoolSettingsModulesOrderBy>>;
  where?: Maybe<StudentSchoolSettingsModulesBoolExp>;
}


export interface StudentQueryRootSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootSchoolsArgs {
  distinct_on?: Maybe<Array<StudentSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSchoolsOrderBy>>;
  where?: Maybe<StudentSchoolsBoolExp>;
}


export interface StudentQueryRootSchoolsAggregateArgs {
  distinct_on?: Maybe<Array<StudentSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSchoolsOrderBy>>;
  where?: Maybe<StudentSchoolsBoolExp>;
}


export interface StudentQueryRootSchoolsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootSemestersArgs {
  distinct_on?: Maybe<Array<StudentSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSemestersOrderBy>>;
  where?: Maybe<StudentSemestersBoolExp>;
}


export interface StudentQueryRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<StudentStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentGroupUsersOrderBy>>;
  where?: Maybe<StudentStudentGroupUsersBoolExp>;
}


export interface StudentQueryRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<StudentStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentGroupsOrderBy>>;
  where?: Maybe<StudentStudentGroupsBoolExp>;
}


export interface StudentQueryRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentsOrderBy>>;
  where?: Maybe<StudentStudentsBoolExp>;
}


export interface StudentQueryRootStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentsOrderBy>>;
  where?: Maybe<StudentStudentsBoolExp>;
}


export interface StudentQueryRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootSubjectsArgs {
  distinct_on?: Maybe<Array<StudentSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSubjectsOrderBy>>;
  where?: Maybe<StudentSubjectsBoolExp>;
}


export interface StudentQueryRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootTasksArgs {
  distinct_on?: Maybe<Array<StudentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTasksOrderBy>>;
  where?: Maybe<StudentTasksBoolExp>;
}


export interface StudentQueryRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<StudentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTasksOrderBy>>;
  where?: Maybe<StudentTasksBoolExp>;
}


export interface StudentQueryRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<StudentTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeacherSubjectOrderBy>>;
  where?: Maybe<StudentTeacherSubjectBoolExp>;
}


export interface StudentQueryRootTeachersArgs {
  distinct_on?: Maybe<Array<StudentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachersOrderBy>>;
  where?: Maybe<StudentTeachersBoolExp>;
}


export interface StudentQueryRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootTeachingStructureLeafsArgs {
  args: StudentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentQueryRootTeachingStructureLeafsAggregateArgs {
  args: StudentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentQueryRootTeachingStructureParentsArgs {
  args: StudentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentQueryRootTeachingStructureParentsAggregateArgs {
  args: StudentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentQueryRootTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructureStudentsOrderBy>>;
  where?: Maybe<StudentTeachingStructureStudentsBoolExp>;
}


export interface StudentQueryRootTeachingStructureStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentQueryRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentQueryRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootUsersArgs {
  distinct_on?: Maybe<Array<StudentUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentUsersOrderBy>>;
  where?: Maybe<StudentUsersBoolExp>;
}


export interface StudentQueryRootUsersAggregateArgs {
  distinct_on?: Maybe<Array<StudentUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentUsersOrderBy>>;
  where?: Maybe<StudentUsersBoolExp>;
}


export interface StudentQueryRootUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentQueryRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<StudentViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentViewAssignmentClassBoolExp>;
}


export interface StudentQueryRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<StudentViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<StudentViewAssignmentStudentGradeBoolExp>;
}


export interface StudentQueryRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<StudentViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewClassStudentOrderBy>>;
  where?: Maybe<StudentViewClassStudentBoolExp>;
}


export interface StudentQueryRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<StudentViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentViewGradeTypeSubjectBoolExp>;
}


export interface StudentQueryRootViewGradesArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}


export interface StudentQueryRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}


export interface StudentQueryRootViewGradesForStudentsArgs {
  distinct_on?: Maybe<Array<StudentViewGradesForStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesForStudentsOrderBy>>;
  where?: Maybe<StudentViewGradesForStudentsBoolExp>;
}


export interface StudentQueryRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentViewLatestChatMessagesBoolExp>;
}


export interface StudentQueryRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentViewLatestChatMessagesBoolExp>;
}


export interface StudentQueryRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface StudentQueryRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<StudentViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewSubjectSemesterOrderBy>>;
  where?: Maybe<StudentViewSubjectSemesterBoolExp>;
}


export interface StudentQueryRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<StudentViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<StudentViewTeacherClassSubjectBoolExp>;
}


export interface StudentQueryRootYearsArgs {
  distinct_on?: Maybe<Array<StudentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentYearsOrderBy>>;
  where?: Maybe<StudentYearsBoolExp>;
}


export interface StudentQueryRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<StudentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentYearsOrderBy>>;
  where?: Maybe<StudentYearsBoolExp>;
}


export interface StudentQueryRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "relationships" */
export interface StudentRelationships {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  related: EntireFieldWrapper<StudentUsers>;
  related_id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<StudentAuthRoles>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentUsers>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "relationships" */
export interface StudentRelationshipsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentRelationshipsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentRelationships>>;
}

/** aggregate fields of "relationships" */
export interface StudentRelationshipsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentRelationshipsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentRelationshipsMinFields>>;
}


/** aggregate fields of "relationships" */
export interface StudentRelationshipsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "relationships" */
export interface StudentRelationshipsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentRelationshipsMaxOrderBy>;
  min?: Maybe<StudentRelationshipsMinOrderBy>;
}

/** input type for inserting array relation for remote table "relationships" */
export interface StudentRelationshipsArrRelInsertInput {
  data: Array<StudentRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentRelationshipsOnConflict>;
}

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export interface StudentRelationshipsBoolExp {
  _and?: Maybe<Array<StudentRelationshipsBoolExp>>;
  _not?: Maybe<StudentRelationshipsBoolExp>;
  _or?: Maybe<Array<StudentRelationshipsBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  related?: Maybe<StudentUsersBoolExp>;
  related_id?: Maybe<StudentUuidComparisonExp>;
  role?: Maybe<StudentStringComparisonExp>;
  roleByRole?: Maybe<StudentAuthRolesBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user?: Maybe<StudentUsersBoolExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "relationships" */
export const enum StudentRelationshipsConstraint {
  /** unique or primary key constraint */
  RELATIONSHIPS_PKEY = 'relationships_pkey',
  /** unique or primary key constraint */
  RELATIONSHIPS_USER_ID_RELATED_ID_KEY = 'relationships_user_id_related_id_key'
};

/** input type for inserting data into table "relationships" */
export interface StudentRelationshipsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related?: Maybe<StudentUsersObjRelInsertInput>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<StudentAuthRolesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentRelationshipsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "relationships" */
export interface StudentRelationshipsMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  related_id?: Maybe<StudentOrderBy>;
  role?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentRelationshipsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "relationships" */
export interface StudentRelationshipsMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  related_id?: Maybe<StudentOrderBy>;
  role?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** response of any mutation on the table "relationships" */
export interface StudentRelationshipsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentRelationships>>;
}

/** on conflict condition type for table "relationships" */
export interface StudentRelationshipsOnConflict {
  constraint: StudentRelationshipsConstraint;
  update_columns?: Array<StudentRelationshipsUpdateColumn>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}

/** Ordering options when selecting data from "relationships". */
export interface StudentRelationshipsOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  related?: Maybe<StudentUsersOrderBy>;
  related_id?: Maybe<StudentOrderBy>;
  role?: Maybe<StudentOrderBy>;
  roleByRole?: Maybe<StudentAuthRolesOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user?: Maybe<StudentUsersOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: relationships */
export interface StudentRelationshipsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "relationships" */
export const enum StudentRelationshipsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "relationships" */
export interface StudentRelationshipsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "relationships" */
export const enum StudentRelationshipsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/**
 * General settings for school
 *
 *
 * columns and relationships of "school_settings"
 */
export interface StudentSchoolSettings {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school: EntireFieldWrapper<StudentSchools>;
  school_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school_settings_module?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModules>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings" */
export interface StudentSchoolSettingsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentSchoolSettingsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentSchoolSettings>>;
}

/** aggregate fields of "school_settings" */
export interface StudentSchoolSettingsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentSchoolSettingsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentSchoolSettingsMinFields>>;
}


/** aggregate fields of "school_settings" */
export interface StudentSchoolSettingsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentSchoolSettingsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings". All fields are combined with a logical 'AND'. */
export interface StudentSchoolSettingsBoolExp {
  _and?: Maybe<Array<StudentSchoolSettingsBoolExp>>;
  _not?: Maybe<StudentSchoolSettingsBoolExp>;
  _or?: Maybe<Array<StudentSchoolSettingsBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  school?: Maybe<StudentSchoolsBoolExp>;
  school_id?: Maybe<StudentUuidComparisonExp>;
  school_settings_module?: Maybe<StudentSchoolSettingsModulesBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings" */
export const enum StudentSchoolSettingsConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_PKEY = 'school_settings_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_SCHOOL_ID_KEY = 'school_settings_school_id_key'
};

/** input type for inserting data into table "school_settings" */
export interface StudentSchoolSettingsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school?: Maybe<StudentSchoolsObjRelInsertInput>;
  school_id?: Maybe<Scalars['uuid']>;
  school_settings_module?: Maybe<StudentSchoolSettingsModulesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentSchoolSettingsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentSchoolSettingsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/**
 * Enable or disable module in application for school of choice
 *
 *
 * columns and relationships of "school_settings_modules"
 */
export interface StudentSchoolSettingsModules {
  assignments: EntireFieldWrapper<Scalars['Boolean']>;
  chat: EntireFieldWrapper<Scalars['Boolean']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  grading: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  live_class: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  school_setting: EntireFieldWrapper<StudentSchoolSettings>;
  school_settings_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings_modules" */
export interface StudentSchoolSettingsModulesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModulesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentSchoolSettingsModules>>;
}

/** aggregate fields of "school_settings_modules" */
export interface StudentSchoolSettingsModulesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModulesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentSchoolSettingsModulesMinFields>>;
}


/** aggregate fields of "school_settings_modules" */
export interface StudentSchoolSettingsModulesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentSchoolSettingsModulesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings_modules". All fields are combined with a logical 'AND'. */
export interface StudentSchoolSettingsModulesBoolExp {
  _and?: Maybe<Array<StudentSchoolSettingsModulesBoolExp>>;
  _not?: Maybe<StudentSchoolSettingsModulesBoolExp>;
  _or?: Maybe<Array<StudentSchoolSettingsModulesBoolExp>>;
  assignments?: Maybe<StudentBooleanComparisonExp>;
  chat?: Maybe<StudentBooleanComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  grading?: Maybe<StudentBooleanComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  live_class?: Maybe<StudentBooleanComparisonExp>;
  school_setting?: Maybe<StudentSchoolSettingsBoolExp>;
  school_settings_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings_modules" */
export const enum StudentSchoolSettingsModulesConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_PKEY = 'school_settings_modules_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_SCHOOL_SETTINGS_ID_KEY = 'school_settings_modules_school_settings_id_key'
};

/** input type for inserting data into table "school_settings_modules" */
export interface StudentSchoolSettingsModulesInsertInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_setting?: Maybe<StudentSchoolSettingsObjRelInsertInput>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentSchoolSettingsModulesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentSchoolSettingsModulesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "school_settings_modules" */
export interface StudentSchoolSettingsModulesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentSchoolSettingsModules>>;
}

/** input type for inserting object relation for remote table "school_settings_modules" */
export interface StudentSchoolSettingsModulesObjRelInsertInput {
  data: StudentSchoolSettingsModulesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentSchoolSettingsModulesOnConflict>;
}

/** on conflict condition type for table "school_settings_modules" */
export interface StudentSchoolSettingsModulesOnConflict {
  constraint: StudentSchoolSettingsModulesConstraint;
  update_columns?: Array<StudentSchoolSettingsModulesUpdateColumn>;
  where?: Maybe<StudentSchoolSettingsModulesBoolExp>;
}

/** Ordering options when selecting data from "school_settings_modules". */
export interface StudentSchoolSettingsModulesOrderBy {
  assignments?: Maybe<StudentOrderBy>;
  chat?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  grading?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  live_class?: Maybe<StudentOrderBy>;
  school_setting?: Maybe<StudentSchoolSettingsOrderBy>;
  school_settings_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: school_settings_modules */
export interface StudentSchoolSettingsModulesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings_modules" */
export const enum StudentSchoolSettingsModulesSelectColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings_modules" */
export interface StudentSchoolSettingsModulesSetInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings_modules" */
export const enum StudentSchoolSettingsModulesUpdateColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** response of any mutation on the table "school_settings" */
export interface StudentSchoolSettingsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentSchoolSettings>>;
}

/** input type for inserting object relation for remote table "school_settings" */
export interface StudentSchoolSettingsObjRelInsertInput {
  data: StudentSchoolSettingsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentSchoolSettingsOnConflict>;
}

/** on conflict condition type for table "school_settings" */
export interface StudentSchoolSettingsOnConflict {
  constraint: StudentSchoolSettingsConstraint;
  update_columns?: Array<StudentSchoolSettingsUpdateColumn>;
  where?: Maybe<StudentSchoolSettingsBoolExp>;
}

/** Ordering options when selecting data from "school_settings". */
export interface StudentSchoolSettingsOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  school?: Maybe<StudentSchoolsOrderBy>;
  school_id?: Maybe<StudentOrderBy>;
  school_settings_module?: Maybe<StudentSchoolSettingsModulesOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: school_settings */
export interface StudentSchoolSettingsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings" */
export const enum StudentSchoolSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings" */
export interface StudentSchoolSettingsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings" */
export const enum StudentSchoolSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Used for UUID tokens for schools.
 *
 *
 * columns and relationships of "schools"
 */
export interface StudentSchools {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  path: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  school_setting?: EntireFieldWrapper<Maybe<StudentSchoolSettings>>;
  serial: EntireFieldWrapper<Scalars['String']>;
}

/** aggregated selection of "schools" */
export interface StudentSchoolsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentSchoolsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentSchools>>;
}

/** aggregate fields of "schools" */
export interface StudentSchoolsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentSchoolsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentSchoolsMinFields>>;
}


/** aggregate fields of "schools" */
export interface StudentSchoolsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentSchoolsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export interface StudentSchoolsBoolExp {
  _and?: Maybe<Array<StudentSchoolsBoolExp>>;
  _not?: Maybe<StudentSchoolsBoolExp>;
  _or?: Maybe<Array<StudentSchoolsBoolExp>>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  path?: Maybe<StudentStringComparisonExp>;
  school_setting?: Maybe<StudentSchoolSettingsBoolExp>;
  serial?: Maybe<StudentStringComparisonExp>;
}

/** unique or primary key constraints on table "schools" */
export const enum StudentSchoolsConstraint {
  /** unique or primary key constraint */
  SCHOOLS_PKEY = 'schools_pkey'
};

/** input type for inserting data into table "schools" */
export interface StudentSchoolsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  school_setting?: Maybe<StudentSchoolSettingsObjRelInsertInput>;
  serial?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentSchoolsMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentSchoolsMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "schools" */
export interface StudentSchoolsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentSchools>>;
}

/** input type for inserting object relation for remote table "schools" */
export interface StudentSchoolsObjRelInsertInput {
  data: StudentSchoolsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentSchoolsOnConflict>;
}

/** on conflict condition type for table "schools" */
export interface StudentSchoolsOnConflict {
  constraint: StudentSchoolsConstraint;
  update_columns?: Array<StudentSchoolsUpdateColumn>;
  where?: Maybe<StudentSchoolsBoolExp>;
}

/** Ordering options when selecting data from "schools". */
export interface StudentSchoolsOrderBy {
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  path?: Maybe<StudentOrderBy>;
  school_setting?: Maybe<StudentSchoolSettingsOrderBy>;
  serial?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: schools */
export interface StudentSchoolsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "schools" */
export const enum StudentSchoolsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** input type for updating data in table "schools" */
export interface StudentSchoolsSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
}

/** update columns of table "schools" */
export const enum StudentSchoolsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** columns and relationships of "semesters" */
export interface StudentSemesters {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_at: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  start_at: EntireFieldWrapper<Scalars['date']>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<StudentTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "semesters". All fields are combined with a logical 'AND'. */
export interface StudentSemestersBoolExp {
  _and?: Maybe<Array<StudentSemestersBoolExp>>;
  _not?: Maybe<StudentSemestersBoolExp>;
  _or?: Maybe<Array<StudentSemestersBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  end_at?: Maybe<StudentDateComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  start_at?: Maybe<StudentDateComparisonExp>;
  teaching_structure?: Maybe<StudentTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "semesters". */
export interface StudentSemestersOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  end_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  start_at?: Maybe<StudentOrderBy>;
  teaching_structure?: Maybe<StudentTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "semesters" */
export const enum StudentSemestersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_AT = 'end_at',
  /** column name */
  ID = 'id',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "student_group_users" */
export interface StudentStudentGroupUsers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  live_class_group: EntireFieldWrapper<Array<StudentStudentGroups>>;
  student_group_id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_group_users" */
export interface StudentStudentGroupUsersLiveClassGroupArgs {
  distinct_on?: Maybe<Array<StudentStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentGroupsOrderBy>>;
  where?: Maybe<StudentStudentGroupsBoolExp>;
}

/** order by aggregate values of table "student_group_users" */
export interface StudentStudentGroupUsersAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentStudentGroupUsersMaxOrderBy>;
  min?: Maybe<StudentStudentGroupUsersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "student_group_users". All fields are combined with a logical 'AND'. */
export interface StudentStudentGroupUsersBoolExp {
  _and?: Maybe<Array<StudentStudentGroupUsersBoolExp>>;
  _not?: Maybe<StudentStudentGroupUsersBoolExp>;
  _or?: Maybe<Array<StudentStudentGroupUsersBoolExp>>;
  id?: Maybe<StudentUuidComparisonExp>;
  live_class_group?: Maybe<StudentStudentGroupsBoolExp>;
  student_group_id?: Maybe<StudentUuidComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "student_group_users" */
export interface StudentStudentGroupUsersMaxOrderBy {
  id?: Maybe<StudentOrderBy>;
  student_group_id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "student_group_users" */
export interface StudentStudentGroupUsersMinOrderBy {
  id?: Maybe<StudentOrderBy>;
  student_group_id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "student_group_users". */
export interface StudentStudentGroupUsersOrderBy {
  id?: Maybe<StudentOrderBy>;
  live_class_group_aggregate?: Maybe<StudentStudentGroupsAggregateOrderBy>;
  student_group_id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "student_group_users" */
export const enum StudentStudentGroupUsersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_GROUP_ID = 'student_group_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "student_groups" */
export interface StudentStudentGroups {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lesson: EntireFieldWrapper<Array<StudentLessons>>;
  /** An aggregate relationship */
  lesson_aggregate: EntireFieldWrapper<StudentLessonsAggregate>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentStudentGroupUsers>>;
  /** An array relationship */
  teacher: EntireFieldWrapper<Array<StudentTeachers>>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_groups" */
export interface StudentStudentGroupsLessonArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentStudentGroupsLessonAggregateArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentStudentGroupsStudentsArgs {
  distinct_on?: Maybe<Array<StudentStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentGroupUsersOrderBy>>;
  where?: Maybe<StudentStudentGroupUsersBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentStudentGroupsTeacherArgs {
  distinct_on?: Maybe<Array<StudentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachersOrderBy>>;
  where?: Maybe<StudentTeachersBoolExp>;
}

/** order by aggregate values of table "student_groups" */
export interface StudentStudentGroupsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentStudentGroupsMaxOrderBy>;
  min?: Maybe<StudentStudentGroupsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "student_groups". All fields are combined with a logical 'AND'. */
export interface StudentStudentGroupsBoolExp {
  _and?: Maybe<Array<StudentStudentGroupsBoolExp>>;
  _not?: Maybe<StudentStudentGroupsBoolExp>;
  _or?: Maybe<Array<StudentStudentGroupsBoolExp>>;
  id?: Maybe<StudentUuidComparisonExp>;
  lesson?: Maybe<StudentLessonsBoolExp>;
  lesson_id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  students?: Maybe<StudentStudentGroupUsersBoolExp>;
  teacher?: Maybe<StudentTeachersBoolExp>;
  teacher_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "student_groups" */
export interface StudentStudentGroupsMaxOrderBy {
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "student_groups" */
export interface StudentStudentGroupsMinOrderBy {
  id?: Maybe<StudentOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "student_groups". */
export interface StudentStudentGroupsOrderBy {
  id?: Maybe<StudentOrderBy>;
  lesson_aggregate?: Maybe<StudentLessonsAggregateOrderBy>;
  lesson_id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  students_aggregate?: Maybe<StudentStudentGroupUsersAggregateOrderBy>;
  teacher_aggregate?: Maybe<StudentTeachersAggregateOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "student_groups" */
export const enum StudentStudentGroupsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  NAME = 'name',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "students" */
export interface StudentStudents {
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<StudentChapterSectionSubmits>>;
  /** An object relationship */
  class: EntireFieldWrapper<StudentClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  course_students: EntireFieldWrapper<Array<StudentCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
}


/** columns and relationships of "students" */
export interface StudentStudentsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentChapterSectionNotesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentStudentsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentChapterSectionSubmitsBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentStudentsCourseStudentsArgs {
  distinct_on?: Maybe<Array<StudentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseStudentOrderBy>>;
  where?: Maybe<StudentCourseStudentBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentStudentsGradesArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentStudentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}

/** aggregated selection of "students" */
export interface StudentStudentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentStudentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentStudents>>;
}

/** aggregate fields of "students" */
export interface StudentStudentsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentStudentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentStudentsMinFields>>;
}


/** aggregate fields of "students" */
export interface StudentStudentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentStudentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "students" */
export interface StudentStudentsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentStudentsMaxOrderBy>;
  min?: Maybe<StudentStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export interface StudentStudentsBoolExp {
  _and?: Maybe<Array<StudentStudentsBoolExp>>;
  _not?: Maybe<StudentStudentsBoolExp>;
  _or?: Maybe<Array<StudentStudentsBoolExp>>;
  chapter_section_notes?: Maybe<StudentChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<StudentChapterSectionSubmitsBoolExp>;
  class?: Maybe<StudentClassesBoolExp>;
  class_id?: Maybe<StudentUuidComparisonExp>;
  course_students?: Maybe<StudentCourseStudentBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  grades?: Maybe<StudentGradesBoolExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentStudentsMaxFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "students" */
export interface StudentStudentsMaxOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentStudentsMinFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "students" */
export interface StudentStudentsMinOrderBy {
  class_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "students". */
export interface StudentStudentsOrderBy {
  chapter_section_notes_aggregate?: Maybe<StudentChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<StudentChapterSectionSubmitsAggregateOrderBy>;
  class?: Maybe<StudentClassesOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
  course_students_aggregate?: Maybe<StudentCourseStudentAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  grades_aggregate?: Maybe<StudentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "students" */
export const enum StudentStudentsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "subjects" */
export interface StudentSubjects {
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentBooks>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentClassrooms>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentCourses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentViewGradeTypeSubject>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  statistics: EntireFieldWrapper<Array<StudentViewStatisticsSemesterSubjectMark>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<StudentTeacherSubject>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentViewGradesAggregate>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsBooksArgs {
  distinct_on?: Maybe<Array<StudentBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBooksOrderBy>>;
  where?: Maybe<StudentBooksBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsClassroomsArgs {
  distinct_on?: Maybe<Array<StudentClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassroomsOrderBy>>;
  where?: Maybe<StudentClassroomsBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsCoursesArgs {
  distinct_on?: Maybe<Array<StudentCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCoursesOrderBy>>;
  where?: Maybe<StudentCoursesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentViewGradeTypeSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsStatisticsArgs {
  distinct_on?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentViewStatisticsSemesterSubjectMarkBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<StudentTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeacherSubjectOrderBy>>;
  where?: Maybe<StudentTeacherSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsViewGradesArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentSubjectsViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}

/** order by aggregate values of table "subjects" */
export interface StudentSubjectsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentSubjectsMaxOrderBy>;
  min?: Maybe<StudentSubjectsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "subjects". All fields are combined with a logical 'AND'. */
export interface StudentSubjectsBoolExp {
  _and?: Maybe<Array<StudentSubjectsBoolExp>>;
  _not?: Maybe<StudentSubjectsBoolExp>;
  _or?: Maybe<Array<StudentSubjectsBoolExp>>;
  books?: Maybe<StudentBooksBoolExp>;
  classrooms?: Maybe<StudentClassroomsBoolExp>;
  courses?: Maybe<StudentCoursesBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  grade_types?: Maybe<StudentViewGradeTypeSubjectBoolExp>;
  icon?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  statistics?: Maybe<StudentViewStatisticsSemesterSubjectMarkBoolExp>;
  teacher_subjects?: Maybe<StudentTeacherSubjectBoolExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  view_grades?: Maybe<StudentViewGradesBoolExp>;
}

/** order by max() on columns of table "subjects" */
export interface StudentSubjectsMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  icon?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "subjects" */
export interface StudentSubjectsMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  icon?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "subjects". */
export interface StudentSubjectsOrderBy {
  books_aggregate?: Maybe<StudentBooksAggregateOrderBy>;
  classrooms_aggregate?: Maybe<StudentClassroomsAggregateOrderBy>;
  courses_aggregate?: Maybe<StudentCoursesAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  grade_types_aggregate?: Maybe<StudentViewGradeTypeSubjectAggregateOrderBy>;
  icon?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  statistics_aggregate?: Maybe<StudentViewStatisticsSemesterSubjectMarkAggregateOrderBy>;
  teacher_subjects_aggregate?: Maybe<StudentTeacherSubjectAggregateOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  view_grades_aggregate?: Maybe<StudentViewGradesAggregateOrderBy>;
}

/** select columns of table "subjects" */
export const enum StudentSubjectsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface StudentSubscriptionRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<StudentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<StudentAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<StudentAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<StudentAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<StudentAssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<StudentAssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<StudentAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<StudentAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<StudentAssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<StudentAssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<StudentAssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<StudentAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestionOptions>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<StudentAssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<StudentAssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<StudentAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<StudentAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<StudentAssignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<StudentAttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<StudentAttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<StudentAttendances>>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<StudentAttendances>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<StudentBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<StudentBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<StudentBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<StudentBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<StudentBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<StudentBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<StudentBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<StudentBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<StudentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<StudentChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<StudentChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<StudentChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<StudentChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<StudentChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<StudentChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<StudentChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<StudentClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<StudentClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<StudentClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<StudentClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<StudentClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<StudentClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<StudentCourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<StudentCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<StudentCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<StudentCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<StudentCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<StudentCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<StudentCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<StudentCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<StudentCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<StudentEventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<StudentEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<StudentEvents>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<StudentEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<StudentFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<StudentGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<StudentGrades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<StudentLatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<StudentLatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<StudentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<StudentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<StudentLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<StudentLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentLessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<StudentLessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<StudentLiveClassAttendees>>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<StudentLiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<StudentLiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<StudentLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<StudentMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<StudentMarks>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<StudentMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<StudentMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<StudentMeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<StudentNotifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<StudentNotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<StudentNotifications>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<StudentParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<StudentParents>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<StudentPromotions>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<StudentSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<StudentSemesters>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<StudentStudentGroupUsers>>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<StudentStudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<StudentStudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<StudentStudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentStudents>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentStudentsAggregate>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<StudentStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<StudentSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<StudentTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<StudentTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<StudentTasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<StudentTeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<StudentTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<StudentTeachingStructureStudents>>;
  /** fetch data from the table: "teaching_structure_students" using primary key columns */
  teaching_structure_students_by_pk?: EntireFieldWrapper<Maybe<StudentTeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<StudentTeachingStructures>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<StudentViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<StudentViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<StudentViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<StudentViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentViewGradesAggregate>;
  /** fetch data from the table: "view.grades_for_students" */
  view_grades_for_students: EntireFieldWrapper<Array<StudentViewGradesForStudents>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<StudentViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<StudentViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<StudentViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<StudentViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<StudentViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<StudentYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<StudentYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<StudentYears>>;
}


export interface StudentSubscriptionRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<StudentAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<StudentAssignmentAttendeeTypeBoolExp>;
}


export interface StudentSubscriptionRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface StudentSubscriptionRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<StudentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentAssignmentBookChapterBoolExp>;
}


export interface StudentSubscriptionRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionBoolExp>;
}


export interface StudentSubscriptionRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionContentBoolExp>;
}


export interface StudentSubscriptionRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<StudentAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<StudentAssignmentDiscussionSubscriptionBoolExp>;
}


export interface StudentSubscriptionRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<StudentAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentFilesOrderBy>>;
  where?: Maybe<StudentAssignmentFilesBoolExp>;
}


export interface StudentSubscriptionRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentAssignmentGradeWeightsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentAssignmentGradeWeightsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<StudentAssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentNotesOrderBy>>;
  where?: Maybe<StudentAssignmentNotesBoolExp>;
}


export interface StudentSubscriptionRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionAnswersBoolExp>;
}


export interface StudentSubscriptionRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionOptionRelationsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionOptionsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuestionsOrderBy>>;
  where?: Maybe<StudentAssignmentQuestionsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<StudentAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentQuizOrderBy>>;
  where?: Maybe<StudentAssignmentQuizBoolExp>;
}


export interface StudentSubscriptionRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentAssignmentSubmitsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<StudentAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentTypeOrderBy>>;
  where?: Maybe<StudentAssignmentTypeBoolExp>;
}


export interface StudentSubscriptionRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentSubscriptionRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<StudentAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentUserOrderBy>>;
  where?: Maybe<StudentAssignmentUserBoolExp>;
}


export interface StudentSubscriptionRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


export interface StudentSubscriptionRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<StudentAttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAttendanceTypesOrderBy>>;
  where?: Maybe<StudentAttendanceTypesBoolExp>;
}


export interface StudentSubscriptionRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface StudentSubscriptionRootAttendancesArgs {
  distinct_on?: Maybe<Array<StudentAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAttendancesOrderBy>>;
  where?: Maybe<StudentAttendancesBoolExp>;
}


export interface StudentSubscriptionRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<StudentBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookChapterTypeOrderBy>>;
  where?: Maybe<StudentBookChapterTypeBoolExp>;
}


export interface StudentSubscriptionRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentSubscriptionRootBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookChaptersOrderBy>>;
  where?: Maybe<StudentBookChaptersBoolExp>;
}


export interface StudentSubscriptionRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootBookCourseArgs {
  distinct_on?: Maybe<Array<StudentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookCourseOrderBy>>;
  where?: Maybe<StudentBookCourseBoolExp>;
}


export interface StudentSubscriptionRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootBookUserArgs {
  distinct_on?: Maybe<Array<StudentBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBookUserOrderBy>>;
  where?: Maybe<StudentBookUserBoolExp>;
}


export interface StudentSubscriptionRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootBooksArgs {
  distinct_on?: Maybe<Array<StudentBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentBooksOrderBy>>;
  where?: Maybe<StudentBooksBoolExp>;
}


export interface StudentSubscriptionRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentChapterSectionNotesBoolExp>;
}


export interface StudentSubscriptionRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentChapterSectionSubmitsBoolExp>;
}


export interface StudentSubscriptionRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionTypeOrderBy>>;
  where?: Maybe<StudentChapterSectionTypeBoolExp>;
}


export interface StudentSubscriptionRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentSubscriptionRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChapterSectionsOrderBy>>;
  where?: Maybe<StudentChapterSectionsBoolExp>;
}


export interface StudentSubscriptionRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentChatMessageLikesBoolExp>;
}


export interface StudentSubscriptionRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentChatMessageLikesBoolExp>;
}


export interface StudentSubscriptionRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessageReadsOrderBy>>;
  where?: Maybe<StudentChatMessageReadsBoolExp>;
}


export interface StudentSubscriptionRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


export interface StudentSubscriptionRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatMessagesOrderBy>>;
  where?: Maybe<StudentChatMessagesBoolExp>;
}


export interface StudentSubscriptionRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChatTypeArgs {
  distinct_on?: Maybe<Array<StudentChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatTypeOrderBy>>;
  where?: Maybe<StudentChatTypeBoolExp>;
}


export interface StudentSubscriptionRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentSubscriptionRootChatUserArgs {
  distinct_on?: Maybe<Array<StudentChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatUserOrderBy>>;
  where?: Maybe<StudentChatUserBoolExp>;
}


export interface StudentSubscriptionRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootChatsArgs {
  distinct_on?: Maybe<Array<StudentChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentChatsOrderBy>>;
  where?: Maybe<StudentChatsBoolExp>;
}


export interface StudentSubscriptionRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootClassLevelsArgs {
  distinct_on?: Maybe<Array<StudentClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassLevelsOrderBy>>;
  where?: Maybe<StudentClassLevelsBoolExp>;
}


export interface StudentSubscriptionRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootClassTypeArgs {
  distinct_on?: Maybe<Array<StudentClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassTypeOrderBy>>;
  where?: Maybe<StudentClassTypeBoolExp>;
}


export interface StudentSubscriptionRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentSubscriptionRootClassesArgs {
  distinct_on?: Maybe<Array<StudentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassesOrderBy>>;
  where?: Maybe<StudentClassesBoolExp>;
}


export interface StudentSubscriptionRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootClassroomsArgs {
  distinct_on?: Maybe<Array<StudentClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassroomsOrderBy>>;
  where?: Maybe<StudentClassroomsBoolExp>;
}


export interface StudentSubscriptionRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootCourseClassArgs {
  distinct_on?: Maybe<Array<StudentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassOrderBy>>;
  where?: Maybe<StudentCourseClassBoolExp>;
}


export interface StudentSubscriptionRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<StudentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseClassroomOrderBy>>;
  where?: Maybe<StudentCourseClassroomBoolExp>;
}


export interface StudentSubscriptionRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootCourseStudentArgs {
  distinct_on?: Maybe<Array<StudentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseStudentOrderBy>>;
  where?: Maybe<StudentCourseStudentBoolExp>;
}


export interface StudentSubscriptionRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<StudentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseTeacherOrderBy>>;
  where?: Maybe<StudentCourseTeacherBoolExp>;
}


export interface StudentSubscriptionRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootCoursesArgs {
  distinct_on?: Maybe<Array<StudentCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCoursesOrderBy>>;
  where?: Maybe<StudentCoursesBoolExp>;
}


export interface StudentSubscriptionRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootEventUsersArgs {
  distinct_on?: Maybe<Array<StudentEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentEventUsersOrderBy>>;
  where?: Maybe<StudentEventUsersBoolExp>;
}


export interface StudentSubscriptionRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootEventsArgs {
  distinct_on?: Maybe<Array<StudentEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentEventsOrderBy>>;
  where?: Maybe<StudentEventsBoolExp>;
}


export interface StudentSubscriptionRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootFilesArgs {
  distinct_on?: Maybe<Array<StudentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentFilesOrderBy>>;
  where?: Maybe<StudentFilesBoolExp>;
}


export interface StudentSubscriptionRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradeTypesOrderBy>>;
  where?: Maybe<StudentGradeTypesBoolExp>;
}


export interface StudentSubscriptionRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootGradesArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


export interface StudentSubscriptionRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradesOrderBy>>;
  where?: Maybe<StudentGradesBoolExp>;
}


export interface StudentSubscriptionRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<StudentLatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLatestActivitiesOrderBy>>;
  where?: Maybe<StudentLatestActivitiesBoolExp>;
}


export interface StudentSubscriptionRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<StudentLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonAttendaceTypeOrderBy>>;
  where?: Maybe<StudentLessonAttendaceTypeBoolExp>;
}


export interface StudentSubscriptionRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentSubscriptionRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<StudentLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonAttendancesOrderBy>>;
  where?: Maybe<StudentLessonAttendancesBoolExp>;
}


export interface StudentSubscriptionRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootLessonsArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


export interface StudentSubscriptionRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLessonsOrderBy>>;
  where?: Maybe<StudentLessonsBoolExp>;
}


export interface StudentSubscriptionRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<StudentLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLiveClassAttendeesOrderBy>>;
  where?: Maybe<StudentLiveClassAttendeesBoolExp>;
}


export interface StudentSubscriptionRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootLiveClassesArgs {
  distinct_on?: Maybe<Array<StudentLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentLiveClassesOrderBy>>;
  where?: Maybe<StudentLiveClassesBoolExp>;
}


export interface StudentSubscriptionRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootMarksArgs {
  distinct_on?: Maybe<Array<StudentMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentMarksOrderBy>>;
  where?: Maybe<StudentMarksBoolExp>;
}


export interface StudentSubscriptionRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootMeetingUserArgs {
  distinct_on?: Maybe<Array<StudentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentMeetingUserOrderBy>>;
  where?: Maybe<StudentMeetingUserBoolExp>;
}


export interface StudentSubscriptionRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<StudentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentMeetingUserOrderBy>>;
  where?: Maybe<StudentMeetingUserBoolExp>;
}


export interface StudentSubscriptionRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootNotificationsArgs {
  distinct_on?: Maybe<Array<StudentNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentNotificationsOrderBy>>;
  where?: Maybe<StudentNotificationsBoolExp>;
}


export interface StudentSubscriptionRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<StudentNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentNotificationsOrderBy>>;
  where?: Maybe<StudentNotificationsBoolExp>;
}


export interface StudentSubscriptionRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootParentsArgs {
  distinct_on?: Maybe<Array<StudentParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentParentsOrderBy>>;
  where?: Maybe<StudentParentsBoolExp>;
}


export interface StudentSubscriptionRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootPromotionsArgs {
  distinct_on?: Maybe<Array<StudentPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPromotionsOrderBy>>;
  where?: Maybe<StudentPromotionsBoolExp>;
}


export interface StudentSubscriptionRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootSemestersArgs {
  distinct_on?: Maybe<Array<StudentSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSemestersOrderBy>>;
  where?: Maybe<StudentSemestersBoolExp>;
}


export interface StudentSubscriptionRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<StudentStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentGroupUsersOrderBy>>;
  where?: Maybe<StudentStudentGroupUsersBoolExp>;
}


export interface StudentSubscriptionRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<StudentStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentGroupsOrderBy>>;
  where?: Maybe<StudentStudentGroupsBoolExp>;
}


export interface StudentSubscriptionRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentsOrderBy>>;
  where?: Maybe<StudentStudentsBoolExp>;
}


export interface StudentSubscriptionRootStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentStudentsOrderBy>>;
  where?: Maybe<StudentStudentsBoolExp>;
}


export interface StudentSubscriptionRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootSubjectsArgs {
  distinct_on?: Maybe<Array<StudentSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSubjectsOrderBy>>;
  where?: Maybe<StudentSubjectsBoolExp>;
}


export interface StudentSubscriptionRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootTasksArgs {
  distinct_on?: Maybe<Array<StudentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTasksOrderBy>>;
  where?: Maybe<StudentTasksBoolExp>;
}


export interface StudentSubscriptionRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<StudentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTasksOrderBy>>;
  where?: Maybe<StudentTasksBoolExp>;
}


export interface StudentSubscriptionRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<StudentTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeacherSubjectOrderBy>>;
  where?: Maybe<StudentTeacherSubjectBoolExp>;
}


export interface StudentSubscriptionRootTeachersArgs {
  distinct_on?: Maybe<Array<StudentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachersOrderBy>>;
  where?: Maybe<StudentTeachersBoolExp>;
}


export interface StudentSubscriptionRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootTeachingStructureLeafsArgs {
  args: StudentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructureLeafsAggregateArgs {
  args: StudentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructureParentsArgs {
  args: StudentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructureParentsAggregateArgs {
  args: StudentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructureStudentsOrderBy>>;
  where?: Maybe<StudentTeachingStructureStudentsBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructureStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


export interface StudentSubscriptionRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentSubscriptionRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<StudentViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentViewAssignmentClassBoolExp>;
}


export interface StudentSubscriptionRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<StudentViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<StudentViewAssignmentStudentGradeBoolExp>;
}


export interface StudentSubscriptionRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<StudentViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewClassStudentOrderBy>>;
  where?: Maybe<StudentViewClassStudentBoolExp>;
}


export interface StudentSubscriptionRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<StudentViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentViewGradeTypeSubjectBoolExp>;
}


export interface StudentSubscriptionRootViewGradesArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}


export interface StudentSubscriptionRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesOrderBy>>;
  where?: Maybe<StudentViewGradesBoolExp>;
}


export interface StudentSubscriptionRootViewGradesForStudentsArgs {
  distinct_on?: Maybe<Array<StudentViewGradesForStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewGradesForStudentsOrderBy>>;
  where?: Maybe<StudentViewGradesForStudentsBoolExp>;
}


export interface StudentSubscriptionRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentViewLatestChatMessagesBoolExp>;
}


export interface StudentSubscriptionRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentViewLatestChatMessagesBoolExp>;
}


export interface StudentSubscriptionRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface StudentSubscriptionRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<StudentViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewSubjectSemesterOrderBy>>;
  where?: Maybe<StudentViewSubjectSemesterBoolExp>;
}


export interface StudentSubscriptionRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<StudentViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<StudentViewTeacherClassSubjectBoolExp>;
}


export interface StudentSubscriptionRootYearsArgs {
  distinct_on?: Maybe<Array<StudentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentYearsOrderBy>>;
  where?: Maybe<StudentYearsBoolExp>;
}


export interface StudentSubscriptionRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<StudentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentYearsOrderBy>>;
  where?: Maybe<StudentYearsBoolExp>;
}


export interface StudentSubscriptionRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "tasks" */
export interface StudentTasks {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** The user this tasks belongs. */
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "tasks" */
export interface StudentTasksAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentTasksAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentTasks>>;
}

/** aggregate fields of "tasks" */
export interface StudentTasksAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentTasksMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentTasksMinFields>>;
}


/** aggregate fields of "tasks" */
export interface StudentTasksAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentTasksSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export interface StudentTasksBoolExp {
  _and?: Maybe<Array<StudentTasksBoolExp>>;
  _not?: Maybe<StudentTasksBoolExp>;
  _or?: Maybe<Array<StudentTasksBoolExp>>;
  body?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  is_completed?: Maybe<StudentBooleanComparisonExp>;
  title?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** unique or primary key constraints on table "tasks" */
export const enum StudentTasksConstraint {
  /** unique or primary key constraint */
  TASKS_PKEY = 'tasks_pkey'
};

/** input type for inserting data into table "tasks" */
export interface StudentTasksInsertInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentTasksMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentTasksMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "tasks" */
export interface StudentTasksMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentTasks>>;
}

/** on conflict condition type for table "tasks" */
export interface StudentTasksOnConflict {
  constraint: StudentTasksConstraint;
  update_columns?: Array<StudentTasksUpdateColumn>;
  where?: Maybe<StudentTasksBoolExp>;
}

/** Ordering options when selecting data from "tasks". */
export interface StudentTasksOrderBy {
  body?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  is_completed?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: tasks */
export interface StudentTasksPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "tasks" */
export const enum StudentTasksSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "tasks" */
export interface StudentTasksSetInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "tasks" */
export const enum StudentTasksUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Connection between teachers and subjects with relevant teaching structure
 *
 *
 * columns and relationships of "teacher_subject"
 */
export interface StudentTeacherSubject {
  /** An object relationship */
  subject: EntireFieldWrapper<StudentSubjects>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<StudentTeachingStructures>;
}

/** order by aggregate values of table "teacher_subject" */
export interface StudentTeacherSubjectAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentTeacherSubjectMaxOrderBy>;
  min?: Maybe<StudentTeacherSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teacher_subject". All fields are combined with a logical 'AND'. */
export interface StudentTeacherSubjectBoolExp {
  _and?: Maybe<Array<StudentTeacherSubjectBoolExp>>;
  _not?: Maybe<StudentTeacherSubjectBoolExp>;
  _or?: Maybe<Array<StudentTeacherSubjectBoolExp>>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  teacher?: Maybe<StudentTeachersBoolExp>;
  teacher_id?: Maybe<StudentUuidComparisonExp>;
  teaching_structure?: Maybe<StudentTeachingStructuresBoolExp>;
}

/** order by max() on columns of table "teacher_subject" */
export interface StudentTeacherSubjectMaxOrderBy {
  teacher_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "teacher_subject" */
export interface StudentTeacherSubjectMinOrderBy {
  teacher_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "teacher_subject". */
export interface StudentTeacherSubjectOrderBy {
  subject?: Maybe<StudentSubjectsOrderBy>;
  teacher?: Maybe<StudentTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
  teaching_structure?: Maybe<StudentTeachingStructuresOrderBy>;
}

/** select columns of table "teacher_subject" */
export const enum StudentTeacherSubjectSelectColumn {
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "teachers" */
export interface StudentTeachers {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentClasses>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<StudentClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<StudentCourseTeacher>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<StudentTeacherSubject>>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
}


/** columns and relationships of "teachers" */
export interface StudentTeachersClassesArgs {
  distinct_on?: Maybe<Array<StudentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentClassesOrderBy>>;
  where?: Maybe<StudentClassesBoolExp>;
}


/** columns and relationships of "teachers" */
export interface StudentTeachersCourseTeachersArgs {
  distinct_on?: Maybe<Array<StudentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentCourseTeacherOrderBy>>;
  where?: Maybe<StudentCourseTeacherBoolExp>;
}


/** columns and relationships of "teachers" */
export interface StudentTeachersTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<StudentTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeacherSubjectOrderBy>>;
  where?: Maybe<StudentTeacherSubjectBoolExp>;
}

/** order by aggregate values of table "teachers" */
export interface StudentTeachersAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentTeachersMaxOrderBy>;
  min?: Maybe<StudentTeachersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export interface StudentTeachersBoolExp {
  _and?: Maybe<Array<StudentTeachersBoolExp>>;
  _not?: Maybe<StudentTeachersBoolExp>;
  _or?: Maybe<Array<StudentTeachersBoolExp>>;
  classes?: Maybe<StudentClassesBoolExp>;
  classroom?: Maybe<StudentClassroomsBoolExp>;
  classroom_id?: Maybe<StudentUuidComparisonExp>;
  course_teachers?: Maybe<StudentCourseTeacherBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  teacher_subjects?: Maybe<StudentTeacherSubjectBoolExp>;
  type?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "teachers" */
export interface StudentTeachersMaxOrderBy {
  classroom_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "teachers" */
export interface StudentTeachersMinOrderBy {
  classroom_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "teachers". */
export interface StudentTeachersOrderBy {
  classes_aggregate?: Maybe<StudentClassesAggregateOrderBy>;
  classroom?: Maybe<StudentClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrderBy>;
  course_teachers_aggregate?: Maybe<StudentCourseTeacherAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  teacher_subjects_aggregate?: Maybe<StudentTeacherSubjectAggregateOrderBy>;
  type?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "teachers" */
export const enum StudentTeachersSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface StudentTeachingStructureLeafsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

export interface StudentTeachingStructureParentsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "teaching_structure_students" */
export interface StudentTeachingStructureStudents {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<StudentTeachingStructures>;
  teaching_structure_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teaching_structure_students_subject: EntireFieldWrapper<Array<StudentSubjects>>;
}


/** columns and relationships of "teaching_structure_students" */
export interface StudentTeachingStructureStudentsTeachingStructureStudentsSubjectArgs {
  distinct_on?: Maybe<Array<StudentSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentSubjectsOrderBy>>;
  where?: Maybe<StudentSubjectsBoolExp>;
}

/** order by aggregate values of table "teaching_structure_students" */
export interface StudentTeachingStructureStudentsAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentTeachingStructureStudentsMaxOrderBy>;
  min?: Maybe<StudentTeachingStructureStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structure_students". All fields are combined with a logical 'AND'. */
export interface StudentTeachingStructureStudentsBoolExp {
  _and?: Maybe<Array<StudentTeachingStructureStudentsBoolExp>>;
  _not?: Maybe<StudentTeachingStructureStudentsBoolExp>;
  _or?: Maybe<Array<StudentTeachingStructureStudentsBoolExp>>;
  id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  teaching_structure?: Maybe<StudentTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentUuidComparisonExp>;
  teaching_structure_students_subject?: Maybe<StudentSubjectsBoolExp>;
}

/** order by max() on columns of table "teaching_structure_students" */
export interface StudentTeachingStructureStudentsMaxOrderBy {
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "teaching_structure_students" */
export interface StudentTeachingStructureStudentsMinOrderBy {
  id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "teaching_structure_students". */
export interface StudentTeachingStructureStudentsOrderBy {
  id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teaching_structure?: Maybe<StudentTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrderBy>;
  teaching_structure_students_subject_aggregate?: Maybe<StudentSubjectsAggregateOrderBy>;
}

/** select columns of table "teaching_structure_students" */
export const enum StudentTeachingStructureStudentsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id'
};

/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructures {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentAssignmentsAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  depth: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  ltr: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  parent?: EntireFieldWrapper<Maybe<StudentTeachingStructures>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<StudentSemesters>>;
  /** A computed field, executes function "subject_icon" */
  subject_icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<StudentTeacherSubject>>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<StudentTeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentTeachingStructuresAggregate>;
  title: EntireFieldWrapper<Scalars['String']>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructuresAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructuresAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentAssignmentsOrderBy>>;
  where?: Maybe<StudentAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructuresTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<StudentTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeacherSubjectOrderBy>>;
  where?: Maybe<StudentTeacherSubjectBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructuresTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructureStudentsOrderBy>>;
  where?: Maybe<StudentTeachingStructureStudentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructuresTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentTeachingStructuresTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentTeachingStructuresBoolExp>;
}

/** aggregated selection of "teaching_structures" */
export interface StudentTeachingStructuresAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentTeachingStructuresAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentTeachingStructures>>;
}

/** aggregate fields of "teaching_structures" */
export interface StudentTeachingStructuresAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentTeachingStructuresAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentTeachingStructuresMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentTeachingStructuresMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentTeachingStructuresStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentTeachingStructuresStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentTeachingStructuresStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentTeachingStructuresSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentTeachingStructuresVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentTeachingStructuresVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentTeachingStructuresVarianceFields>>;
}


/** aggregate fields of "teaching_structures" */
export interface StudentTeachingStructuresAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentTeachingStructuresSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "teaching_structures" */
export interface StudentTeachingStructuresAggregateOrderBy {
  avg?: Maybe<StudentTeachingStructuresAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentTeachingStructuresMaxOrderBy>;
  min?: Maybe<StudentTeachingStructuresMinOrderBy>;
  stddev?: Maybe<StudentTeachingStructuresStddevOrderBy>;
  stddev_pop?: Maybe<StudentTeachingStructuresStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentTeachingStructuresStddevSampOrderBy>;
  sum?: Maybe<StudentTeachingStructuresSumOrderBy>;
  var_pop?: Maybe<StudentTeachingStructuresVarPopOrderBy>;
  var_samp?: Maybe<StudentTeachingStructuresVarSampOrderBy>;
  variance?: Maybe<StudentTeachingStructuresVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentTeachingStructuresAvgFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresAvgOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structures". All fields are combined with a logical 'AND'. */
export interface StudentTeachingStructuresBoolExp {
  _and?: Maybe<Array<StudentTeachingStructuresBoolExp>>;
  _not?: Maybe<StudentTeachingStructuresBoolExp>;
  _or?: Maybe<Array<StudentTeachingStructuresBoolExp>>;
  assignments?: Maybe<StudentAssignmentsBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  depth?: Maybe<StudentIntComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  ltr?: Maybe<StudentIntComparisonExp>;
  parent?: Maybe<StudentTeachingStructuresBoolExp>;
  parent_id?: Maybe<StudentUuidComparisonExp>;
  rtl?: Maybe<StudentIntComparisonExp>;
  semester?: Maybe<StudentSemestersBoolExp>;
  subject_icon?: Maybe<StudentStringComparisonExp>;
  teacher_subjects?: Maybe<StudentTeacherSubjectBoolExp>;
  teaching_structure_students?: Maybe<StudentTeachingStructureStudentsBoolExp>;
  teaching_structures?: Maybe<StudentTeachingStructuresBoolExp>;
  title?: Maybe<StudentStringComparisonExp>;
  type_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentTeachingStructuresMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  depth?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  parent_id?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentTeachingStructuresMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  depth?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  parent_id?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "teaching_structures". */
export interface StudentTeachingStructuresOrderBy {
  assignments_aggregate?: Maybe<StudentAssignmentsAggregateOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  depth?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  parent?: Maybe<StudentTeachingStructuresOrderBy>;
  parent_id?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
  semester?: Maybe<StudentSemestersOrderBy>;
  subject_icon?: Maybe<StudentOrderBy>;
  teacher_subjects_aggregate?: Maybe<StudentTeacherSubjectAggregateOrderBy>;
  teaching_structure_students_aggregate?: Maybe<StudentTeachingStructureStudentsAggregateOrderBy>;
  teaching_structures_aggregate?: Maybe<StudentTeachingStructuresAggregateOrderBy>;
  title?: Maybe<StudentOrderBy>;
  type_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "teaching_structures" */
export const enum StudentTeachingStructuresSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPTH = 'depth',
  /** column name */
  ID = 'id',
  /** column name */
  LTR = 'ltr',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  RTL = 'rtl',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE_ID = 'type_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface StudentTeachingStructuresStddevFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresStddevOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentTeachingStructuresStddevPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresStddevPopOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentTeachingStructuresStddevSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresStddevSampOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentTeachingStructuresSumFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresSumOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentTeachingStructuresVarPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresVarPopOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentTeachingStructuresVarSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresVarSampOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentTeachingStructuresVarianceFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "teaching_structures" */
export interface StudentTeachingStructuresVarianceOrderBy {
  depth?: Maybe<StudentOrderBy>;
  ltr?: Maybe<StudentOrderBy>;
  rtl?: Maybe<StudentOrderBy>;
}


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export interface StudentTimestampComparisonExp {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
}


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface StudentTimestamptzComparisonExp {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
}


/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export interface StudentTimetzComparisonExp {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
}

/** columns and relationships of "users" */
export interface StudentUsers {
  /** An object relationship */
  account?: EntireFieldWrapper<Maybe<StudentAuthAccounts>>;
  /** An object relationship */
  address?: EntireFieldWrapper<Maybe<StudentPrivateAdresses>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  birthday?: EntireFieldWrapper<Maybe<StudentPrivateBirthdays>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** A computed field, executes function "user_full_name" */
  full_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<StudentPrivateInsuranceNumbers>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  phone_number?: EntireFieldWrapper<Maybe<StudentPrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<StudentRelationships>>;
  /** An array relationship */
  relationshipsByUserId: EntireFieldWrapper<Array<StudentRelationships>>;
  /** An aggregate relationship */
  relationshipsByUserId_aggregate: EntireFieldWrapper<StudentRelationshipsAggregate>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<StudentRelationshipsAggregate>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "users" */
export interface StudentUsersRelationshipsArgs {
  distinct_on?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentRelationshipsOrderBy>>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentUsersRelationshipsByUserIdArgs {
  distinct_on?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentRelationshipsOrderBy>>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentUsersRelationshipsByUserIdAggregateArgs {
  distinct_on?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentRelationshipsOrderBy>>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentUsersRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<StudentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentRelationshipsOrderBy>>;
  where?: Maybe<StudentRelationshipsBoolExp>;
}

/** aggregated selection of "users" */
export interface StudentUsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentUsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentUsers>>;
}

/** aggregate fields of "users" */
export interface StudentUsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentUsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentUsersMinFields>>;
}


/** aggregate fields of "users" */
export interface StudentUsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentUsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface StudentUsersBoolExp {
  _and?: Maybe<Array<StudentUsersBoolExp>>;
  _not?: Maybe<StudentUsersBoolExp>;
  _or?: Maybe<Array<StudentUsersBoolExp>>;
  account?: Maybe<StudentAuthAccountsBoolExp>;
  address?: Maybe<StudentPrivateAdressesBoolExp>;
  avatar_url?: Maybe<StudentStringComparisonExp>;
  birthday?: Maybe<StudentPrivateBirthdaysBoolExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  first_name?: Maybe<StudentStringComparisonExp>;
  full_name?: Maybe<StudentStringComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  insurance_number?: Maybe<StudentPrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<StudentStringComparisonExp>;
  phone_number?: Maybe<StudentPrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<StudentRelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<StudentRelationshipsBoolExp>;
  title?: Maybe<StudentStringComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "users" */
export const enum StudentUsersConstraint {
  /** unique or primary key constraint */
  USERS_PKEY = 'users_pkey'
};

/** input type for inserting data into table "users" */
export interface StudentUsersInsertInput {
  account?: Maybe<StudentAuthAccountsObjRelInsertInput>;
  address?: Maybe<StudentPrivateAdressesObjRelInsertInput>;
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<StudentPrivateBirthdaysObjRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<StudentPrivateInsuranceNumbersObjRelInsertInput>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<StudentPrivatePhoneNumbersObjRelInsertInput>;
  relationships?: Maybe<StudentRelationshipsArrRelInsertInput>;
  relationshipsByUserId?: Maybe<StudentRelationshipsArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentUsersMaxFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentUsersMinFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "users" */
export interface StudentUsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentUsers>>;
}

/** input type for inserting object relation for remote table "users" */
export interface StudentUsersObjRelInsertInput {
  data: StudentUsersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentUsersOnConflict>;
}

/** on conflict condition type for table "users" */
export interface StudentUsersOnConflict {
  constraint: StudentUsersConstraint;
  update_columns?: Array<StudentUsersUpdateColumn>;
  where?: Maybe<StudentUsersBoolExp>;
}

/** Ordering options when selecting data from "users". */
export interface StudentUsersOrderBy {
  account?: Maybe<StudentAuthAccountsOrderBy>;
  address?: Maybe<StudentPrivateAdressesOrderBy>;
  avatar_url?: Maybe<StudentOrderBy>;
  birthday?: Maybe<StudentPrivateBirthdaysOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  first_name?: Maybe<StudentOrderBy>;
  full_name?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  insurance_number?: Maybe<StudentPrivateInsuranceNumbersOrderBy>;
  last_name?: Maybe<StudentOrderBy>;
  phone_number?: Maybe<StudentPrivatePhoneNumbersOrderBy>;
  relationshipsByUserId_aggregate?: Maybe<StudentRelationshipsAggregateOrderBy>;
  relationships_aggregate?: Maybe<StudentRelationshipsAggregateOrderBy>;
  title?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** primary key columns input for table: users */
export interface StudentUsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "users" */
export const enum StudentUsersSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "users" */
export interface StudentUsersSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "users" */
export const enum StudentUsersUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface StudentUuidComparisonExp {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

/** columns and relationships of "view.assignment_class" */
export interface StudentViewAssignmentClass {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.assignment_class" */
export interface StudentViewAssignmentClassAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentViewAssignmentClassMaxOrderBy>;
  min?: Maybe<StudentViewAssignmentClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.assignment_class". All fields are combined with a logical 'AND'. */
export interface StudentViewAssignmentClassBoolExp {
  _and?: Maybe<Array<StudentViewAssignmentClassBoolExp>>;
  _not?: Maybe<StudentViewAssignmentClassBoolExp>;
  _or?: Maybe<Array<StudentViewAssignmentClassBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  class?: Maybe<StudentClassesBoolExp>;
  class_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "view.assignment_class" */
export interface StudentViewAssignmentClassMaxOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "view.assignment_class" */
export interface StudentViewAssignmentClassMinOrderBy {
  assignment_id?: Maybe<StudentOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "view.assignment_class". */
export interface StudentViewAssignmentClassOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  class?: Maybe<StudentClassesOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.assignment_class" */
export const enum StudentViewAssignmentClassSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id'
};

/** columns and relationships of "view.assignment_student_grade" */
export interface StudentViewAssignmentStudentGrade {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  grade?: EntireFieldWrapper<Maybe<StudentGrades>>;
  grade_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.assignment_student_grade". All fields are combined with a logical 'AND'. */
export interface StudentViewAssignmentStudentGradeBoolExp {
  _and?: Maybe<Array<StudentViewAssignmentStudentGradeBoolExp>>;
  _not?: Maybe<StudentViewAssignmentStudentGradeBoolExp>;
  _or?: Maybe<Array<StudentViewAssignmentStudentGradeBoolExp>>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  grade?: Maybe<StudentGradesBoolExp>;
  grade_id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.assignment_student_grade". */
export interface StudentViewAssignmentStudentGradeOrderBy {
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  grade?: Maybe<StudentGradesOrderBy>;
  grade_id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.assignment_student_grade" */
export const enum StudentViewAssignmentStudentGradeSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  GRADE_ID = 'grade_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.class_student" */
export interface StudentViewClassStudent {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.class_student". All fields are combined with a logical 'AND'. */
export interface StudentViewClassStudentBoolExp {
  _and?: Maybe<Array<StudentViewClassStudentBoolExp>>;
  _not?: Maybe<StudentViewClassStudentBoolExp>;
  _or?: Maybe<Array<StudentViewClassStudentBoolExp>>;
  class?: Maybe<StudentClassesBoolExp>;
  class_id?: Maybe<StudentUuidComparisonExp>;
  student?: Maybe<StudentStudentsBoolExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.class_student". */
export interface StudentViewClassStudentOrderBy {
  class?: Maybe<StudentClassesOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
  student?: Maybe<StudentStudentsOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.class_student" */
export const enum StudentViewClassStudentSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.grade_type_subject" */
export interface StudentViewGradeTypeSubject {
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentGradeTypes>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "view.grade_type_subject" */
export interface StudentViewGradeTypeSubjectGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGradeTypesOrderBy>>;
  where?: Maybe<StudentGradeTypesBoolExp>;
}

/** order by aggregate values of table "view.grade_type_subject" */
export interface StudentViewGradeTypeSubjectAggregateOrderBy {
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentViewGradeTypeSubjectMaxOrderBy>;
  min?: Maybe<StudentViewGradeTypeSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grade_type_subject". All fields are combined with a logical 'AND'. */
export interface StudentViewGradeTypeSubjectBoolExp {
  _and?: Maybe<Array<StudentViewGradeTypeSubjectBoolExp>>;
  _not?: Maybe<StudentViewGradeTypeSubjectBoolExp>;
  _or?: Maybe<Array<StudentViewGradeTypeSubjectBoolExp>>;
  grade_type?: Maybe<StudentGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentUuidComparisonExp>;
  grade_types?: Maybe<StudentGradeTypesBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "view.grade_type_subject" */
export interface StudentViewGradeTypeSubjectMaxOrderBy {
  grade_type_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "view.grade_type_subject" */
export interface StudentViewGradeTypeSubjectMinOrderBy {
  grade_type_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "view.grade_type_subject". */
export interface StudentViewGradeTypeSubjectOrderBy {
  grade_type?: Maybe<StudentGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  grade_types_aggregate?: Maybe<StudentGradeTypesAggregateOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.grade_type_subject" */
export const enum StudentViewGradeTypeSubjectSelectColumn {
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.grades" */
export interface StudentViewGrades {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<StudentSemesters>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** aggregated selection of "view.grades" */
export interface StudentViewGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentViewGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentViewGrades>>;
}

/** aggregate fields of "view.grades" */
export interface StudentViewGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentViewGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentViewGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentViewGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentViewGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentViewGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentViewGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentViewGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentViewGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentViewGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentViewGradesVarianceFields>>;
}


/** aggregate fields of "view.grades" */
export interface StudentViewGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentViewGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "view.grades" */
export interface StudentViewGradesAggregateOrderBy {
  avg?: Maybe<StudentViewGradesAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentViewGradesMaxOrderBy>;
  min?: Maybe<StudentViewGradesMinOrderBy>;
  stddev?: Maybe<StudentViewGradesStddevOrderBy>;
  stddev_pop?: Maybe<StudentViewGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentViewGradesStddevSampOrderBy>;
  sum?: Maybe<StudentViewGradesSumOrderBy>;
  var_pop?: Maybe<StudentViewGradesVarPopOrderBy>;
  var_samp?: Maybe<StudentViewGradesVarSampOrderBy>;
  variance?: Maybe<StudentViewGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentViewGradesAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "view.grades" */
export interface StudentViewGradesAvgOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grades". All fields are combined with a logical 'AND'. */
export interface StudentViewGradesBoolExp {
  _and?: Maybe<Array<StudentViewGradesBoolExp>>;
  _not?: Maybe<StudentViewGradesBoolExp>;
  _or?: Maybe<Array<StudentViewGradesBoolExp>>;
  created_at?: Maybe<StudentTimetzComparisonExp>;
  created_date?: Maybe<StudentDateComparisonExp>;
  grade_type?: Maybe<StudentStringComparisonExp>;
  grade_type_id?: Maybe<StudentUuidComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  semester?: Maybe<StudentSemestersBoolExp>;
  semester_id?: Maybe<StudentUuidComparisonExp>;
  student_id?: Maybe<StudentUuidComparisonExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  value?: Maybe<StudentIntComparisonExp>;
  weight?: Maybe<StudentIntComparisonExp>;
}

/** columns and relationships of "view.grades_for_students" */
export interface StudentViewGradesForStudents {
  assigment_date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.grades_for_students". All fields are combined with a logical 'AND'. */
export interface StudentViewGradesForStudentsBoolExp {
  _and?: Maybe<Array<StudentViewGradesForStudentsBoolExp>>;
  _not?: Maybe<StudentViewGradesForStudentsBoolExp>;
  _or?: Maybe<Array<StudentViewGradesForStudentsBoolExp>>;
  assigment_date?: Maybe<StudentTimestamptzComparisonExp>;
  assignment?: Maybe<StudentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentUuidComparisonExp>;
  comment?: Maybe<StudentStringComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  mark?: Maybe<StudentMarksBoolExp>;
  mark_id?: Maybe<StudentUuidComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.grades_for_students". */
export interface StudentViewGradesForStudentsOrderBy {
  assigment_date?: Maybe<StudentOrderBy>;
  assignment?: Maybe<StudentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrderBy>;
  comment?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  mark?: Maybe<StudentMarksOrderBy>;
  mark_id?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.grades_for_students" */
export const enum StudentViewGradesForStudentsSelectColumn {
  /** column name */
  ASSIGMENT_DATE = 'assigment_date',
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate max on columns */
export interface StudentViewGradesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "view.grades" */
export interface StudentViewGradesMaxOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  created_date?: Maybe<StudentOrderBy>;
  grade_type?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate min on columns */
export interface StudentViewGradesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "view.grades" */
export interface StudentViewGradesMinOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  created_date?: Maybe<StudentOrderBy>;
  grade_type?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "view.grades". */
export interface StudentViewGradesOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  created_date?: Maybe<StudentOrderBy>;
  grade_type?: Maybe<StudentOrderBy>;
  grade_type_id?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  semester?: Maybe<StudentSemestersOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  student_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.grades" */
export const enum StudentViewGradesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_DATE = 'created_date',
  /** column name */
  GRADE_TYPE = 'grade_type',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  VALUE = 'value',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface StudentViewGradesStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "view.grades" */
export interface StudentViewGradesStddevOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentViewGradesStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "view.grades" */
export interface StudentViewGradesStddevPopOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentViewGradesStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "view.grades" */
export interface StudentViewGradesStddevSampOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentViewGradesSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "view.grades" */
export interface StudentViewGradesSumOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentViewGradesVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "view.grades" */
export interface StudentViewGradesVarPopOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentViewGradesVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "view.grades" */
export interface StudentViewGradesVarSampOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentViewGradesVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "view.grades" */
export interface StudentViewGradesVarianceOrderBy {
  value?: Maybe<StudentOrderBy>;
  weight?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "view.latest_chat_messages" */
export interface StudentViewLatestChatMessages {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<StudentChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user?: EntireFieldWrapper<Maybe<StudentUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregated selection of "view.latest_chat_messages" */
export interface StudentViewLatestChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentViewLatestChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentViewLatestChatMessages>>;
}

/** aggregate fields of "view.latest_chat_messages" */
export interface StudentViewLatestChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentViewLatestChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentViewLatestChatMessagesMinFields>>;
}


/** aggregate fields of "view.latest_chat_messages" */
export interface StudentViewLatestChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentViewLatestChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "view.latest_chat_messages". All fields are combined with a logical 'AND'. */
export interface StudentViewLatestChatMessagesBoolExp {
  _and?: Maybe<Array<StudentViewLatestChatMessagesBoolExp>>;
  _not?: Maybe<StudentViewLatestChatMessagesBoolExp>;
  _or?: Maybe<Array<StudentViewLatestChatMessagesBoolExp>>;
  body?: Maybe<StudentStringComparisonExp>;
  chat?: Maybe<StudentChatsBoolExp>;
  chat_id?: Maybe<StudentUuidComparisonExp>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  user_id?: Maybe<StudentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentViewLatestChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentViewLatestChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "view.latest_chat_messages". */
export interface StudentViewLatestChatMessagesOrderBy {
  body?: Maybe<StudentOrderBy>;
  chat?: Maybe<StudentChatsOrderBy>;
  chat_id?: Maybe<StudentOrderBy>;
  created_at?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  user_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.latest_chat_messages" */
export const enum StudentViewLatestChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMark {
  avg?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
  count?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  max?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  min?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkAggregateOrderBy {
  avg?: Maybe<StudentViewStatisticsSemesterSubjectMarkAvgOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentViewStatisticsSemesterSubjectMarkMaxOrderBy>;
  min?: Maybe<StudentViewStatisticsSemesterSubjectMarkMinOrderBy>;
  stddev?: Maybe<StudentViewStatisticsSemesterSubjectMarkStddevOrderBy>;
  stddev_pop?: Maybe<StudentViewStatisticsSemesterSubjectMarkStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentViewStatisticsSemesterSubjectMarkStddevSampOrderBy>;
  sum?: Maybe<StudentViewStatisticsSemesterSubjectMarkSumOrderBy>;
  var_pop?: Maybe<StudentViewStatisticsSemesterSubjectMarkVarPopOrderBy>;
  var_samp?: Maybe<StudentViewStatisticsSemesterSubjectMarkVarSampOrderBy>;
  variance?: Maybe<StudentViewStatisticsSemesterSubjectMarkVarianceOrderBy>;
}

/** order by avg() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkAvgOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** Boolean expression to filter rows from the table "view.statistics_semester_subject_mark". All fields are combined with a logical 'AND'. */
export interface StudentViewStatisticsSemesterSubjectMarkBoolExp {
  _and?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkBoolExp>>;
  _not?: Maybe<StudentViewStatisticsSemesterSubjectMarkBoolExp>;
  _or?: Maybe<Array<StudentViewStatisticsSemesterSubjectMarkBoolExp>>;
  avg?: Maybe<StudentNumericComparisonExp>;
  count?: Maybe<StudentBigintComparisonExp>;
  max?: Maybe<StudentIntComparisonExp>;
  min?: Maybe<StudentIntComparisonExp>;
  semester_id?: Maybe<StudentUuidComparisonExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
}

/** order by max() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkMaxOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** order by min() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkMinOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** Ordering options when selecting data from "view.statistics_semester_subject_mark". */
export interface StudentViewStatisticsSemesterSubjectMarkOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
  semester_id?: Maybe<StudentOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.statistics_semester_subject_mark" */
export const enum StudentViewStatisticsSemesterSubjectMarkSelectColumn {
  /** column name */
  AVG = 'avg',
  /** column name */
  COUNT = 'count',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** order by stddev() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkStddevOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** order by stddev_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkStddevPopOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** order by stddev_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkStddevSampOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** order by sum() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkSumOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** order by var_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkVarPopOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** order by var_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkVarSampOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** order by variance() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentViewStatisticsSemesterSubjectMarkVarianceOrderBy {
  avg?: Maybe<StudentOrderBy>;
  count?: Maybe<StudentOrderBy>;
  max?: Maybe<StudentOrderBy>;
  min?: Maybe<StudentOrderBy>;
}

/** columns and relationships of "view.subject_semester" */
export interface StudentViewSubjectSemester {
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.subject_semester". All fields are combined with a logical 'AND'. */
export interface StudentViewSubjectSemesterBoolExp {
  _and?: Maybe<Array<StudentViewSubjectSemesterBoolExp>>;
  _not?: Maybe<StudentViewSubjectSemesterBoolExp>;
  _or?: Maybe<Array<StudentViewSubjectSemesterBoolExp>>;
  semester_id?: Maybe<StudentUuidComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.subject_semester". */
export interface StudentViewSubjectSemesterOrderBy {
  semester_id?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.subject_semester" */
export const enum StudentViewSubjectSemesterSelectColumn {
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.teacher_class_subject" */
export interface StudentViewTeacherClassSubject {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.teacher_class_subject". All fields are combined with a logical 'AND'. */
export interface StudentViewTeacherClassSubjectBoolExp {
  _and?: Maybe<Array<StudentViewTeacherClassSubjectBoolExp>>;
  _not?: Maybe<StudentViewTeacherClassSubjectBoolExp>;
  _or?: Maybe<Array<StudentViewTeacherClassSubjectBoolExp>>;
  class?: Maybe<StudentClassesBoolExp>;
  class_id?: Maybe<StudentUuidComparisonExp>;
  subject?: Maybe<StudentSubjectsBoolExp>;
  subject_id?: Maybe<StudentUuidComparisonExp>;
  teacher_id?: Maybe<StudentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.teacher_class_subject". */
export interface StudentViewTeacherClassSubjectOrderBy {
  class?: Maybe<StudentClassesOrderBy>;
  class_id?: Maybe<StudentOrderBy>;
  subject?: Maybe<StudentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrderBy>;
  teacher_id?: Maybe<StudentOrderBy>;
}

/** select columns of table "view.teacher_class_subject" */
export const enum StudentViewTeacherClassSubjectSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "years" */
export interface StudentYears {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "year_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentPromotions>>;
  start_date: EntireFieldWrapper<Scalars['date']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "years" */
export interface StudentYearsPromotionsArgs {
  distinct_on?: Maybe<Array<StudentPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentPromotionsOrderBy>>;
  where?: Maybe<StudentPromotionsBoolExp>;
}

/** aggregated selection of "years" */
export interface StudentYearsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentYearsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentYears>>;
}

/** aggregate fields of "years" */
export interface StudentYearsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentYearsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentYearsMinFields>>;
}


/** aggregate fields of "years" */
export interface StudentYearsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentYearsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "years". All fields are combined with a logical 'AND'. */
export interface StudentYearsBoolExp {
  _and?: Maybe<Array<StudentYearsBoolExp>>;
  _not?: Maybe<StudentYearsBoolExp>;
  _or?: Maybe<Array<StudentYearsBoolExp>>;
  created_at?: Maybe<StudentTimestamptzComparisonExp>;
  end_date?: Maybe<StudentDateComparisonExp>;
  id?: Maybe<StudentUuidComparisonExp>;
  name?: Maybe<StudentStringComparisonExp>;
  promotions?: Maybe<StudentPromotionsBoolExp>;
  start_date?: Maybe<StudentDateComparisonExp>;
  updated_at?: Maybe<StudentTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentYearsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentYearsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** Ordering options when selecting data from "years". */
export interface StudentYearsOrderBy {
  created_at?: Maybe<StudentOrderBy>;
  end_date?: Maybe<StudentOrderBy>;
  id?: Maybe<StudentOrderBy>;
  name?: Maybe<StudentOrderBy>;
  promotions_aggregate?: Maybe<StudentPromotionsAggregateOrderBy>;
  start_date?: Maybe<StudentOrderBy>;
  updated_at?: Maybe<StudentOrderBy>;
}

/** select columns of table "years" */
export const enum StudentYearsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_DATE = 'end_date',
  /** column name */
  ID = 'id',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export type StudentAdressFragment = { street?: Maybe<string>, area?: Maybe<string>, city?: Maybe<string>, postal_code?: Maybe<string>, country?: Maybe<string>, created_at: string, updated_at: string };

export type StudentAssignmentFragment = { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> };

export type StudentAggregateAssignmentFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentAssignmentClassFragment = { class?: Maybe<{ name?: Maybe<string>, id: string }> };

export type StudentAssignmentGradeFragment = { id: string, student: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> }, mark?: Maybe<{ id: string, value: number }> };

export type StudentAssignmentStudentFragment = { user?: Maybe<{ id: string, full_name?: Maybe<string> }>, assignment: { id: string } };

export type StudentAssignmentStudentGradeFragment = { student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, grade?: Maybe<{ id: string, mark?: Maybe<{ id: string, value: number }> }> };

export type StudentAssignmentTotalCountFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentAssignmentTypeFragment = { name: string, icon?: Maybe<string> };

export type StudentBookFragment = { id: string, title: string, book_chapters: Array<{ id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> }> };

export type StudentChapterFragment = { id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> };

export type StudentChatFragment = { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentChatMessageFragment = { id: string, body: string, user_id: string, chat_id: string, created_at: string };

export type StudentKClassFragment = { name?: Maybe<string>, id: string };

export type StudentClassStudentFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type StudentChatTypeFragment = { name: string, description: string };

export type StudentFileFragment = { id: string, file_name: string, foreign_id: string, path: string };

export type StudentGradeFragment = { id: string, weight: number, comment?: Maybe<string>, mark?: Maybe<{ id: string, name: string, value: number }>, assignment: { title: string, type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { id: string, name: string } } }> } };

export type StudentLessonFragment = { id: string, start_at?: Maybe<any>, start_date?: Maybe<any>, description?: Maybe<string>, course: { id: string, subject: { id: string, name: string }, course_teachers: Array<{ teacher: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> } }> } };

export type StudentMarkFragment = { name: string, value: number };

export type StudentMessageFragment = { id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, replys?: Maybe<Array<{ id: string, body: string, user_id: string, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>>, likes: Array<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }>, responding?: Maybe<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type StudentMessageAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentNoteFragment = { id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type StudentPhoneNumberFragment = { country_code: string, number: string, created_at: string, updated_at: string };

export type StudentPrivateChatFragment = { id: string, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentSectionFragment = { id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> };

export type StudentSectionTypeFragment = { name: string, icon?: Maybe<string> };

export type StudentSemesterFragment = { id: string, start_at: any, end_at: any };

export type StudentStudentFragment = { id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> };

export type StudentSubjectFragment = { id: string, name: string, icon?: Maybe<string> };

export type StudentTaskFragment = { id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean };

export type StudentTasksAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentTeacherFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type StudentUserFragment = { id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> };

export type StudentYearFragment = { id: string, name?: Maybe<string>, start_date: any, end_date: any };

export type StudentGetMyTaskSubmissionQueryVariables = Exact<{
  assignment_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}>;


export type StudentGetMyTaskSubmissionQuery = { assignment_submits: Array<{ content?: Maybe<string>, file?: Maybe<string>, is_submited: boolean, completed_at?: Maybe<string>, id: string, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> };

export type StudentGetMyAssignmentsQueryVariables = Exact<{
  user_id?: Maybe<Scalars['uuid']>;
  teaching_structure_id?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type StudentGetMyAssignmentsQuery = { assignments: Array<{ type: StudentAssignmentTypeEnum, title: string, id: string, duration: number, assignment_submits: Array<{ is_submited: boolean }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, title: string }> }> };

export type StudentGetMySubjectsQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type StudentGetMySubjectsQuery = { teaching_structure_students: Array<{ teaching_structure_id: string, teaching_structure: { subject_icon?: Maybe<string>, title: string, parent?: Maybe<{ title: string }> } }> };

export type StudentGetAssignmentByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type StudentGetAssignmentByIdQuery = { assignments_by_pk?: Maybe<{ description?: Maybe<string>, due_at: string, due_at_filter?: Maybe<string>, duration: number, id: string, is_completed?: Maybe<boolean>, is_everybody: boolean, is_gradeable: boolean, title: string, type: StudentAssignmentTypeEnum, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> };

export type StudentGetTeachingStructureBasedOnPositionQueryVariables = Exact<{
  _lt?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
}>;


export type StudentGetTeachingStructureBasedOnPositionQuery = { teaching_structures: Array<{ id: string }> };

export type StudentInsertMyTaskSubmissionMutationVariables = Exact<{
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  file?: Maybe<Scalars['String']>;
  is_submited?: Maybe<Scalars['Boolean']>;
}>;


export type StudentInsertMyTaskSubmissionMutation = { insert_assignment_submits_one?: Maybe<{ id: string }> };

export type StudentUpdateMyTaskSubmissionMutationVariables = Exact<{
  submission_id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  file?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
}>;


export type StudentUpdateMyTaskSubmissionMutation = { update_assignment_submits?: Maybe<{ affected_rows: number }> };

export type StudentGetAttendanceForStudentQueryVariables = Exact<{
  where?: Maybe<StudentAttendancesBoolExp>;
}>;


export type StudentGetAttendanceForStudentQuery = { attendances: Array<{ id: string, date: string, comment?: Maybe<string>, subject: { title: string, id: string, teacher_subjects: Array<{ teacher: { user?: Maybe<{ full_name?: Maybe<string> }> } }> }, type?: Maybe<{ icon: string, text: string, value: string }>, class: { title: string } }> };

export type StudentSectionUpdateDurationMutationVariables = Exact<{
  section_id: Scalars['uuid'];
  duration_spent?: Maybe<Scalars['Int']>;
}>;


export type StudentSectionUpdateDurationMutation = { update_chapter_section_submits?: Maybe<{ affected_rows: number }> };

export type StudentSectionCreateSubmitMutationVariables = Exact<{
  section_id: Scalars['uuid'];
  is_completed?: Maybe<Scalars['Boolean']>;
}>;


export type StudentSectionCreateSubmitMutation = { insert_chapter_section_submits?: Maybe<{ affected_rows: number }> };

export type StudentNoteDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type StudentNoteDeleteMutation = { delete_chapter_section_notes_by_pk?: Maybe<{ id: string }> };

export type StudentNoteInsertMutationVariables = Exact<{
  section_id: Scalars['uuid'];
  body: Scalars['String'];
}>;


export type StudentNoteInsertMutation = { insert_chapter_section_notes_one?: Maybe<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentGetGradesForStudentQueryVariables = Exact<{
  studentId?: Maybe<Scalars['uuid']>;
}>;


export type StudentGetGradesForStudentQuery = { view_grades_for_students: Array<{ id?: Maybe<string>, comment?: Maybe<string>, mark_id?: Maybe<string>, mark?: Maybe<{ name: string, value: number }>, assignment?: Maybe<{ title: string, id: string, due_at: string, type: StudentAssignmentTypeEnum }>, subject?: Maybe<{ id: string, name: string, teacher_subjects: Array<{ teacher: { user?: Maybe<{ full_name?: Maybe<string> }> } }> }> }> };

export type StudentStudentGetMyLiveClassByMyIdQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type StudentStudentGetMyLiveClassByMyIdQuery = { live_classes: Array<{ id: string, attendeePW: string, description?: Maybe<string>, status?: Maybe<string>, starting_at?: Maybe<string>, name: string, duration: number }> };

export type StudentStudentJoinLiveClassMutationVariables = Exact<{
  name: Scalars['String'];
  lesson_id?: Maybe<Scalars['String']>;
}>;


export type StudentStudentJoinLiveClassMutation = { studentJoin?: Maybe<{ url: string, id: string }> };

export type StudentGetAllMyLeafsOnlyIdQueryVariables = Exact<{
  teaching_structure_id?: Maybe<Scalars['uuid']>;
}>;


export type StudentGetAllMyLeafsOnlyIdQuery = { teaching_structure_leafs: Array<{ id: string }> };

export const StudentAdressFragmentDoc = gql`
    fragment Adress on private_adresses {
  street
  area
  city
  postal_code
  country
  created_at
  updated_at
}
    `;
export const StudentAssignmentTypeFragmentDoc = gql`
    fragment AssignmentType on assignment_type {
  name
  icon
}
    `;
export const StudentFileFragmentDoc = gql`
    fragment File on files {
  id
  file_name
  foreign_id
  path
}
    `;
export const StudentAssignmentFragmentDoc = gql`
    fragment Assignment on assignments {
  id
  title
  description
  duration
  due_at
  due_at_filter
  created_at
  assignment_users {
    user_id
    id
  }
  chat {
    title
    id
  }
  teaching_structure {
    subject_icon
    subject_icon
    id
    ltr
    rtl
  }
  assignment_type {
    ...AssignmentType
  }
  lesson {
    course {
      subject {
        name
      }
    }
  }
  is_gradeable
  is_completed
  lesson {
    course {
      subject {
        name
      }
    }
  }
  user {
    full_name
  }
  grade_weight: assignment_grade_weight {
    id
    value
    comment
  }
  files {
    ...File
  }
}
    ${StudentAssignmentTypeFragmentDoc}
${StudentFileFragmentDoc}`;
export const StudentAggregateAssignmentFragmentDoc = gql`
    fragment AggregateAssignment on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentKClassFragmentDoc = gql`
    fragment KClass on classes {
  name
  id
}
    `;
export const StudentAssignmentClassFragmentDoc = gql`
    fragment AssignmentClass on view_assignment_class {
  class {
    ...KClass
  }
}
    ${StudentKClassFragmentDoc}`;
export const StudentAssignmentGradeFragmentDoc = gql`
    fragment AssignmentGrade on grades {
  id
  student {
    id
    user {
      full_name
    }
  }
  mark {
    id
    value
  }
}
    `;
export const StudentAssignmentStudentFragmentDoc = gql`
    fragment AssignmentStudent on assignment_user {
  user {
    id
    full_name
  }
  assignment {
    id
  }
}
    `;
export const StudentAssignmentStudentGradeFragmentDoc = gql`
    fragment AssignmentStudentGrade on view_assignment_student_grade {
  student {
    id
    user {
      full_name
    }
  }
  grade {
    id
    mark {
      id
      value
    }
  }
}
    `;
export const StudentAssignmentTotalCountFragmentDoc = gql`
    fragment AssignmentTotalCount on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentSectionTypeFragmentDoc = gql`
    fragment SectionType on chapter_section_type {
  name
  icon
}
    `;
export const StudentNoteFragmentDoc = gql`
    fragment Note on chapter_section_notes {
  id
  body
  created_at
  user {
    full_name
    avatar_url
  }
}
    `;
export const StudentSectionFragmentDoc = gql`
    fragment Section on chapter_sections {
  id
  title
  body @include(if: $with_body)
  duration_left
  duration_total: duration
  is_completed
  type: chapter_section_type {
    ...SectionType
  }
  notes: chapter_section_notes @include(if: $with_notes) {
    ...Note
  }
}
    ${StudentSectionTypeFragmentDoc}
${StudentNoteFragmentDoc}`;
export const StudentChapterFragmentDoc = gql`
    fragment Chapter on book_chapters {
  id
  title
  duration_left
  due_at
  type: book_chapter_type {
    name
    description
  }
  sections: chapter_sections(order_by: {sort: asc}) {
    ...Section
  }
}
    ${StudentSectionFragmentDoc}`;
export const StudentBookFragmentDoc = gql`
    fragment Book on books {
  id
  title
  book_chapters {
    ...Chapter
  }
}
    ${StudentChapterFragmentDoc}`;
export const StudentChatFragmentDoc = gql`
    fragment Chat on chats {
  id
  title
  avatar_url
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const StudentChatMessageFragmentDoc = gql`
    fragment ChatMessage on chat_messages {
  id
  body
  user_id
  chat_id
  created_at
}
    `;
export const StudentClassStudentFragmentDoc = gql`
    fragment ClassStudent on students {
  id
  user {
    full_name
  }
}
    `;
export const StudentChatTypeFragmentDoc = gql`
    fragment ChatType on chat_type {
  name
  description
}
    `;
export const StudentGradeFragmentDoc = gql`
    fragment Grade on grades {
  id
  weight
  comment
  mark {
    id
    name
    value
  }
  assignment {
    title
    type: assignment_type {
      name
      icon
    }
    lesson {
      course {
        subject {
          id
          name
        }
      }
    }
  }
}
    `;
export const StudentTeacherFragmentDoc = gql`
    fragment Teacher on teachers {
  id
  user {
    full_name
  }
}
    `;
export const StudentLessonFragmentDoc = gql`
    fragment Lesson on lessons {
  id
  start_at
  start_date
  course {
    id
    subject {
      id
      name
    }
    course_teachers {
      teacher {
        ...Teacher
      }
    }
  }
  description
}
    ${StudentTeacherFragmentDoc}`;
export const StudentMarkFragmentDoc = gql`
    fragment Mark on marks {
  name
  value
}
    `;
export const StudentMessageFragmentDoc = gql`
    fragment Message on chat_messages {
  id
  body
  user_id
  chat_id
  is_pinned
  created_at
  replys {
    id
    body
    user_id
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  likes: chat_message_likes {
    id
    chat_message_id
    chat_like_user {
      id
      first_name
      full_name
    }
  }
  responding: chat_message {
    id
    body
    user_id
    chat_id
    is_pinned
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  user {
    first_name
    last_name
    avatar_url
  }
}
    `;
export const StudentMessageAggregateFragmentDoc = gql`
    fragment MessageAggregate on chat_messages_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentPhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on private_phone_numbers {
  country_code
  number
  created_at
  updated_at
}
    `;
export const StudentPrivateChatFragmentDoc = gql`
    fragment PrivateChat on chats {
  id
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const StudentSemesterFragmentDoc = gql`
    fragment Semester on semesters {
  id
  start_at
  end_at
}
    `;
export const StudentStudentFragmentDoc = gql`
    fragment Student on students {
  id
  user {
    avatar_url
    full_name
  }
}
    `;
export const StudentSubjectFragmentDoc = gql`
    fragment Subject on subjects {
  id
  name
  icon
}
    `;
export const StudentTaskFragmentDoc = gql`
    fragment Task on tasks {
  id
  body
  title
  is_completed
}
    `;
export const StudentTasksAggregateFragmentDoc = gql`
    fragment TasksAggregate on tasks_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentUserFragmentDoc = gql`
    fragment User on UserData {
  id
  last_name
  first_name
  email
  birthday_at
  avatar_url
  mobile
  street_address
  title
  role
  is_verified
  assignments
  live_class
  grading
  chat
}
    `;
export const StudentYearFragmentDoc = gql`
    fragment Year on years {
  id
  name
  start_date
  end_date
}
    `;
export const StudentgetMyTaskSubmissionDocument = gql`
    query getMyTaskSubmission($assignment_id: uuid = "", $user_id: uuid = "") {
  assignment_submits(
    where: {assignment_id: {_eq: $assignment_id}, user_id: {_eq: $user_id}}
  ) {
    content
    file
    is_submited
    completed_at
    id
    files {
      ...File
    }
  }
}
    ${StudentFileFragmentDoc}`;

/**
 * __useGetMyTaskSubmissionQuery__
 *
 * To run a query within a React component, call `useGetMyTaskSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTaskSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTaskSubmissionQuery({
 *   variables: {
 *      assignment_id: // value for 'assignment_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetMyTaskSubmissionQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetMyTaskSubmissionQuery, StudentGetMyTaskSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetMyTaskSubmissionQuery, StudentGetMyTaskSubmissionQueryVariables>(StudentgetMyTaskSubmissionDocument, options);
      }
export function useGetMyTaskSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetMyTaskSubmissionQuery, StudentGetMyTaskSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetMyTaskSubmissionQuery, StudentGetMyTaskSubmissionQueryVariables>(StudentgetMyTaskSubmissionDocument, options);
        }
export type GetMyTaskSubmissionQueryHookResult = ReturnType<typeof useGetMyTaskSubmissionQuery>;
export type GetMyTaskSubmissionLazyQueryHookResult = ReturnType<typeof useGetMyTaskSubmissionLazyQuery>;
export type GetMyTaskSubmissionQueryResult = Apollo.QueryResult<StudentGetMyTaskSubmissionQuery, StudentGetMyTaskSubmissionQueryVariables>;
export const StudentgetMyAssignmentsDocument = gql`
    query getMyAssignments($user_id: uuid = "", $teaching_structure_id: [uuid!] = "") {
  assignments(
    where: {assignment_users: {user_id: {_eq: $user_id}}, teaching_structure_id: {_in: $teaching_structure_id}}
  ) {
    type
    title
    id
    duration
    assignment_submits {
      is_submited
    }
    teaching_structure {
      subject_icon
      title
    }
  }
}
    `;

/**
 * __useGetMyAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetMyAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAssignmentsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      teaching_structure_id: // value for 'teaching_structure_id'
 *   },
 * });
 */
export function useGetMyAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetMyAssignmentsQuery, StudentGetMyAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetMyAssignmentsQuery, StudentGetMyAssignmentsQueryVariables>(StudentgetMyAssignmentsDocument, options);
      }
export function useGetMyAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetMyAssignmentsQuery, StudentGetMyAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetMyAssignmentsQuery, StudentGetMyAssignmentsQueryVariables>(StudentgetMyAssignmentsDocument, options);
        }
export type GetMyAssignmentsQueryHookResult = ReturnType<typeof useGetMyAssignmentsQuery>;
export type GetMyAssignmentsLazyQueryHookResult = ReturnType<typeof useGetMyAssignmentsLazyQuery>;
export type GetMyAssignmentsQueryResult = Apollo.QueryResult<StudentGetMyAssignmentsQuery, StudentGetMyAssignmentsQueryVariables>;
export const StudentgetMySubjectsDocument = gql`
    query getMySubjects($_eq: uuid = "") {
  teaching_structure_students(where: {student_id: {_eq: $_eq}}) {
    teaching_structure_id
    teaching_structure {
      subject_icon
      title
      parent {
        title
      }
    }
  }
}
    `;

/**
 * __useGetMySubjectsQuery__
 *
 * To run a query within a React component, call `useGetMySubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubjectsQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetMySubjectsQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetMySubjectsQuery, StudentGetMySubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetMySubjectsQuery, StudentGetMySubjectsQueryVariables>(StudentgetMySubjectsDocument, options);
      }
export function useGetMySubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetMySubjectsQuery, StudentGetMySubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetMySubjectsQuery, StudentGetMySubjectsQueryVariables>(StudentgetMySubjectsDocument, options);
        }
export type GetMySubjectsQueryHookResult = ReturnType<typeof useGetMySubjectsQuery>;
export type GetMySubjectsLazyQueryHookResult = ReturnType<typeof useGetMySubjectsLazyQuery>;
export type GetMySubjectsQueryResult = Apollo.QueryResult<StudentGetMySubjectsQuery, StudentGetMySubjectsQueryVariables>;
export const StudentgetAssignmentByIdDocument = gql`
    query getAssignmentById($id: uuid = "") {
  assignments_by_pk(id: $id) {
    description
    due_at
    due_at_filter
    duration
    id
    is_completed
    is_everybody
    is_gradeable
    title
    type
    files {
      ...File
    }
  }
}
    ${StudentFileFragmentDoc}`;

/**
 * __useGetAssignmentByIdQuery__
 *
 * To run a query within a React component, call `useGetAssignmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentByIdQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetAssignmentByIdQuery, StudentGetAssignmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetAssignmentByIdQuery, StudentGetAssignmentByIdQueryVariables>(StudentgetAssignmentByIdDocument, options);
      }
export function useGetAssignmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetAssignmentByIdQuery, StudentGetAssignmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetAssignmentByIdQuery, StudentGetAssignmentByIdQueryVariables>(StudentgetAssignmentByIdDocument, options);
        }
export type GetAssignmentByIdQueryHookResult = ReturnType<typeof useGetAssignmentByIdQuery>;
export type GetAssignmentByIdLazyQueryHookResult = ReturnType<typeof useGetAssignmentByIdLazyQuery>;
export type GetAssignmentByIdQueryResult = Apollo.QueryResult<StudentGetAssignmentByIdQuery, StudentGetAssignmentByIdQueryVariables>;
export const StudentgetTeachingStructureBasedOnPositionDocument = gql`
    query getTeachingStructureBasedOnPosition($_lt: Int, $_gt: Int) {
  teaching_structures(
    where: {ltr: {_lt: $_lt}, rtl: {_gt: $_gt}, type_id: {_eq: "e74e23b7-70ba-4d1d-af59-96d31b09742e"}}
  ) {
    id
  }
}
    `;

/**
 * __useGetTeachingStructureBasedOnPositionQuery__
 *
 * To run a query within a React component, call `useGetTeachingStructureBasedOnPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeachingStructureBasedOnPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeachingStructureBasedOnPositionQuery({
 *   variables: {
 *      _lt: // value for '_lt'
 *      _gt: // value for '_gt'
 *   },
 * });
 */
export function useGetTeachingStructureBasedOnPositionQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetTeachingStructureBasedOnPositionQuery, StudentGetTeachingStructureBasedOnPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetTeachingStructureBasedOnPositionQuery, StudentGetTeachingStructureBasedOnPositionQueryVariables>(StudentgetTeachingStructureBasedOnPositionDocument, options);
      }
export function useGetTeachingStructureBasedOnPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetTeachingStructureBasedOnPositionQuery, StudentGetTeachingStructureBasedOnPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetTeachingStructureBasedOnPositionQuery, StudentGetTeachingStructureBasedOnPositionQueryVariables>(StudentgetTeachingStructureBasedOnPositionDocument, options);
        }
export type GetTeachingStructureBasedOnPositionQueryHookResult = ReturnType<typeof useGetTeachingStructureBasedOnPositionQuery>;
export type GetTeachingStructureBasedOnPositionLazyQueryHookResult = ReturnType<typeof useGetTeachingStructureBasedOnPositionLazyQuery>;
export type GetTeachingStructureBasedOnPositionQueryResult = Apollo.QueryResult<StudentGetTeachingStructureBasedOnPositionQuery, StudentGetTeachingStructureBasedOnPositionQueryVariables>;
export const StudentinsertMyTaskSubmissionDocument = gql`
    mutation insertMyTaskSubmission($assignment_id: uuid = "", $content: String = "", $completed_at: timestamptz = "", $file: String = "", $is_submited: Boolean = false) {
  insert_assignment_submits_one(
    object: {assignment_id: $assignment_id, content: $content, completed_at: $completed_at, file: $file, is_submited: $is_submited}
  ) {
    id
  }
}
    `;
export type StudentInsertMyTaskSubmissionMutationFn = Apollo.MutationFunction<StudentInsertMyTaskSubmissionMutation, StudentInsertMyTaskSubmissionMutationVariables>;

/**
 * __useInsertMyTaskSubmissionMutation__
 *
 * To run a mutation, you first call `useInsertMyTaskSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMyTaskSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMyTaskSubmissionMutation, { data, loading, error }] = useInsertMyTaskSubmissionMutation({
 *   variables: {
 *      assignment_id: // value for 'assignment_id'
 *      content: // value for 'content'
 *      completed_at: // value for 'completed_at'
 *      file: // value for 'file'
 *      is_submited: // value for 'is_submited'
 *   },
 * });
 */
export function useInsertMyTaskSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<StudentInsertMyTaskSubmissionMutation, StudentInsertMyTaskSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentInsertMyTaskSubmissionMutation, StudentInsertMyTaskSubmissionMutationVariables>(StudentinsertMyTaskSubmissionDocument, options);
      }
export type InsertMyTaskSubmissionMutationHookResult = ReturnType<typeof useInsertMyTaskSubmissionMutation>;
export type InsertMyTaskSubmissionMutationResult = Apollo.MutationResult<StudentInsertMyTaskSubmissionMutation>;
export type InsertMyTaskSubmissionMutationOptions = Apollo.BaseMutationOptions<StudentInsertMyTaskSubmissionMutation, StudentInsertMyTaskSubmissionMutationVariables>;
export const StudentupdateMyTaskSubmissionDocument = gql`
    mutation updateMyTaskSubmission($submission_id: uuid = "", $is_submited: Boolean = false, $file: String = "", $content: String = "", $completed_at: timestamptz = "") {
  update_assignment_submits(
    where: {id: {_eq: $submission_id}}
    _set: {is_submited: $is_submited, file: $file, content: $content, completed_at: $completed_at}
  ) {
    affected_rows
  }
}
    `;
export type StudentUpdateMyTaskSubmissionMutationFn = Apollo.MutationFunction<StudentUpdateMyTaskSubmissionMutation, StudentUpdateMyTaskSubmissionMutationVariables>;

/**
 * __useUpdateMyTaskSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMyTaskSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyTaskSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyTaskSubmissionMutation, { data, loading, error }] = useUpdateMyTaskSubmissionMutation({
 *   variables: {
 *      submission_id: // value for 'submission_id'
 *      is_submited: // value for 'is_submited'
 *      file: // value for 'file'
 *      content: // value for 'content'
 *      completed_at: // value for 'completed_at'
 *   },
 * });
 */
export function useUpdateMyTaskSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<StudentUpdateMyTaskSubmissionMutation, StudentUpdateMyTaskSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentUpdateMyTaskSubmissionMutation, StudentUpdateMyTaskSubmissionMutationVariables>(StudentupdateMyTaskSubmissionDocument, options);
      }
export type UpdateMyTaskSubmissionMutationHookResult = ReturnType<typeof useUpdateMyTaskSubmissionMutation>;
export type UpdateMyTaskSubmissionMutationResult = Apollo.MutationResult<StudentUpdateMyTaskSubmissionMutation>;
export type UpdateMyTaskSubmissionMutationOptions = Apollo.BaseMutationOptions<StudentUpdateMyTaskSubmissionMutation, StudentUpdateMyTaskSubmissionMutationVariables>;
export const StudentgetAttendanceForStudentDocument = gql`
    query getAttendanceForStudent($where: attendances_bool_exp) {
  attendances(where: $where) {
    id
    date
    comment
    subject {
      title
      id
      teacher_subjects {
        teacher {
          user {
            full_name
          }
        }
      }
    }
    type {
      icon
      text
      value
    }
    class {
      title
    }
  }
}
    `;

/**
 * __useGetAttendanceForStudentQuery__
 *
 * To run a query within a React component, call `useGetAttendanceForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceForStudentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAttendanceForStudentQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetAttendanceForStudentQuery, StudentGetAttendanceForStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetAttendanceForStudentQuery, StudentGetAttendanceForStudentQueryVariables>(StudentgetAttendanceForStudentDocument, options);
      }
export function useGetAttendanceForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetAttendanceForStudentQuery, StudentGetAttendanceForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetAttendanceForStudentQuery, StudentGetAttendanceForStudentQueryVariables>(StudentgetAttendanceForStudentDocument, options);
        }
export type GetAttendanceForStudentQueryHookResult = ReturnType<typeof useGetAttendanceForStudentQuery>;
export type GetAttendanceForStudentLazyQueryHookResult = ReturnType<typeof useGetAttendanceForStudentLazyQuery>;
export type GetAttendanceForStudentQueryResult = Apollo.QueryResult<StudentGetAttendanceForStudentQuery, StudentGetAttendanceForStudentQueryVariables>;
export const StudentSectionUpdateDurationDocument = gql`
    mutation SectionUpdateDuration($section_id: uuid!, $duration_spent: Int = 1) {
  update_chapter_section_submits(
    where: {chapter_section_id: {_eq: $section_id}}
    _inc: {duration_spent: $duration_spent}
  ) {
    affected_rows
  }
}
    `;
export type StudentSectionUpdateDurationMutationFn = Apollo.MutationFunction<StudentSectionUpdateDurationMutation, StudentSectionUpdateDurationMutationVariables>;

/**
 * __useSectionUpdateDurationMutation__
 *
 * To run a mutation, you first call `useSectionUpdateDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectionUpdateDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectionUpdateDurationMutation, { data, loading, error }] = useSectionUpdateDurationMutation({
 *   variables: {
 *      section_id: // value for 'section_id'
 *      duration_spent: // value for 'duration_spent'
 *   },
 * });
 */
export function useSectionUpdateDurationMutation(baseOptions?: Apollo.MutationHookOptions<StudentSectionUpdateDurationMutation, StudentSectionUpdateDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentSectionUpdateDurationMutation, StudentSectionUpdateDurationMutationVariables>(StudentSectionUpdateDurationDocument, options);
      }
export type SectionUpdateDurationMutationHookResult = ReturnType<typeof useSectionUpdateDurationMutation>;
export type SectionUpdateDurationMutationResult = Apollo.MutationResult<StudentSectionUpdateDurationMutation>;
export type SectionUpdateDurationMutationOptions = Apollo.BaseMutationOptions<StudentSectionUpdateDurationMutation, StudentSectionUpdateDurationMutationVariables>;
export const StudentSectionCreateSubmitDocument = gql`
    mutation SectionCreateSubmit($section_id: uuid!, $is_completed: Boolean = true) {
  insert_chapter_section_submits(
    objects: {is_completed: $is_completed, chapter_section_id: $section_id}
    on_conflict: {constraint: chapter_section_student_pkey, update_columns: is_completed}
  ) {
    affected_rows
  }
}
    `;
export type StudentSectionCreateSubmitMutationFn = Apollo.MutationFunction<StudentSectionCreateSubmitMutation, StudentSectionCreateSubmitMutationVariables>;

/**
 * __useSectionCreateSubmitMutation__
 *
 * To run a mutation, you first call `useSectionCreateSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSectionCreateSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sectionCreateSubmitMutation, { data, loading, error }] = useSectionCreateSubmitMutation({
 *   variables: {
 *      section_id: // value for 'section_id'
 *      is_completed: // value for 'is_completed'
 *   },
 * });
 */
export function useSectionCreateSubmitMutation(baseOptions?: Apollo.MutationHookOptions<StudentSectionCreateSubmitMutation, StudentSectionCreateSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentSectionCreateSubmitMutation, StudentSectionCreateSubmitMutationVariables>(StudentSectionCreateSubmitDocument, options);
      }
export type SectionCreateSubmitMutationHookResult = ReturnType<typeof useSectionCreateSubmitMutation>;
export type SectionCreateSubmitMutationResult = Apollo.MutationResult<StudentSectionCreateSubmitMutation>;
export type SectionCreateSubmitMutationOptions = Apollo.BaseMutationOptions<StudentSectionCreateSubmitMutation, StudentSectionCreateSubmitMutationVariables>;
export const StudentNoteDeleteDocument = gql`
    mutation NoteDelete($id: uuid!) {
  delete_chapter_section_notes_by_pk(id: $id) {
    id
  }
}
    `;
export type StudentNoteDeleteMutationFn = Apollo.MutationFunction<StudentNoteDeleteMutation, StudentNoteDeleteMutationVariables>;

/**
 * __useNoteDeleteMutation__
 *
 * To run a mutation, you first call `useNoteDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteDeleteMutation, { data, loading, error }] = useNoteDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteDeleteMutation(baseOptions?: Apollo.MutationHookOptions<StudentNoteDeleteMutation, StudentNoteDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentNoteDeleteMutation, StudentNoteDeleteMutationVariables>(StudentNoteDeleteDocument, options);
      }
export type NoteDeleteMutationHookResult = ReturnType<typeof useNoteDeleteMutation>;
export type NoteDeleteMutationResult = Apollo.MutationResult<StudentNoteDeleteMutation>;
export type NoteDeleteMutationOptions = Apollo.BaseMutationOptions<StudentNoteDeleteMutation, StudentNoteDeleteMutationVariables>;
export const StudentNoteInsertDocument = gql`
    mutation NoteInsert($section_id: uuid!, $body: String!) {
  insert_chapter_section_notes_one(
    object: {body: $body, chapter_section_id: $section_id}
  ) {
    ...Note
  }
}
    ${StudentNoteFragmentDoc}`;
export type StudentNoteInsertMutationFn = Apollo.MutationFunction<StudentNoteInsertMutation, StudentNoteInsertMutationVariables>;

/**
 * __useNoteInsertMutation__
 *
 * To run a mutation, you first call `useNoteInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteInsertMutation, { data, loading, error }] = useNoteInsertMutation({
 *   variables: {
 *      section_id: // value for 'section_id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useNoteInsertMutation(baseOptions?: Apollo.MutationHookOptions<StudentNoteInsertMutation, StudentNoteInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentNoteInsertMutation, StudentNoteInsertMutationVariables>(StudentNoteInsertDocument, options);
      }
export type NoteInsertMutationHookResult = ReturnType<typeof useNoteInsertMutation>;
export type NoteInsertMutationResult = Apollo.MutationResult<StudentNoteInsertMutation>;
export type NoteInsertMutationOptions = Apollo.BaseMutationOptions<StudentNoteInsertMutation, StudentNoteInsertMutationVariables>;
export const StudentGetGradesForStudentDocument = gql`
    query GetGradesForStudent($studentId: uuid = "") {
  view_grades_for_students(where: {user_id: {_eq: $studentId}}) {
    id
    comment
    mark_id
    mark {
      name
      value
    }
    assignment {
      title
      id
      due_at
      type
    }
    subject {
      id
      name
      teacher_subjects {
        teacher {
          user {
            full_name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetGradesForStudentQuery__
 *
 * To run a query within a React component, call `useGetGradesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradesForStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetGradesForStudentQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetGradesForStudentQuery, StudentGetGradesForStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetGradesForStudentQuery, StudentGetGradesForStudentQueryVariables>(StudentGetGradesForStudentDocument, options);
      }
export function useGetGradesForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetGradesForStudentQuery, StudentGetGradesForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetGradesForStudentQuery, StudentGetGradesForStudentQueryVariables>(StudentGetGradesForStudentDocument, options);
        }
export type GetGradesForStudentQueryHookResult = ReturnType<typeof useGetGradesForStudentQuery>;
export type GetGradesForStudentLazyQueryHookResult = ReturnType<typeof useGetGradesForStudentLazyQuery>;
export type GetGradesForStudentQueryResult = Apollo.QueryResult<StudentGetGradesForStudentQuery, StudentGetGradesForStudentQueryVariables>;
export const StudentStudentGetMyLiveClassByMyIdDocument = gql`
    query StudentGetMyLiveClassByMyId($user_id: uuid!) {
  live_classes(where: {live_class_attendees: {user_id: {_eq: $user_id}}}) {
    id
    attendeePW
    description
    status
    starting_at
    name
    duration
  }
}
    `;

/**
 * __useStudentGetMyLiveClassByMyIdQuery__
 *
 * To run a query within a React component, call `useStudentGetMyLiveClassByMyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentGetMyLiveClassByMyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentGetMyLiveClassByMyIdQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useStudentGetMyLiveClassByMyIdQuery(baseOptions: Apollo.QueryHookOptions<StudentStudentGetMyLiveClassByMyIdQuery, StudentStudentGetMyLiveClassByMyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentStudentGetMyLiveClassByMyIdQuery, StudentStudentGetMyLiveClassByMyIdQueryVariables>(StudentStudentGetMyLiveClassByMyIdDocument, options);
      }
export function useStudentGetMyLiveClassByMyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentStudentGetMyLiveClassByMyIdQuery, StudentStudentGetMyLiveClassByMyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentStudentGetMyLiveClassByMyIdQuery, StudentStudentGetMyLiveClassByMyIdQueryVariables>(StudentStudentGetMyLiveClassByMyIdDocument, options);
        }
export type StudentGetMyLiveClassByMyIdQueryHookResult = ReturnType<typeof useStudentGetMyLiveClassByMyIdQuery>;
export type StudentGetMyLiveClassByMyIdLazyQueryHookResult = ReturnType<typeof useStudentGetMyLiveClassByMyIdLazyQuery>;
export type StudentGetMyLiveClassByMyIdQueryResult = Apollo.QueryResult<StudentStudentGetMyLiveClassByMyIdQuery, StudentStudentGetMyLiveClassByMyIdQueryVariables>;
export const StudentStudentJoinLiveClassDocument = gql`
    mutation StudentJoinLiveClass($name: String!, $lesson_id: String) {
  studentJoin(meeting_id: $lesson_id, name: $name) {
    url
    id
  }
}
    `;
export type StudentStudentJoinLiveClassMutationFn = Apollo.MutationFunction<StudentStudentJoinLiveClassMutation, StudentStudentJoinLiveClassMutationVariables>;

/**
 * __useStudentJoinLiveClassMutation__
 *
 * To run a mutation, you first call `useStudentJoinLiveClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentJoinLiveClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentJoinLiveClassMutation, { data, loading, error }] = useStudentJoinLiveClassMutation({
 *   variables: {
 *      name: // value for 'name'
 *      lesson_id: // value for 'lesson_id'
 *   },
 * });
 */
export function useStudentJoinLiveClassMutation(baseOptions?: Apollo.MutationHookOptions<StudentStudentJoinLiveClassMutation, StudentStudentJoinLiveClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentStudentJoinLiveClassMutation, StudentStudentJoinLiveClassMutationVariables>(StudentStudentJoinLiveClassDocument, options);
      }
export type StudentJoinLiveClassMutationHookResult = ReturnType<typeof useStudentJoinLiveClassMutation>;
export type StudentJoinLiveClassMutationResult = Apollo.MutationResult<StudentStudentJoinLiveClassMutation>;
export type StudentJoinLiveClassMutationOptions = Apollo.BaseMutationOptions<StudentStudentJoinLiveClassMutation, StudentStudentJoinLiveClassMutationVariables>;
export const StudentGetAllMyLeafsOnlyIdDocument = gql`
    query GetAllMyLeafsOnlyID($teaching_structure_id: uuid = "") {
  teaching_structure_leafs(args: {leaf_id: $teaching_structure_id}) {
    id
  }
}
    `;

/**
 * __useGetAllMyLeafsOnlyIdQuery__
 *
 * To run a query within a React component, call `useGetAllMyLeafsOnlyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyLeafsOnlyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyLeafsOnlyIdQuery({
 *   variables: {
 *      teaching_structure_id: // value for 'teaching_structure_id'
 *   },
 * });
 */
export function useGetAllMyLeafsOnlyIdQuery(baseOptions?: Apollo.QueryHookOptions<StudentGetAllMyLeafsOnlyIdQuery, StudentGetAllMyLeafsOnlyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGetAllMyLeafsOnlyIdQuery, StudentGetAllMyLeafsOnlyIdQueryVariables>(StudentGetAllMyLeafsOnlyIdDocument, options);
      }
export function useGetAllMyLeafsOnlyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGetAllMyLeafsOnlyIdQuery, StudentGetAllMyLeafsOnlyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGetAllMyLeafsOnlyIdQuery, StudentGetAllMyLeafsOnlyIdQueryVariables>(StudentGetAllMyLeafsOnlyIdDocument, options);
        }
export type GetAllMyLeafsOnlyIdQueryHookResult = ReturnType<typeof useGetAllMyLeafsOnlyIdQuery>;
export type GetAllMyLeafsOnlyIdLazyQueryHookResult = ReturnType<typeof useGetAllMyLeafsOnlyIdLazyQuery>;
export type GetAllMyLeafsOnlyIdQueryResult = Apollo.QueryResult<StudentGetAllMyLeafsOnlyIdQuery, StudentGetAllMyLeafsOnlyIdQueryVariables>;